<template>
  <div id="mapApp">
    <div class="mapTop">
        <div class="title">
            沛县智慧人武电子沙盘
            <template>
                <!-- <i class="el-icon-video-pause" @click="PauseAnimation" v-if="animationPaly==true"></i> -->
                <!-- <i class="el-icon-video-play" @click="StartAnimation"></i> -->
                <i class="el-icon-s-home" @click="ResetMap"></i>
                <!-- <i class="el-icon-circle-close" @click="CleanMap"></i> -->
                <i :class="zoomMap?'el-icon-s-fold':'el-icon-s-unfold'" @click="ZoomMap"></i>
            </template>
        </div>
        <div id="baseMap">
            <el-radio-group v-model="baseMap" @change="SetBaseMap">
                <el-radio label="satellite">卫星影像</el-radio>
                <el-radio label="vector">三维矢量</el-radio>
                <el-radio label="traffic">实时路况</el-radio>
            </el-radio-group>
        </div>
    </div>
    <transition name="el-fade-in-linear">
        <div :class="zoomMap?'mapLeftPart':'mapLeftPart unZoomMap'" v-show="dataShow&&zoomMap">
            <div v-show="zoomMap">
                <el-tabs tab-position="left" :stretch="true" style="height: calc(100% - 20px);" class="leftTabs" @tab-click="TabClick">
                    <el-tab-pane label="总览" class="blueTabs">
                        <div slot="label" class="infoTitle">总览</div>
                        <el-scrollbar style="height:100%">
                            <div>
                                <el-row :gutter="10">
                                    <el-col :span="12" v-for="item in object" :key="'object_'+item.name">
                                        <div class="sumCard">
                                            <div style="word-break: keep-all;overflow: hidden;">{{item.name}}</div>
                                            <div class="sumCardVal">{{item.value}}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-scrollbar>
                    </el-tab-pane>
                    <el-tab-pane label="路网信息" class="blueTabs">
                        <div slot="label" class="infoTitle">路网信息</div>
                        <el-scrollbar style="height:100%">
                            <div>
                                <el-row :gutter="10">
                                    <el-col :span="12" v-for="item in road" :key="'road_'+item.name">
                                        <div class="roadCard" @click="Driving(item)" :style="BackgroundColor(item.type,'card')">
                                            <el-row :gutter="10">
                                                <el-col :span="18">
                                                    <div class="roadCardName">{{item.name}}</div>
                                                </el-col>
                                                <el-col :span="6" style="text-align: right;">
                                                    <span class="roadType" :style="BackgroundColor(item.type,'tag')">{{item.type}}</span>
                                                </el-col>
                                            </el-row>
                                            <div class="roadCardVal">
                                                {{item.kilometer}}
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-scrollbar>
                    </el-tab-pane>
                    <el-tab-pane label="航道信息" class="blueTabs">
                        <div slot="label" class="infoTitle">航道信息</div>
                        <el-scrollbar style="height:100%">
                            <div>
                                <el-row :gutter="10">
                                    <el-col :span="12" v-for="item in channel"  :key="item.name+'_'+item.start+'_'+item.end">
                                        <div class="sumCard">
                                            <div>{{item.name}}</div>
                                            <div class="sumCardVal">{{item.kilometer}}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-scrollbar>
                    </el-tab-pane>
                    <el-tab-pane label="快速响应" class="blueTabs">
                        <div slot="label" class="infoTitle">快速响应</div>
                        <el-scrollbar style="height:100%">
                            <div>
                                <el-form ref="form" :model="simulation.form" name-position="top">
                                    <el-form-item name="出发地">
                                        <div class="sumCard" style="border-color: #8bc34a;">
                                            <div style="margin-bottom:5px">出发地</div>
                                            <div>
                                                <el-row :gutter="10">
                                                    <el-col :span="24" style="margin-bottom:20px">
                                                        <el-select 
                                                        style="width:100%"
                                                        v-model="simulation.form.start.type"
                                                        @change="ChangeSimulationType('start')">
                                                            <el-option label="选择" value="select"></el-option>
                                                            <el-option label="输入" value="search"></el-option>
                                                        </el-select>
                                                    </el-col>
                                                    <el-col :span="24" v-if="simulation.form.start.type=='select'">
                                                        <el-cascader
                                                        style="width:100%"
                                                        placeholder="请选择出发地"
                                                        v-model="simulation.form.start.value"
                                                        :props="{ value:'guid',label:'name',children:'records' }"
                                                        :options="pointerData">
                                                        </el-cascader>
                                                    </el-col>
                                                    <el-col :span="24" v-if="simulation.form.start.type=='search'">
                                                        <el-select
                                                        style="width:100%"
                                                        v-model="simulation.form.start.value"
                                                        filterable
                                                        remote
                                                        placeholder="请输入出发地"
                                                        :remote-method="SearchPointStart"
                                                        :loading="simulation.form.start.loading">
                                                            <el-option
                                                            v-for="item in simulation.searchResult.start"
                                                            :key="item.id"
                                                            :label="item.title"
                                                            :value="item.location">
                                                            </el-option>
                                                        </el-select>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        
                                    </el-form-item>
                                    <el-form-item name="目的地">
                                        <div class="sumCard" style="border-color: #f44336;">
                                            <div style="margin-bottom:5px">目的地</div>
                                            <div>
                                                <el-row :gutter="10">
                                                    <el-col :span="24" style="margin-bottom:20px">
                                                        <el-select 
                                                        style="width:100%"
                                                        v-model="simulation.form.end.type"
                                                        @change="ChangeSimulationType('end')">
                                                            <el-option label="选择" value="select"></el-option>
                                                            <el-option label="输入" value="search"></el-option>
                                                        </el-select>
                                                    </el-col>
                                                    <el-col :span="24" v-if="simulation.form.end.type=='select'">
                                                        <el-cascader
                                                        style="width:100%"
                                                        placeholder="请选择目的地"
                                                        v-model="simulation.form.end.value"
                                                        :props="{ value:'guid',label:'name',children:'records' }"
                                                        :options="pointerData">
                                                        </el-cascader>
                                                    </el-col>
                                                    <el-col :span="24" v-if="simulation.form.end.type=='search'">
                                                        <el-select
                                                        style="width:100%"
                                                        v-model="simulation.form.end.value"
                                                        filterable
                                                        remote
                                                        placeholder="请输入目的地"
                                                        :remote-method="SearchPointEnd"
                                                        :loading="simulation.form.end.loading">
                                                            <el-option
                                                            v-for="item in simulation.searchResult.end"
                                                            :key="item.id"
                                                            :label="item.title"
                                                            :value="item.location">
                                                            </el-option>
                                                        </el-select>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                    </el-form-item>
                                </el-form>
                                <div class="sumCard" @click="SimulationRoad" style="text-align: center;cursor: pointer;border-left: none;background-image: linear-gradient(287deg, #40ffb8, #22835b);">
                                    <i class="el-icon-s-opportunity"></i>快速响应
                                </div>
                            </div>
                        </el-scrollbar>
                    </el-tab-pane>
                    <el-tab-pane label="紧急动员" class="blueTabs">
                        <div slot="label" class="infoTitle">紧急动员</div>
                        <el-scrollbar style="height:100%">
                            <div>
                                <div class="sumCard" @click="PersonJob" style="text-align: center;cursor: pointer;border-left: none;background-image: linear-gradient(287deg, #40ffb8, #22835b);">
                                    <i class="el-icon-s-opportunity"></i>紧急动员
                                </div>
                                <div class="sumCard" @click="AddPerson" style="text-align: center;cursor: pointer;border-left: none;">
                                    <i class="el-icon-circle-plus"></i>点击添加专业人员
                                </div>
                                <div class="sumCard" v-for="(e,i) in simulation.table" :key="'simulationTable_'+i+'_'+e.id">
                                    <el-row :gutter="10">
                                        <el-col :span="20">
                                            <div>
                                                <el-select v-model="e.id" style="width:100%" filterable placeholder="请选择所需技能">
                                                    <el-option
                                                        v-for="item in simulation.skillOptions"
                                                        :key="'skillOptions_'+item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                        <span style="float: left">{{ item.name }}</span>
                                                        <span style="float: right">{{ item.number }}</span>
                                                    </el-option>
                                                </el-select>
                                            </div>
                                            <div class="sumCardVal">
                                                <el-input style="width:100%" v-model.number="e.number" placeholder="请输入所需人数"></el-input>
                                            </div>
                                        </el-col>
                                        <el-col :span="4">
                                            <el-button size="mini" class="delBtnRed" @click="DeletePerson(i)">
                                                <i class="el-icon-remove-outline"></i>
                                            </el-button>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                        </el-scrollbar>
                    </el-tab-pane>
                    <el-tab-pane label="关键目标" class="blueTabs">
                        <div slot="label" class="infoTitle">关键目标</div>
                        <div class="pointerData">
                            <el-collapse v-model="pointerActive" accordion>
                                <el-collapse-item name="pointerDataShow" title="类型显示控制">
                                    <el-scrollbar :style="{height: pointerDataHeight}">
                                        <el-checkbox-group v-model="pointerDataShow" @change="ChangePointerDataShow">
                                            <div v-for="item in pointerData" :key="'checkbox_'+item.guid" class="pointerCard" style="padding: 0px;">
                                                <el-checkbox style="width: calc(100% - 40px);padding: 20px;" :label="item.guid">{{item.name}}</el-checkbox>
                                            </div>
                                        </el-checkbox-group>
                                    </el-scrollbar>
                                </el-collapse-item>
                                <template v-for="item in pointerData">
                                    <el-collapse-item v-if="item.records!=undefined" :title="item.name + ' （'+item.records.length+'）'" :name="item.guid" :key="item.guid">
                                        <el-scrollbar :style="{height: pointerDataHeight}">
                                            <div v-for="point in item.records" :key="point.guid" class="pointerCard">
                                                <div>{{point.name}}</div>
                                                <div>{{point.address}}</div>
                                                <div>道路距离 {{(point.roadDistance*1/1000).toFixed(2)}} km</div>
                                                <div>直线距离 {{(point.straightDistance*1/1000).toFixed(2)}} km</div>
                                                <div>{{point.remark}}</div>
                                                <div>
                                                    <el-button type="text" @click="GoPointer(point)"><i class="el-icon-s-promotion"></i>定位</el-button>
                                                    <el-button type="text" @click="PointDetail(point)"><i class="el-icon-s-data"></i>详情</el-button>
                                                </div>
                                            </div>
                                        </el-scrollbar>
                                    </el-collapse-item>
                                </template>
                            </el-collapse>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </transition>
    <transition name="el-zoom-in-center">
        <div v-show="zoomMap">
            <transition name="el-fade-in-linear">
                <div class="mapRightPart" v-show="showDetailCard == 'driving'">
                    <div v-if="showDetailCard == 'driving'" class="aimulationArea">
                        <div class="aimulationPoint">
                            <div class="name">出发地</div>
                            <div class="value">
                                {{PointerLabel('start')}}
                            </div>
                        </div>
                        <div class="aimulationPoint">
                            <div class="name">目的地</div>
                            <div class="value">
                                {{PointerLabel('end')}}
                            </div>
                        </div>
                        <div class="aimulationPoint">
                            <div class="name">距离</div>
                            <div class="value">{{((simulation.result.distance)/1000).toFixed(2)}} 公里</div>
                        </div>
                        <div class="aimulationPoint">
                            <div class="name">预计抵达时间</div>
                            <div class="value">{{simulation.result.duration}} 分钟</div>
                        </div>
                        <div class="aimulationPoint">
                            <div class="name">方案指引</div>
                            <el-steps direction="vertical" :active="1" :space="10">
                                <el-step v-for="(item,index) in simulation.result.steps" :key="'simulation_'+index" :description="item.instruction+' '+item.accessorial_desc"></el-step>
                            </el-steps>
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="el-zoom-in-center">
                <div class="mapRightPart" v-show="showDetailCard == 'personJob'">
                    <el-tabs v-model="skillResult.activeName">
                        <el-tab-pane 
                            v-for="(item,index) in skillResult.data" 
                            :key="'skillResult_'+index" 
                            :label="simulation.skillOptions.find(e=>e.id==item.query.id).name + '(' + item.query.number + ')'" 
                            :name="'skill_'+item.query.id">
                                <el-table
                                    :data="item.result"
                                    height="calc(100vh - 110px)"
                                    min-height="calc(100vh - 110px)"
                                    border
                                    size="mini"
                                    style="width: 100%">
                                    <el-table-column label="姓名">
                                        <template slot-scope="{row}">
                                            {{row['人信息'].name}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="身份证号">
                                        <template slot-scope="{row}">
                                            {{row['人信息'].IDCard.slice(0,6)}}******{{row['人信息'].IDCard.slice(12,18)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="性别">
                                        <template slot-scope="{row}">
                                            {{row['人信息'].sex}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="出生年月">
                                        <template slot-scope="{row}">
                                            {{row['人信息'].birthday}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="机构">
                                        <template slot-scope="{row}">
                                            {{row['技能信息'].agency}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="技能等级">
                                        <template slot-scope="{row}">
                                            {{row['技能信息'].skillLevel}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="状态">
                                        <template slot-scope="{row}">
                                            {{row['技能信息'].ocard}}
                                            {{row['技能信息'].oemploy}}
                                            {{row['技能信息'].ojob}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="详情">
                                        <template slot-scope="{row}">
                                            <el-popover placement="right" width="400" trigger="click">
                                                <div>
                                                    <el-descriptions title="详细信息" :column="2" size="mini" border>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="姓名">{{row['人信息'].name}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="生日">{{row['人信息'].birthday}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="统计">{{row['人信息'].census}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="身份证">{{row['人信息'].IDCard}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="入伍日期">{{row['人信息'].inArmyTime}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="服役时间">{{row['人信息'].inPartyTime}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="退伍日期">{{row['人信息'].outArmyTime}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="是否党政机关工作人员">{{row['人信息'].isStaff}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="是否是在校大学生">{{row['人信息'].isStu}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="工作">{{row['人信息'].job}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="电话">{{row['人信息'].phone}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="性别">{{row['人信息'].sex}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="更新时间">{{row['人信息'].updateTime}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="工作场所">{{row['人信息'].workPlace}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="工作单元">{{row['人信息'].workUnit}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="机构">{{row['人信息'].agency}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="机构代码">{{row['人信息'].agencyCode}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="文件号">{{row['人信息'].fileNumber}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="区域">{{row['人信息'].region}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="技能水平">{{row['人信息'].skillLevel}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="技能名称">{{row['人信息'].skillName}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="起始日期">{{row['人信息'].startDate}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="单位">{{row['人信息'].unit}}</el-descriptions-item>
                                                        <el-descriptions-item label-class-name="descriptionsLabelStyle" label="有效日期">{{row['人信息'].validityDate}}</el-descriptions-item>
                                                    </el-descriptions>
                                                </div>
                                                <i slot="reference" class="el-icon-search"></i>
                                            </el-popover>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            
                            </el-tab-pane>
                    </el-tabs>
                </div>
            </transition>
        </div>
    </transition>
    <transition name="el-zoom-in-center">
        <div id="mapCover" v-show="!mapShow"></div>
    </transition>
    <el-dialog
        :title="pointDetailInfo?pointDetailInfo.name:''"
        :visible.sync="pointDetailInfoShow"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="PointDetailInfoHide">
        <div v-if="pointDetailInfo">
            <el-descriptions title="目标信息" :column="2" border :colon="false" :labelStyle="{
                'color': 'white',
                'background': 'unset',
                'font-weight': 'bolder',
            }">
                <el-descriptions-item label="目标名称">{{pointDetailInfo.name}}</el-descriptions-item>
                <el-descriptions-item label="目标位置">{{pointDetailInfo.address}}</el-descriptions-item>
                <el-descriptions-item label="道路距离">{{(pointDetailInfo.roadDistance*1/1000).toFixed(2)}} km</el-descriptions-item>
                <el-descriptions-item label="直线距离">{{(pointDetailInfo.straightDistance*1/1000).toFixed(2)}} km</el-descriptions-item>
                <el-descriptions-item label="基础信息">{{pointDetailInfo.remark}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions style="margin-top:20px" v-if="pointDetailInfo.detailArr && pointDetailInfo.detailArr.length>0" title="额外信息" :column="2" border :colon="false" :labelStyle="{
                'color': 'white',
                'background': 'unset',
                'font-weight': 'bolder',
            }">
                <el-descriptions-item :label="item.name" v-for="item in pointDetailInfo.detailArr" :key="'pointDetailInfo'+'_'+item.name+'_'+item.value">{{item.value}}</el-descriptions-item>
            </el-descriptions>
        </div>
        <div slot="footer">
            <el-button @click="pointDetailInfoShow = false">取 消</el-button>
            <el-button type="primary" @click="pointDetailInfoShow = false">确 定</el-button>
        </div>
    </el-dialog>
    <div id='mapContainer' :class="imageType?'ex':''"></div>
  </div>
</template>

<script>
const jsonp = require('jsonp');
export default {
    data(){
        return {
            zoomMap:true,
            baseMap:'satellite',
            dataShow:false,
            mapShow:false,
            imageType:false,
            key:'DFQBZ-RKHW6-QFOSK-MFZZ2-U3QJJ-DOFBM',
            mine:null,
            venueList:[],
            map:null,
            center: new this.$Map.LatLng(34.736104,116.930169),
            zoom:10,
            rotation:0,
            pitch:0,
            animationPaly:true,
            road:[],
            channel:[],
            object:[],
            polylineLayer:null,
            showDetailCard:null,
            simulation:{
                visible:false,
                form:{
                    start:{
                        value:'',
                        loading:false,
                        type:'search'
                    },
                    end:{
                        value:'',
                        loading:false,
                        type:'search'
                    }
                },
                searchResult:{
                    start:[],
                    end:[]
                },
                skillOptions:[],
                table:[],
            },
            skillResult:{
                visible:false,
                activeName:'',
                data:[]
            },
            centerImg:require('@/assets/star.png'),
            pointerActive:'pointerDataShow',
            pointerData:[],
            pointerDataHeight:null,
            pointerDataShow:[],
            pointerDataMap:{},
            pointDetailInfo:[],
            pointDetailInfoShow:false,
        }
    },
    methods:{
        GetData(){
            let self = this;
            self.$axios.get(`/api/way/get`).then(res => { self.road = res.records })
            self.$axios.get(`/api/channel/get`).then(res => { self.channel = res.records })
            self.InitMap();
            self.$axios.get(`/api/count/get`).then(res => { 
                let ids = Object.keys(res).toString()
                self.$axios.get(`/api/count/list?ids=${ids}`)
                .then(res2 => {
                    let object = [];
                    res2.records.forEach(e=>{
                        let aim = object.find(r=>r.name==e.name);
                        if(aim){
                            aim.value+=e.number
                        }else{
                            object.push({name:e.name,value:e.number})
                        }
                    })
                    self.object = object
                })
            });
            self.$axios.get(`/api/skill/get?pageSize=999`).then(res => {
                const idArr = res.records.map(e=>e.id);
                self.$axios.get(`/api/person-job/list/skillList?ids=${idArr.toString()}`)
                .then(res2 => {
                    self.simulation.skillOptions = res2;
                })
            })
            self.Pointer()
        },
        InitMap() {
            let self = this;
            let drawContainer = document.getElementById('mapContainer');
            self.map = new self.$Map.Map(drawContainer, {
                zoom: self.zoom,
                minZoom:self.zoom,
                maxZoom:self.zoom*2,
                scrollable:true,
                pitch: self.pitch,
                center: self.center,
                draggable: true,
                // viewMode:'3D',
                rotation:self.rotation,
                mapStyleId: 'style1',
                renderOptions: {
                    enableBloom: false, //泛光
                    fogOptions: {
                        color:'rgb(3,11,28)'
                    }
                },
                baseMap: [{ type: "satellite" }],
            }).removeControl("floor").removeControl("rotation").removeControl("scale").removeControl("zoom");
            // 中心点
            new self.$Map.MultiMarker({
                map: self.map,  //指定地图容器
                //样式定义
                styles: {
                    default: new self.$Map.MarkerStyle({ 
                        width: 64/2,  // 点标记样式宽度（像素）
                        height: 64/2, // 点标记样式高度（像素）
                        src: self.centerImg,  //图片路径
                        anchor: { x: 16, y: 32 }  
                    }) 
                },
                geometries: [{
                    id: "mine",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                    position: self.center,  //点标记坐标位置
                    properties: {//自定义属性
                        "title": "mine"
                    }
                }]
            });
            self.InitMap_Town();
            // self.StartAnimation()
            document.querySelectorAll('a[href="http://map.qq.com?ref=jsapi_v3"]')[0].parentNode.parentNode.remove()
        },
        InitMap_Town(){
            let self = this;
            const areaData = [
                {
                    "path": [
                        34.69375876724076,
                        116.85178917012317,
                        34.69413475766442,
                        116.84819317002335,
                        34.69463574518112,
                        116.8455931698083,
                        34.69502873616556,
                        116.84277716968315,
                        34.69594971345337,
                        116.83980616974735,
                        34.6974136767223,
                        116.83671116996297,
                        34.69754367344241,
                        116.83407216938988,
                        34.697719669290066,
                        116.83050717015051,
                        34.69887864065365,
                        116.82199517020106,
                        34.699057636626165,
                        116.82068217012389,
                        34.700178608938344,
                        116.81483216941541,
                        34.70023160752742,
                        116.81455416958111,
                        34.702144560553336,
                        116.81226516971061,
                        34.702108561089965,
                        116.80598217025545,
                        34.70191356632984,
                        116.80225116953815,
                        34.70165057245812,
                        116.80179516942856,
                        34.70402651398491,
                        116.79815817021917,
                        34.7057214721893,
                        116.79818917018133,
                        34.71353827947078,
                        116.79833016974841,
                        34.7139002704092,
                        116.80338717006343,
                        34.71939413452309,
                        116.80338717006349,
                        34.72093409713799,
                        116.80338816988841,
                        34.72163507947138,
                        116.8100631698791,
                        34.72287904884396,
                        116.8100551694832,
                        34.73479175535672,
                        116.80997917021367,
                        34.733999774592256,
                        116.80659917002387,
                        34.734840754151286,
                        116.80536916978741,
                        34.73642671466856,
                        116.80304916995487,
                        34.73617072110492,
                        116.80141717003546,
                        34.735523737173196,
                        116.79728117016049,
                        34.73347678725252,
                        116.79532016945477,
                        34.73447576313605,
                        116.7934451698611,
                        34.73544973864957,
                        116.78929616956738,
                        34.74007262493905,
                        116.78094116997677,
                        34.74237756788549,
                        116.78261817010208,
                        34.74727044731513,
                        116.78767816989183,
                        34.74892240635781,
                        116.78856016997379,
                        34.75179433536613,
                        116.79009416998393,
                        34.75328929872883,
                        116.78918517013781,
                        34.75632622396861,
                        116.78733817013335,
                        34.759372148319045,
                        116.78875917016549,
                        34.76303705779248,
                        116.78616016977546,
                        34.763619043714165,
                        116.78574717022192,
                        34.76220307873391,
                        116.7781861699513,
                        34.76714095687243,
                        116.774430170018,
                        34.76736095131055,
                        116.77426216978851,
                        34.773766793377845,
                        116.77668016953045,
                        34.775016762644135,
                        116.77995017011531,
                        34.779743645343814,
                        116.78049116971546,
                        34.78195759115607,
                        116.79199217004245,
                        34.7820355889853,
                        116.79239916974822,
                        34.78755945234293,
                        116.79302516973723,
                        34.78817643717668,
                        116.79600816936858,
                        34.789849396442456,
                        116.80410616993964,
                        34.787367457566965,
                        116.8064341701681,
                        34.78795144315753,
                        116.81450116987871,
                        34.788498429917965,
                        116.81463516977298,
                        34.79762420426616,
                        116.81686316954415,
                        34.79660922926444,
                        116.82353616988497,
                        34.79558525449291,
                        116.83423116939971,
                        34.7954412578737,
                        116.83573616999578,
                        34.7939072963596,
                        116.83477816974585,
                        34.79003439178323,
                        116.83551716971263,
                        34.789799397528775,
                        116.83904816951505,
                        34.78465352426878,
                        116.83834316988342,
                        34.78496151722275,
                        116.84280616999658,
                        34.785337507512594,
                        116.84827116984222,
                        34.794987269168686,
                        116.8470911698346,
                        34.79690522207595,
                        116.8527661697426,
                        34.80047713371249,
                        116.86333116956096,
                        34.80028313897129,
                        116.86527116945194,
                        34.7972132142975,
                        116.86555017000953,
                        34.79712321701632,
                        116.86579316968373,
                        34.79669622707501,
                        116.86620316976251,
                        34.7967412263339,
                        116.86761016955107,
                        34.79513626599846,
                        116.86779617022223,
                        34.79526226269021,
                        116.86649317019075,
                        34.79478927430011,
                        116.86656216978773,
                        34.794741275234124,
                        116.86580716992738,
                        34.79306031735149,
                        116.86652016995491,
                        34.79296831928041,
                        116.86584816993528,
                        34.7921263404102,
                        116.86594116982165,
                        34.79187634606446,
                        116.86538716980277,
                        34.79081137271841,
                        116.86543316983357,
                        34.79044538160395,
                        116.86768516989407,
                        34.79014838891609,
                        116.86783016965903,
                        34.79003839189913,
                        116.86782516963613,
                        34.79009339042483,
                        116.86740416968667,
                        34.789853395911585,
                        116.86668817018439,
                        34.78950840488359,
                        116.86672016997137,
                        34.78946740542391,
                        116.86587916989737,
                        34.78726445987014,
                        116.86610216948011,
                        34.78729945944225,
                        116.86571116966788,
                        34.78479352107653,
                        116.86590317018674,
                        34.78517251195001,
                        116.86709417006519,
                        34.78406253958839,
                        116.86745616956509,
                        34.78416553701989,
                        116.86800717010925,
                        34.78244657894133,
                        116.86841217016519,
                        34.78258457553842,
                        116.86929216969898,
                        34.78278857082293,
                        116.87054916969969,
                        34.78247957815414,
                        116.87067017007345,
                        34.78216058625387,
                        116.87079616957188,
                        34.78225358357052,
                        116.87135416978869,
                        34.780759620611164,
                        116.87203616985403,
                        34.78094761632113,
                        116.87381416936337,
                        34.778499676520354,
                        116.87425316975445,
                        34.77882366890629,
                        116.87508816998073,
                        34.777432702795906,
                        116.87542316971648,
                        34.77651672536789,
                        116.87556616983157,
                        34.77635472922858,
                        116.87401517010304,
                        34.77541975293612,
                        116.87416816936557,
                        34.7749297644716,
                        116.87424816973153,
                        34.774972763419804,
                        116.87501716983559,
                        34.77338580308695,
                        116.87519216973773,
                        34.77336980343105,
                        116.87506717006427,
                        34.772310829342864,
                        116.87542316971641,
                        34.77228083005593,
                        116.87517417019441,
                        34.771849840459616,
                        116.87525816985998,
                        34.77183684081981,
                        116.87495216953819,
                        34.7695068986184,
                        116.87535216957124,
                        34.76861192034802,
                        116.87151316979723,
                        34.76837592640649,
                        116.87161516990447,
                        34.76731195285968,
                        116.86767917004597,
                        34.76679096597231,
                        116.86785216940002,
                        34.76658297055816,
                        116.86698816975975,
                        34.76464701832313,
                        116.86744217021953,
                        34.764775015723586,
                        116.86681717005553,
                        34.763101056510514,
                        116.86737516937403,
                        34.76289006222945,
                        116.86667817013827,
                        34.7619090863945,
                        116.86697716988911,
                        34.76175309025116,
                        116.86629817019671,
                        34.759968133757845,
                        116.86676517017693,
                        34.75859016817671,
                        116.86711116978333,
                        34.7573071999272,
                        116.86542816981027,
                        34.75786018631222,
                        116.86371616952496,
                        34.75538624728104,
                        116.86292616950445,
                        34.75490325915734,
                        116.86227816977427,
                        34.75236032172609,
                        116.86402316967155,
                        34.751599340632886,
                        116.8657791694395,
                        34.74919139998923,
                        116.86502117010437,
                        34.74868141246606,
                        116.86076317003067,
                        34.746670462248865,
                        116.85916117024847,
                        34.74618847425469,
                        116.85903317020197,
                        34.74408652612379,
                        116.85847516998508,
                        34.743032551678745,
                        116.8581951696026,
                        34.741860580520594,
                        116.8621011702221,
                        34.73590872739556,
                        116.87208816973208,
                        34.73423876897662,
                        116.8716241701249,
                        34.733596784828094,
                        116.87143716962879,
                        34.73268580696584,
                        116.86440517016102,
                        34.73036986433531,
                        116.8625121701257,
                        34.72966488151368,
                        116.86193616946723,
                        34.72735493857817,
                        116.8624071696454,
                        34.7249169991197,
                        116.86762016959591,
                        34.72346403496689,
                        116.86889316949008,
                        34.72217506625549,
                        116.8687441695272,
                        34.72219806575906,
                        116.8686541700138,
                        34.71623021316693,
                        116.86757916958798,
                        34.71232630940552,
                        116.86687716943102,
                        34.71139833230004,
                        116.87016416973434,
                        34.70749942816522,
                        116.87507116936312,
                        34.70707143922839,
                        116.88625316984785,
                        34.707037439522225,
                        116.88712817025716,
                        34.70617846075708,
                        116.88755816952913,
                        34.70191156589481,
                        116.88969716961165,
                        34.69707868538219,
                        116.89012216975905,
                        34.68863589362028,
                        116.89085817025101,
                        34.68854089624508,
                        116.88448816985886,
                        34.68759791910736,
                        116.87810716959608,
                        34.688408899133236,
                        116.87758816973731,
                        34.68891088672056,
                        116.87726717024523,
                        34.68950387231719,
                        116.87398316941668,
                        34.68950787203575,
                        116.87057616946275,
                        34.68904788359549,
                        116.86670516990159,
                        34.688645893344,
                        116.86515716964777,
                        34.68700393369814,
                        116.86382517020233,
                        34.68596695959527,
                        116.86202917025142,
                        34.686081956408415,
                        116.85747816937645,
                        34.68715293030954,
                        116.85694517017225,
                        34.688597894596356,
                        116.85622516957373,
                        34.691699817849454,
                        116.85695216984499,
                        34.69345577499776,
                        116.8546771702183,
                        34.69375876724076,
                        116.85178917012317
                    ],
                    "name": "朱寨镇"
                },
                {
                    "path": [
                        34.71546623232686,
                        116.92166216940367,
                        34.71127233548583,
                        116.9240861698916,
                        34.71111533912086,
                        116.92146116956214,
                        34.709143387974635,
                        116.92113116984928,
                        34.70926938521913,
                        116.91934016992117,
                        34.70958837736783,
                        116.91936716968539,
                        34.7096383754779,
                        116.91881017019179,
                        34.7098173710688,
                        116.91881416949137,
                        34.709673374724495,
                        116.9172571699151,
                        34.70969337439033,
                        116.9154161697583,
                        34.70991236909906,
                        116.91406517004634,
                        34.70698144121669,
                        116.91370517019618,
                        34.70813941293372,
                        116.90572516962592,
                        34.70638745609619,
                        116.90496116954483,
                        34.704373505677154,
                        116.90461417011345,
                        34.704621499266146,
                        116.90332617015065,
                        34.70557947549561,
                        116.90344716962615,
                        34.70585446919549,
                        116.90182416992761,
                        34.70480849482177,
                        116.90119516956563,
                        34.70429750746965,
                        116.90079516953259,
                        34.705629474532635,
                        116.89586716998731,
                        34.70592046749984,
                        116.89477016982018,
                        34.707832420557985,
                        116.89528717002919,
                        34.70840640637361,
                        116.89305017003734,
                        34.70851740349015,
                        116.89310716993869,
                        34.70871539857625,
                        116.89341917010826,
                        34.709001391621335,
                        116.89199717025113,
                        34.707055439293995,
                        116.89128417022359,
                        34.709058389975546,
                        116.88713016990694,
                        34.71001336617371,
                        116.88736916938329,
                        34.71025636051544,
                        116.88755917025242,
                        34.71159732777049,
                        116.88751817024449,
                        34.71151632957335,
                        116.88789616963797,
                        34.714706250823575,
                        116.88791417007971,
                        34.714867246985165,
                        116.88619416939842,
                        34.71641920870385,
                        116.88704617024146,
                        34.716495206836086,
                        116.88544316973605,
                        34.71762117879736,
                        116.88506016942146,
                        34.719747126642936,
                        116.88489116936707,
                        34.72118809065079,
                        116.88538616983467,
                        34.72320204144132,
                        116.88591416991437,
                        34.724795001632664,
                        116.88638517009257,
                        34.72707694582329,
                        116.88643316977317,
                        34.72910489574792,
                        116.88638017006974,
                        34.73157783457792,
                        116.88660316965255,
                        34.732389814268565,
                        116.88681716991277,
                        34.73223381847331,
                        116.8855451698435,
                        34.73475575629603,
                        116.88453817008813,
                        34.735031749261424,
                        116.88597716966369,
                        34.73689970341062,
                        116.88523716987197,
                        34.7375396871885,
                        116.88504916955101,
                        34.7375866860342,
                        116.88520716973478,
                        34.73788067883224,
                        116.88520716973478,
                        34.73788967904687,
                        116.88506617016778,
                        34.73859066152992,
                        116.88492016967963,
                        34.73854266299289,
                        116.88460017001248,
                        34.73959963640706,
                        116.88432616947777,
                        34.739710633729864,
                        116.8849541700148,
                        34.742591563081874,
                        116.88398016987135,
                        34.74326454644951,
                        116.88440917021678,
                        34.74375853396096,
                        116.88459316944153,
                        34.744677511555764,
                        116.88458116974593,
                        34.74470051070235,
                        116.88424916948493,
                        34.745180498894904,
                        116.88410416971999,
                        34.74511850015457,
                        116.88263517000715,
                        34.74809142716654,
                        116.8817521701004,
                        34.74808642717008,
                        116.88084516990405,
                        34.74947839269978,
                        116.88047816948297,
                        34.749518391972096,
                        116.88156516960439,
                        34.752722313187284,
                        116.88021616954221,
                        34.753293298570334,
                        116.87996416964717,
                        34.75304430473414,
                        116.87902217018907,
                        34.75223732478271,
                        116.87681117013643,
                        34.753456295019944,
                        116.87692616976413,
                        34.754848260091734,
                        116.87670516983121,
                        34.754845260634504,
                        116.87614216959155,
                        34.75515725289412,
                        116.87612917007107,
                        34.75514825308206,
                        116.8753151697612,
                        34.758323174432185,
                        116.87409416974555,
                        34.758004182138734,
                        116.87296916998939,
                        34.75609822948344,
                        116.8735791700847,
                        34.75611222943451,
                        116.87293817002715,
                        34.75785218611055,
                        116.87236616956669,
                        34.75781418724431,
                        116.87222016997679,
                        34.75827617557066,
                        116.8720771698617,
                        34.75873716425173,
                        116.87380417021564,
                        34.759691140720335,
                        116.87364117000905,
                        34.75883916153328,
                        116.87035717007878,
                        34.760621118095614,
                        116.86954117011909,
                        34.759968133757845,
                        116.86676517017693,
                        34.76175309025116,
                        116.86629817019671,
                        34.7619090863945,
                        116.86697716988911,
                        34.76289006222945,
                        116.86667817013827,
                        34.763101056510514,
                        116.86737516937403,
                        34.764775015723586,
                        116.86681717005553,
                        34.76464701832313,
                        116.86744217021953,
                        34.76658297055816,
                        116.86698816975975,
                        34.76679096597231,
                        116.86785216940002,
                        34.76731195285968,
                        116.86767917004597,
                        34.76837592640649,
                        116.87161516990447,
                        34.76861192034802,
                        116.87151316979723,
                        34.7695068986184,
                        116.87535216957124,
                        34.77183684081981,
                        116.87495216953819,
                        34.771849840459616,
                        116.87525816985998,
                        34.77228083005593,
                        116.87517417019441,
                        34.772310829342864,
                        116.87542316971641,
                        34.77336980343105,
                        116.87506717006427,
                        34.77338580308695,
                        116.87519216973773,
                        34.774972763419804,
                        116.87501716983559,
                        34.7749297644716,
                        116.87424816973153,
                        34.77541975293612,
                        116.87416816936557,
                        34.77635472922858,
                        116.87401517010304,
                        34.77651672536789,
                        116.87556616983157,
                        34.777432702795906,
                        116.87542316971648,
                        34.77882366890629,
                        116.87508816998073,
                        34.778499676520354,
                        116.87425316975445,
                        34.78094761632113,
                        116.87381416936337,
                        34.780759620611164,
                        116.87203616985403,
                        34.78225358357052,
                        116.87135416978869,
                        34.78216058625387,
                        116.87079616957188,
                        34.78247957815414,
                        116.87067017007345,
                        34.78278857082293,
                        116.87054916969969,
                        34.78258457553842,
                        116.86929216969898,
                        34.78244657894133,
                        116.86841217016519,
                        34.78416553701989,
                        116.86800717010925,
                        34.78406253958839,
                        116.86745616956509,
                        34.78517251195001,
                        116.86709417006519,
                        34.78479352107653,
                        116.86590317018674,
                        34.78729945944225,
                        116.86571116966788,
                        34.78726445987014,
                        116.86610216948011,
                        34.78946740542391,
                        116.86587916989737,
                        34.78950840488359,
                        116.86672016997137,
                        34.789853395911585,
                        116.86668817018439,
                        34.79009339042483,
                        116.86740416968667,
                        34.79003839189913,
                        116.86782516963613,
                        34.79014838891609,
                        116.86783016965903,
                        34.79044538160395,
                        116.86768516989407,
                        34.79081137271841,
                        116.86543316983357,
                        34.79187634606446,
                        116.86538716980277,
                        34.7921263404102,
                        116.86594116982165,
                        34.79296831928041,
                        116.86584816993528,
                        34.79306031735149,
                        116.86652016995491,
                        34.794741275234124,
                        116.86580716992738,
                        34.79478927430011,
                        116.86656216978773,
                        34.79526226269021,
                        116.86649317019075,
                        34.79513626599846,
                        116.86779617022223,
                        34.7967412263339,
                        116.86761016955107,
                        34.79669622707501,
                        116.86620316976251,
                        34.79712321701632,
                        116.86579316968373,
                        34.7972132142975,
                        116.86555017000953,
                        34.80028313897129,
                        116.86527116945194,
                        34.80047713371249,
                        116.86333116956096,
                        34.80283607583808,
                        116.8627901699609,
                        34.802827076063885,
                        116.86265316969357,
                        34.80613299398286,
                        116.86154416983094,
                        34.80632198956294,
                        116.86260816948777,
                        34.807815952659524,
                        116.86225316966055,
                        34.80803694722231,
                        116.86553116974304,
                        34.80780495311757,
                        116.86555216965947,
                        34.80808694624624,
                        116.86968917025769,
                        34.80823394263692,
                        116.86968316951157,
                        34.80853093509594,
                        116.87316016978565,
                        34.80473602849153,
                        116.87388416968383,
                        34.80520801716694,
                        116.87714017002504,
                        34.80213309329284,
                        116.87811116979537,
                        34.80243008560104,
                        116.87949016999477,
                        34.800394135890784,
                        116.88027216961925,
                        34.801286113886405,
                        116.88410217007085,
                        34.80239908673917,
                        116.88838716990875,
                        34.80407504497703,
                        116.88764316991912,
                        34.806147993831644,
                        116.89491816995941,
                        34.8042570409206,
                        116.8956781698426,
                        34.80452503378953,
                        116.89673116962875,
                        34.80289707388475,
                        116.89874216966487,
                        34.80167210441222,
                        116.89917916950783,
                        34.80102412083314,
                        116.89707616941023,
                        34.79984214934451,
                        116.897533170243,
                        34.79738921045931,
                        116.89848216937375,
                        34.79920116580025,
                        116.9046101699166,
                        34.79395629495653,
                        116.90660517005911,
                        34.79608224285149,
                        116.91490016937531,
                        34.794489281673314,
                        116.91712516967164,
                        34.794349285171265,
                        116.91816216956427,
                        34.78547850445267,
                        116.92167016980044,
                        34.784844520014005,
                        116.91924416966263,
                        34.78177559578999,
                        116.91938316957977,
                        34.781710597279115,
                        116.92013116976739,
                        34.779571650157116,
                        116.92041516944946,
                        34.77736670488063,
                        116.92034116982961,
                        34.777524700603465,
                        116.91892416999538,
                        34.778303681535405,
                        116.91645716984975,
                        34.77839667950669,
                        116.91558716946335,
                        34.77840267891743,
                        116.91459616960151,
                        34.77823268306855,
                        116.913958169917,
                        34.77781269343013,
                        116.91298116940052,
                        34.776200733543355,
                        116.91338717017966,
                        34.77104586102573,
                        116.91425417019293,
                        34.77164984572826,
                        116.91646517024557,
                        34.770037885730005,
                        116.91687816979912,
                        34.76746294940597,
                        116.9182031695718,
                        34.76453802133723,
                        116.91900916948573,
                        34.76412803163289,
                        116.91920517020264,
                        34.76244607280545,
                        116.92028416992801,
                        34.7614490978474,
                        116.92101516949893,
                        34.759644142037104,
                        116.92244716940175,
                        34.75750919505719,
                        116.92378816996631,
                        34.75656621821661,
                        116.92424317025097,
                        34.754894259488985,
                        116.92476316993462,
                        34.754869260091276,
                        116.92189016990805,
                        34.751623340323164,
                        116.92198016942137,
                        34.75165733940435,
                        116.91957316955022,
                        34.74921639976953,
                        116.91959517018981,
                        34.74911740207091,
                        116.92132716966833,
                        34.74787943213494,
                        116.92154216975342,
                        34.74779043434411,
                        116.92669016940671,
                        34.744293520624005,
                        116.92654116944374,
                        34.744276521025455,
                        116.9201911700414,
                        34.74426952188407,
                        116.91743916949036,
                        34.74321054800902,
                        116.91742716979478,
                        34.74320954779428,
                        116.91405116980303,
                        34.74231656982751,
                        116.91226216952481,
                        34.74136959281173,
                        116.91113616994367,
                        34.741334593685416,
                        116.9093521696883,
                        34.73431276719714,
                        116.91247316941187,
                        34.733876777871735,
                        116.91031917015899,
                        34.73402177445837,
                        116.9091461698239,
                        34.73382477900732,
                        116.9084711694312,
                        34.72928289096882,
                        116.90727217005505,
                        34.72777392845253,
                        116.91263516979348,
                        34.728949899374754,
                        116.91311517019255,
                        34.72838791309908,
                        116.91379016968695,
                        34.72903789716613,
                        116.9139631699393,
                        34.72907589672111,
                        116.91460917001969,
                        34.72684595119449,
                        116.91563216966858,
                        34.71546623232686,
                        116.92166216940367
                    ],
                    "name": "经济开发区"
                },
                {
                    "path": [
                        34.807976948905946,
                        116.9011401702136,
                        34.81102487349877,
                        116.89980717004495,
                        34.81168585737423,
                        116.90212117002977,
                        34.812963825565646,
                        116.90156816983581,
                        34.8131688202792,
                        116.90133017018442,
                        34.81317582020737,
                        116.90095017024285,
                        34.812550835767766,
                        116.89923616940938,
                        34.81173085581464,
                        116.89933116984389,
                        34.81131986597682,
                        116.8983811699899,
                        34.812045847946656,
                        116.8980291696374,
                        34.81166585730496,
                        116.89709516967689,
                        34.81233984108972,
                        116.89660116993251,
                        34.81279882990688,
                        116.89768717022898,
                        34.81498777587089,
                        116.89674516987259,
                        34.814729781650136,
                        116.89582716980563,
                        34.81579475577431,
                        116.89533916990905,
                        34.81562875982778,
                        116.89475616957782,
                        34.81592375278961,
                        116.89441716964406,
                        34.81582575478103,
                        116.8940371697025,
                        34.816939727505435,
                        116.89360417005747,
                        34.81788870414697,
                        116.89686217004846,
                        34.81942166629837,
                        116.90212617005274,
                        34.820163647856674,
                        116.90467316966605,
                        34.820656635291925,
                        116.9094421701009,
                        34.82395855415694,
                        116.90921216994718,
                        34.82434954444765,
                        116.91209716966931,
                        34.826609488443665,
                        116.91163916990993,
                        34.82694848023467,
                        116.91508716987177,
                        34.825686511263626,
                        116.91547716985909,
                        34.82501152830638,
                        116.91513416972742,
                        34.82381155781087,
                        116.9147291696714,
                        34.82369656015289,
                        116.91440116960834,
                        34.823365568769766,
                        116.91414516951531,
                        34.82253558896427,
                        116.91376116937572,
                        34.821275620223744,
                        116.9159911696949,
                        34.814454788998496,
                        116.91050216955972,
                        34.80953291060063,
                        116.90654317013502,
                        34.807976948905946,
                        116.9011401702136
                    ],
                    "name": "中煤集团大屯煤电（集团）公司"
                },
                {
                    "path": [
                        34.789799397528775,
                        116.83904816951505,
                        34.79003439178323,
                        116.83551716971263,
                        34.7939072963596,
                        116.83477816974585,
                        34.7954412578737,
                        116.83573616999578,
                        34.79558525449291,
                        116.83423116939971,
                        34.79660922926444,
                        116.82353616988497,
                        34.79762420426616,
                        116.81686316954415,
                        34.79778619993834,
                        116.81579516968935,
                        34.80416604277337,
                        116.80831217013503,
                        34.805411012164996,
                        116.80685216974473,
                        34.810347890112794,
                        116.80486216962514,
                        34.812301841993204,
                        116.80540916997136,
                        34.824023552277275,
                        116.80869117025193,
                        34.825885506096164,
                        116.80890717016203,
                        34.82704947703988,
                        116.80904216988125,
                        34.8272504723979,
                        116.80692016951707,
                        34.820616636286154,
                        116.80057616996243,
                        34.822262595439845,
                        116.79961517023783,
                        34.82493652938323,
                        116.80009616956349,
                        34.824744534593584,
                        116.796749169884,
                        34.81510177279553,
                        116.79318217009639,
                        34.811624858239135,
                        116.78591717010178,
                        34.81243983798138,
                        116.78305116974789,
                        34.81115686991217,
                        116.78233117004771,
                        34.80916591875658,
                        116.78121316996419,
                        34.804287039325,
                        116.77847516965683,
                        34.80251508305812,
                        116.7742281694537,
                        34.80326706482174,
                        116.76547016945693,
                        34.808419937818094,
                        116.76533916993571,
                        34.81041588843716,
                        116.75689416993342,
                        34.81122986821491,
                        116.75344416942353,
                        34.81149186128732,
                        116.7428361699474,
                        34.81242983830484,
                        116.74259917012098,
                        34.81547176300317,
                        116.74183116984187,
                        34.81938466661054,
                        116.74084216962989,
                        34.82993240632846,
                        116.74194016962198,
                        34.8303573953673,
                        116.73958717017751,
                        34.83198635529628,
                        116.73055916984397,
                        34.83161736451913,
                        116.7294311697147,
                        34.83013240135694,
                        116.72489817017967,
                        34.828622438061224,
                        116.72029117012652,
                        34.82883643275738,
                        116.71282617011539,
                        34.82952741589776,
                        116.71302617013191,
                        34.830104401461156,
                        116.71033116948229,
                        34.8340403046251,
                        116.71174516984186,
                        34.83353231701405,
                        116.71383316987081,
                        34.83486428379084,
                        116.71416916943154,
                        34.83638624613782,
                        116.71434017003408,
                        34.83695723199754,
                        116.71460117014999,
                        34.83758821659428,
                        116.71478117007506,
                        34.839941158617535,
                        116.71520217002457,
                        34.842014107455995,
                        116.71574316962469,
                        34.843255076639835,
                        116.71628516994801,
                        34.84411705540073,
                        116.71703616961041,
                        34.84457804424614,
                        116.71729616990137,
                        34.84466704158918,
                        116.71623416989438,
                        34.846339000838924,
                        116.71671517011833,
                        34.84791096178717,
                        116.71704616965617,
                        34.84752197142266,
                        116.71826917021991,
                        34.84987591295651,
                        116.71928116999825,
                        34.849946911635676,
                        116.71925017003615,
                        34.85017490567958,
                        116.71829816963402,
                        34.850355901107925,
                        116.71820817012062,
                        34.850721892277086,
                        116.71831517025073,
                        34.85190786286192,
                        116.71866017003227,
                        34.85235985204077,
                        116.72021316941066,
                        34.85244984943591,
                        116.72034317000525,
                        34.852470848790816,
                        116.72092416978835,
                        34.853120833111916,
                        116.72098417006279,
                        34.853221830534494,
                        116.72139417014166,
                        34.85321183075897,
                        116.72145517024101,
                        34.85204085931391,
                        116.72141417023309,
                        34.85136087604804,
                        116.7219051696045,
                        34.85112188267954,
                        116.72361816971473,
                        34.85085188879145,
                        116.72374917013431,
                        34.850221904521305,
                        116.7238081696855,
                        34.84988091270291,
                        116.72821716937197,
                        34.849835914457415,
                        116.72878616945947,
                        34.85095688608328,
                        116.72884616973397,
                        34.85090688729261,
                        116.72950716988294,
                        34.85126887895473,
                        116.72954016949491,
                        34.85226885421527,
                        116.72960817016529,
                        34.85237685148643,
                        116.72771517012997,
                        34.85355882191218,
                        116.72768417016786,
                        34.85363682053455,
                        116.72629316937457,
                        34.855589771954335,
                        116.72624317004423,
                        34.85558877163626,
                        116.72594216974534,
                        34.858411701960044,
                        116.72583316996541,
                        34.85841170196042,
                        116.72597316970747,
                        34.85929268045261,
                        116.72601316989045,
                        34.85928368095195,
                        116.72670417017669,
                        34.85942367695092,
                        116.72670417017669,
                        34.85938467818186,
                        116.72778616937687,
                        34.861847617013055,
                        116.72797617024601,
                        34.86172962016728,
                        116.73019916999422,
                        34.862910590877995,
                        116.73023917017717,
                        34.86292959078956,
                        116.72984917018981,
                        34.86675449625845,
                        116.73025017004785,
                        34.86764847384369,
                        116.7294371695629,
                        34.87021541045708,
                        116.72712616995123,
                        34.87103539024995,
                        116.7263551701974,
                        34.871165387077134,
                        116.72615416945763,
                        34.871276384245625,
                        116.72618516941975,
                        34.87129638382592,
                        116.72626516978565,
                        34.87049740360428,
                        116.72914916968291,
                        34.87159937584685,
                        116.72969017018129,
                        34.87169837392012,
                        116.72916916977435,
                        34.87183837015953,
                        116.72892916957491,
                        34.87196836719041,
                        116.72845816939662,
                        34.87223936042814,
                        116.72855816985407,
                        34.87283734583709,
                        116.72642516961926,
                        34.873529328167855,
                        116.72672616991821,
                        34.87480729677065,
                        116.72322017023005,
                        34.87554827871741,
                        116.72353116967639,
                        34.87573627409099,
                        116.72164816968683,
                        34.87661725197977,
                        116.72180816952037,
                        34.8770642406871,
                        116.71837217015246,
                        34.88030516117728,
                        116.71712017017474,
                        34.88049715605335,
                        116.71774216996567,
                        34.88143913249288,
                        116.71841317016043,
                        34.8808691472924,
                        116.71959516981799,
                        34.88263210297575,
                        116.7202761700585,
                        34.88224311321241,
                        116.72213016973573,
                        34.88333508591059,
                        116.72223017019316,
                        34.88322608877632,
                        116.7230511701758,
                        34.88226511232348,
                        116.72301116999277,
                        34.88216511519078,
                        116.72374216956364,
                        34.882745100857505,
                        116.72374216956364,
                        34.88274610084506,
                        116.72396316949663,
                        34.884067067889056,
                        116.72407316999974,
                        34.884018069300645,
                        116.72455316950051,
                        34.88541203472137,
                        116.72470216946347,
                        34.88608001786079,
                        116.72476416938774,
                        34.885802024919734,
                        116.72645716940652,
                        34.88573102697921,
                        116.72658717000114,
                        34.885582030509376,
                        116.72658717000114,
                        34.88516304051297,
                        116.7288301698408,
                        34.885213039851074,
                        116.72894016944565,
                        34.88607401819447,
                        116.72936116939515,
                        34.88717599090358,
                        116.72961116964046,
                        34.8872859886278,
                        116.72955217008919,
                        34.88748498364559,
                        116.72872017023597,
                        34.88818596574854,
                        116.72861016973283,
                        34.88885394917454,
                        116.72605616954854,
                        34.892068870048966,
                        116.72718816987573,
                        34.89146088500897,
                        116.73045316953944,
                        34.89090189882398,
                        116.73290616944143,
                        34.89158288219046,
                        116.73316716955735,
                        34.89190387381824,
                        116.73350717021424,
                        34.89127489001115,
                        116.73627016973762,
                        34.892686854442985,
                        116.7367011697329,
                        34.89212786849902,
                        116.74097516970009,
                        34.892347863068494,
                        116.74102516992883,
                        34.89215886750417,
                        116.74319716962341,
                        34.896772753625974,
                        116.74339917018814,
                        34.89648376053139,
                        116.74484716998451,
                        34.89302684652321,
                        116.74422517019352,
                        34.88983892509017,
                        116.74361816957287,
                        34.887777976459326,
                        116.74416616974393,
                        34.887724977430175,
                        116.74450916987561,
                        34.8864630090524,
                        116.75273616941969,
                        34.88626501372876,
                        116.75882717015263,
                        34.886329012353414,
                        116.76314116940445,
                        34.883719076647004,
                        116.76539716966298,
                        34.88361907907711,
                        116.76775816950341,
                        34.88316009014411,
                        116.77860017022952,
                        34.88315509024757,
                        116.78353617017069,
                        34.883154090269464,
                        116.78499016981485,
                        34.88234011045042,
                        116.78636917001421,
                        34.88110614135374,
                        116.78584517013259,
                        34.8746033017392,
                        116.7830851700839,
                        34.868989440575675,
                        116.78389416947249,
                        34.86626250807513,
                        116.78590516950855,
                        34.86391456644739,
                        116.79168317024697,
                        34.86564552351426,
                        116.80144316997631,
                        34.866258508116175,
                        116.80590716991438,
                        34.86688849268357,
                        116.81049516970094,
                        34.87230035879363,
                        116.81287917000601,
                        34.876332259281234,
                        116.82634916963804,
                        34.8773572340626,
                        116.82908316974739,
                        34.875839271452314,
                        116.83203416959174,
                        34.87554527879967,
                        116.83653916953767,
                        34.87398831740751,
                        116.83653916953767,
                        34.87240935647937,
                        116.83653816971272,
                        34.872089364002434,
                        116.83835516958001,
                        34.87156037725467,
                        116.84134616960733,
                        34.87088139407511,
                        116.84519716997525,
                        34.87085939490133,
                        116.85755416954659,
                        34.87116338718057,
                        116.85881516974521,
                        34.87262535114584,
                        116.86488317001357,
                        34.85867269618673,
                        116.87006716965169,
                        34.85789971508521,
                        116.86942616959422,
                        34.85626875572974,
                        116.86807216950913,
                        34.85374381826531,
                        116.86597517015761,
                        34.84505703230202,
                        116.86870916936854,
                        34.840603142882344,
                        116.868111169867,
                        34.840219152199175,
                        116.86822616949472,
                        34.835170277183565,
                        116.87006116980365,
                        34.832825334807566,
                        116.8708831696111,
                        34.82575450948095,
                        116.87336417000039,
                        34.8207326332863,
                        116.87512616961605,
                        34.818817681059194,
                        116.87579816963567,
                        34.81757271138786,
                        116.87623516947869,
                        34.81428479288181,
                        116.87533716950317,
                        34.81509077293056,
                        116.86275416997607,
                        34.807815952659524,
                        116.86225316966055,
                        34.80632198956294,
                        116.86260816948777,
                        34.80613299398286,
                        116.86154416983094,
                        34.802827076063885,
                        116.86265316969357,
                        34.80283607583808,
                        116.8627901699609,
                        34.80047713371249,
                        116.86333116956096,
                        34.79690522207595,
                        116.8527661697426,
                        34.794987269168686,
                        116.8470911698346,
                        34.785337507512594,
                        116.84827116984222,
                        34.78496151722275,
                        116.84280616999658,
                        34.78465352426878,
                        116.83834316988342,
                        34.789799397528775,
                        116.83904816951505
                    ],
                    "name": "安国镇"
                },
                {
                    "path": [
                        34.6458149490121,
                        117.0362661700968,
                        34.64355800452104,
                        117.03575616956051,
                        34.6404420813207,
                        117.02643316967418,
                        34.640028091988604,
                        117.02451717007263,
                        34.639331108741885,
                        117.02128716967073,
                        34.64131606002663,
                        117.01792216954962,
                        34.64356600466257,
                        117.01504017020059,
                        34.64366400238989,
                        117.01080916989105,
                        34.64368300181523,
                        117.01000416980195,
                        34.64113006438324,
                        117.00679216984173,
                        34.63907511551596,
                        117.00149017020262,
                        34.637078164414625,
                        117.00094016948339,
                        34.63704716481818,
                        116.9993491695719,
                        34.637026165323455,
                        116.99830016998366,
                        34.63825613515084,
                        116.99878416968234,
                        34.639700099490504,
                        116.99781717010995,
                        34.64015908852736,
                        116.997332169688,
                        34.63960210223181,
                        116.99445117016387,
                        34.63995309375348,
                        116.99445117016387,
                        34.64030008537827,
                        116.99335116962375,
                        34.64104406685998,
                        116.99266916955838,
                        34.64294102019041,
                        116.99289816988727,
                        34.64323701293054,
                        116.99293317004738,
                        34.64343600739526,
                        116.99363716985401,
                        34.64495497058664,
                        116.99555116980578,
                        34.645313961660044,
                        116.99843317005318,
                        34.649352862280956,
                        117.00008316951593,
                        34.65180280175158,
                        116.99830216963366,
                        34.65234978836928,
                        116.99768616969051,
                        34.655916700331865,
                        116.99568516970021,
                        34.65964260873178,
                        116.9952011700016,
                        34.660674582790485,
                        116.99568516970031,
                        34.662191545479864,
                        116.9974011701836,
                        34.66458148681452,
                        116.99720316981691,
                        34.66514347284387,
                        116.99704016961027,
                        34.667385417915284,
                        116.99639017023026,
                        34.668143398733214,
                        116.9934211699443,
                        34.669701360427425,
                        116.9865971699907,
                        34.67002635278455,
                        116.98517316958544,
                        34.67273628537944,
                        116.98222517011422,
                        34.673023278960564,
                        116.98085916943528,
                        34.673212274136446,
                        116.97996016963485,
                        34.673625263655296,
                        116.97857516958773,
                        34.673545265522016,
                        116.97268516959461,
                        34.67366926241719,
                        116.97046017019663,
                        34.67572821180641,
                        116.96991117020059,
                        34.677908158142024,
                        116.96531616984302,
                        34.67809715325497,
                        116.96537316974445,
                        34.68084608603486,
                        116.96518516942346,
                        34.68230105015875,
                        116.96813117014325,
                        34.688235903316155,
                        116.96566917002059,
                        34.68842589863314,
                        116.96936116948154,
                        34.68996086109813,
                        116.97136417002001,
                        34.696879690707554,
                        116.9718071697109,
                        34.69800766309334,
                        116.9717171701976,
                        34.704945491437925,
                        116.96753816976661,
                        34.70806941477456,
                        116.97164416950442,
                        34.71088834518173,
                        116.97530216952855,
                        34.71525723723429,
                        116.97770017007727,
                        34.71767417754438,
                        116.97948216978453,
                        34.719181140326654,
                        116.98429116950406,
                        34.72173807773791,
                        116.98572216958206,
                        34.72451500921034,
                        116.98668216948184,
                        34.72166307972545,
                        116.98858217008811,
                        34.71665720254955,
                        116.99170016943872,
                        34.713870271831574,
                        116.99250516952769,
                        34.71010136446633,
                        116.99329616937301,
                        34.70763542573329,
                        116.99168716991811,
                        34.70691744302476,
                        116.99167117002453,
                        34.70589946799603,
                        116.9904561698567,
                        34.70451150226718,
                        116.99195116950875,
                        34.70349652775969,
                        116.99228716996765,
                        34.702584549891064,
                        116.99258917009146,
                        34.70102258879715,
                        116.99822016961848,
                        34.69993061508445,
                        116.999518169627,
                        34.69461174650774,
                        117.00268516938138,
                        34.69262079565533,
                        117.0037841700966,
                        34.69180981553036,
                        117.00438216959806,
                        34.69056384622204,
                        117.00530217021313,
                        34.68913588137947,
                        117.00618916941959,
                        34.6880499082239,
                        117.00769917003859,
                        34.68725592787312,
                        117.01084317022679,
                        34.687160930409945,
                        117.01121916997037,
                        34.689496872621,
                        117.01500216966797,
                        34.69054384713973,
                        117.02085317020133,
                        34.69199581120841,
                        117.0252521698421,
                        34.695164733017414,
                        117.03486116995875,
                        34.700139610014574,
                        117.03772817013756,
                        34.703749521616714,
                        117.03980816977061,
                        34.70779942145909,
                        117.04348316951321,
                        34.714195263773405,
                        117.05409416936237,
                        34.71521723857508,
                        117.05587716979285,
                        34.7154292333321,
                        117.05648517023842,
                        34.71324328736186,
                        117.05842116993142,
                        34.714075267059506,
                        117.06184116940582,
                        34.715123241290875,
                        117.06615717010422,
                        34.710372357905705,
                        117.06482317011057,
                        34.70409251302414,
                        117.06937216953906,
                        34.698581648666305,
                        117.07312516999761,
                        34.6970456865111,
                        117.06993216940563,
                        34.69627570538139,
                        117.06781816943737,
                        34.691671818837555,
                        117.06417217000711,
                        34.68777391519108,
                        117.06206516971149,
                        34.68354101958926,
                        117.06066616942057,
                        34.68176706330145,
                        117.06008016961461,
                        34.67908312959915,
                        117.05815616961715,
                        34.67780516069737,
                        117.05745116998553,
                        34.674548241252985,
                        117.0582251701124,
                        34.67174131074513,
                        117.05924416956331,
                        34.663309518592385,
                        117.058224169389,
                        34.65979760514923,
                        117.05809316986773,
                        34.658584634366704,
                        117.05325716948565,
                        34.657148669702806,
                        117.05432816971351,
                        34.65550471041598,
                        117.05481116958721,
                        34.65501972226372,
                        117.05309816947695,
                        34.65426074127598,
                        117.04668117012741,
                        34.65158180746808,
                        117.04496717019221,
                        34.65115581801859,
                        117.04105516972493,
                        34.65026983983899,
                        117.03727416967718,
                        34.649922847807545,
                        117.03719517003447,
                        34.6458149490121,
                        117.0362661700968
                    ],
                    "name": "胡寨镇"
                },
                {
                    "path": [
                        34.55516718074827,
                        117.10112416979209,
                        34.552277252053116,
                        117.10167117013826,
                        34.55155826985919,
                        117.10166916959005,
                        34.55132827586482,
                        117.10070816986546,
                        34.550367299136255,
                        117.1009891700728,
                        34.54997730857461,
                        117.09950816976618,
                        34.548726339562975,
                        117.10008716989941,
                        34.547045380803844,
                        117.10071816991115,
                        34.54665539021149,
                        117.09908616999176,
                        34.54465343950542,
                        117.10016716936697,
                        34.54412345278333,
                        117.10038716947498,
                        34.54391245827958,
                        117.09955616944666,
                        34.54310247751077,
                        117.10019716950413,
                        34.542824484348905,
                        117.09948416947663,
                        34.540899532244275,
                        117.09460316978704,
                        34.539506566396575,
                        117.09515616998095,
                        34.53902857778158,
                        117.09533316953303,
                        34.538838582850005,
                        117.09493316949991,
                        34.537947604675516,
                        117.09228116940626,
                        34.53739661790677,
                        117.09112916988595,
                        34.53782660761301,
                        117.09057917006501,
                        34.53687563070641,
                        117.08885716973394,
                        34.53857558894021,
                        117.0872951701347,
                        34.53893558014223,
                        117.08683417000229,
                        34.538283596413834,
                        117.08496216988337,
                        34.53868358638344,
                        117.08463217017051,
                        34.53861358851707,
                        117.08435116996311,
                        34.539133575482964,
                        117.08369116963898,
                        34.538752584468426,
                        117.08197816952875,
                        34.53921257324794,
                        117.08184816983241,
                        34.53895957987315,
                        117.07875317004807,
                        34.53796860402361,
                        117.07834217014431,
                        34.53786660621515,
                        117.07766716975158,
                        34.53785760646708,
                        117.07734016951342,
                        34.53799760341033,
                        117.07716016958835,
                        34.53837659399491,
                        117.07626816946069,
                        34.538526590198856,
                        117.07620817008453,
                        34.53833559514176,
                        117.07569716972343,
                        34.53679563316596,
                        117.07604817025098,
                        34.53680563276686,
                        117.07639817005533,
                        34.53546466556172,
                        117.07660916994247,
                        34.53547466532212,
                        117.07682917005049,
                        34.535084675280935,
                        117.07687916938094,
                        34.53496267799891,
                        117.07568716967756,
                        34.5345736875444,
                        117.07575716999783,
                        34.53448168989561,
                        117.07501616948288,
                        34.532915728099816,
                        117.07536117016265,
                        34.53223074551764,
                        117.07550616992758,
                        34.531867754044505,
                        117.07254017001465,
                        34.53004679849216,
                        117.07303116938593,
                        34.52979480521429,
                        117.07178916945392,
                        34.529652808887306,
                        117.07030516967255,
                        34.52946181345436,
                        117.06950316995653,
                        34.52968980753369,
                        117.06769016938885,
                        34.529688807709,
                        117.06718916997177,
                        34.529446813831086,
                        117.06580516974945,
                        34.52921481902354,
                        117.06516816988992,
                        34.529958801023,
                        117.06494316975902,
                        34.53070278303566,
                        117.06454816974883,
                        34.531448764666834,
                        117.0643291694657,
                        34.53460468687409,
                        117.06413116999735,
                        34.535502664312396,
                        117.0640001695778,
                        34.53701362753985,
                        117.06274816959997,
                        34.5388535821614,
                        117.06173816947158,
                        34.539946555434085,
                        117.06035516997255,
                        34.541716512125355,
                        117.05725816964004,
                        34.54330347291153,
                        117.05733717018107,
                        34.54480843581111,
                        117.05741216962586,
                        34.54796235846121,
                        117.05624816951162,
                        34.55060429339437,
                        117.05095416937021,
                        34.550907286038374,
                        117.05050716948149,
                        34.551917260704386,
                        117.04985616937823,
                        34.55618915608492,
                        117.05292416939851,
                        34.55681314012484,
                        117.05337217001049,
                        34.56415895971852,
                        117.05440516970525,
                        34.56979182100363,
                        117.05376816984575,
                        34.571102788622106,
                        117.0537111699444,
                        34.575910670570615,
                        117.0534981695091,
                        34.5773776342473,
                        117.05347417011801,
                        34.58250750807189,
                        117.05480317008875,
                        34.584772452604646,
                        117.05831717017278,
                        34.58789437528342,
                        117.06820016992584,
                        34.588273366354315,
                        117.06967516948637,
                        34.59621817097643,
                        117.06941916939343,
                        34.597921128482355,
                        117.06938616978151,
                        34.5984721151523,
                        117.0715821697655,
                        34.60012407496205,
                        117.0790431695787,
                        34.60415797538974,
                        117.07939516993127,
                        34.60483895861176,
                        117.08090916984986,
                        34.60543594404027,
                        117.08145216999809,
                        34.606549916148715,
                        117.08246717014943,
                        34.612625766899725,
                        117.08152616961803,
                        34.613060755842916,
                        117.08145816984597,
                        34.61448372101147,
                        117.07972516964422,
                        34.61591468608932,
                        117.07686316948838,
                        34.61721865400534,
                        117.0744591699902,
                        34.62024457947489,
                        117.07439416969297,
                        34.6209915610734,
                        117.07603917003114,
                        34.62165854467992,
                        117.08046916963399,
                        34.62216053234187,
                        117.08380617016601,
                        34.621964536951204,
                        117.08654816977305,
                        34.62203253525222,
                        117.0906491694879,
                        34.62451147414963,
                        117.09610917020906,
                        34.62764639718709,
                        117.09959416998082,
                        34.62861137320706,
                        117.10172016964462,
                        34.62895936436474,
                        117.10945417016758,
                        34.62913835992351,
                        117.11184116994725,
                        34.62907736155291,
                        117.11187716993228,
                        34.62895936437123,
                        117.1118471697951,
                        34.62882736770015,
                        117.11150816986141,
                        34.62683541671526,
                        117.11248016945665,
                        34.62219653113608,
                        117.11410116950535,
                        34.61618767914934,
                        117.11620016940489,
                        34.61448272156834,
                        117.11679617015488,
                        34.60739489604365,
                        117.11934416959299,
                        34.60679391062934,
                        117.11956016950303,
                        34.60441696892433,
                        117.12056717015675,
                        34.6036249889022,
                        117.12099817015194,
                        34.597852130810764,
                        117.12363017015399,
                        34.59779013188623,
                        117.12365816974305,
                        34.59715914799992,
                        117.12400017004981,
                        34.59593417793446,
                        117.12479116989519,
                        34.59334124145484,
                        117.12615616985086,
                        34.59190027743466,
                        117.12705516965119,
                        34.5907833045847,
                        117.12773716971661,
                        34.58824136732319,
                        117.12929016999327,
                        34.58820136850006,
                        117.12932017013047,
                        34.585872425532756,
                        117.13104917013422,
                        34.585159443229436,
                        117.1317591697887,
                        34.58265450502641,
                        117.13383616994703,
                        34.58064955399662,
                        117.13567816992861,
                        34.5780186190113,
                        117.13822516954195,
                        34.57757563006566,
                        117.1386541698873,
                        34.57575167459766,
                        117.14038816991396,
                        34.57263375166121,
                        117.14316317003113,
                        34.57154777840031,
                        117.14407816972503,
                        34.57099879159715,
                        117.14437317017614,
                        34.567873868697376,
                        117.14604816975324,
                        34.56587391763041,
                        117.1465511697184,
                        34.56465994734882,
                        117.14680116996367,
                        34.563683971381344,
                        117.14700216980505,
                        34.561390028457176,
                        117.14693216948488,
                        34.55909608440882,
                        117.14665416965049,
                        34.55823010593896,
                        117.14647616937525,
                        34.55823210563946,
                        117.14630416984615,
                        34.55814810779015,
                        117.14251916960038,
                        34.55823110610001,
                        117.12455616971805,
                        34.558349103140536,
                        117.11401116999119,
                        34.55838810201597,
                        117.10013717012822,
                        34.55838410188104,
                        117.09988316968501,
                        34.55654214723007,
                        117.1007691699649,
                        34.55516718074827,
                        117.10112416979209
                    ],
                    "name": "五段镇"
                },
                {
                    "path": [
                        34.79387229695015,
                        116.94937917006679,
                        34.793531305635575,
                        116.95276816957903,
                        34.7893914082465,
                        116.9519951701753,
                        34.788652425996354,
                        116.9517571696256,
                        34.78842143158968,
                        116.95157116985277,
                        34.787491454641625,
                        116.95019716967622,
                        34.78597849214071,
                        116.94821816942714,
                        34.78502251539724,
                        116.94667316954641,
                        34.78324955929054,
                        116.94344817006565,
                        34.7814746032155,
                        116.93781216961743,
                        34.7818535938378,
                        116.93694217012937,
                        34.78459952649524,
                        116.93062316979083,
                        34.78579549669309,
                        116.9243481698333,
                        34.786129488267136,
                        116.92439317003914,
                        34.78834843359402,
                        116.92469416943969,
                        34.7902823860501,
                        116.92743116992217,
                        34.79099736782377,
                        116.92736516979991,
                        34.79462027877286,
                        116.92703017006423,
                        34.794531281188654,
                        116.92454916967486,
                        34.794349285171265,
                        116.91816216956427,
                        34.794489281673314,
                        116.91712516967164,
                        34.79608224285149,
                        116.91490016937531,
                        34.79395629495653,
                        116.90660517005911,
                        34.79920116580025,
                        116.9046101699166,
                        34.79738921045931,
                        116.89848216937375,
                        34.79984214934451,
                        116.897533170243,
                        34.80102412083314,
                        116.89707616941023,
                        34.80167210441222,
                        116.89917916950783,
                        34.80289707388475,
                        116.89874216966487,
                        34.80452503378953,
                        116.89673116962875,
                        34.8042570409206,
                        116.8956781698426,
                        34.806147993831644,
                        116.89491816995941,
                        34.80407504497703,
                        116.88764316991912,
                        34.80239908673917,
                        116.88838716990875,
                        34.801286113886405,
                        116.88410217007085,
                        34.800394135890784,
                        116.88027216961925,
                        34.80243008560104,
                        116.87949016999477,
                        34.80213309329284,
                        116.87811116979537,
                        34.80520801716694,
                        116.87714017002504,
                        34.80473602849153,
                        116.87388416968383,
                        34.80853093509594,
                        116.87316016978565,
                        34.80823394263692,
                        116.86968316951157,
                        34.80808694624624,
                        116.86968917025769,
                        34.80780495311757,
                        116.86555216965947,
                        34.80803694722231,
                        116.86553116974304,
                        34.807815952659524,
                        116.86225316966055,
                        34.81509077293056,
                        116.86275416997607,
                        34.81428479288181,
                        116.87533716950317,
                        34.81757271138786,
                        116.87623516947869,
                        34.818817681059194,
                        116.87579816963567,
                        34.8207326332863,
                        116.87512616961605,
                        34.82575450948095,
                        116.87336417000039,
                        34.832825334807566,
                        116.8708831696111,
                        34.835170277183565,
                        116.87006116980365,
                        34.835835260525634,
                        116.87274616950921,
                        34.83531927360358,
                        116.88308617009501,
                        34.83503128035732,
                        116.89005016979065,
                        34.834912283573566,
                        116.89590217014894,
                        34.83669523927948,
                        116.89897517019209,
                        34.83782321150637,
                        116.89860816977091,
                        34.84622900337065,
                        116.89584017022483,
                        34.84985491415273,
                        116.89453416982039,
                        34.85133087796543,
                        116.88887917000393,
                        34.85591376398019,
                        116.88539517005712,
                        34.85939567789792,
                        116.88274916981138,
                        34.86121163330624,
                        116.88136816996217,
                        34.86235360523284,
                        116.87692917013851,
                        34.863177584719075,
                        116.87752116979223,
                        34.86888944377075,
                        116.88162716953005,
                        34.86892344243004,
                        116.88551616953283,
                        34.86890244359721,
                        116.88765516961541,
                        34.868194460977854,
                        116.88766616948604,
                        34.86818646114486,
                        116.88967317022251,
                        34.868952441776266,
                        116.88965716943069,
                        34.86896144169513,
                        116.88975916953785,
                        34.86562652448162,
                        116.89469117017943,
                        34.86148662690978,
                        116.90060616938851,
                        34.85967667107279,
                        116.90293117014221,
                        34.86023565733885,
                        116.90368017015481,
                        34.86186661691586,
                        116.90587117011597,
                        34.86298658950757,
                        116.90737616981369,
                        34.86435655567642,
                        116.90848717022463,
                        34.866722497558676,
                        116.90821617006293,
                        34.869993416550706,
                        116.91051716962899,
                        34.870356407654825,
                        116.91395516954508,
                        34.86982942036815,
                        116.91836417012985,
                        34.87281634630999,
                        116.91952817024415,
                        34.873047340675896,
                        116.92180316987086,
                        34.873063340143496,
                        116.92195916950645,
                        34.87366932550509,
                        116.92238217000411,
                        34.87503529172938,
                        116.92240916976827,
                        34.87487729576186,
                        116.92275216989998,
                        34.8747013001792,
                        116.92425417012304,
                        34.87464330114054,
                        116.92730816989955,
                        34.87456030358862,
                        116.93163616939515,
                        34.87428831054157,
                        116.93166516970747,
                        34.87170837420856,
                        116.93193616986905,
                        34.87177937248877,
                        116.93875916999775,
                        34.873047340727254,
                        116.94077616988163,
                        34.87308233997896,
                        116.94322217011091,
                        34.873363332769024,
                        116.94369316939081,
                        34.87309833944147,
                        116.94397316977326,
                        34.87309833944624,
                        116.94573216991431,
                        34.87228835999477,
                        116.94577516957197,
                        34.87123238589619,
                        116.94646216966021,
                        34.86637450585149,
                        116.94723417013724,
                        34.867465479084856,
                        116.93611916959964,
                        34.8671484870452,
                        116.93208516983195,
                        34.86405056366859,
                        116.9318701697467,
                        34.863978565145786,
                        116.92959616994493,
                        34.86193561588824,
                        116.92963816977772,
                        34.861866616970715,
                        116.92611916967078,
                        34.86017565941949,
                        116.92597317008085,
                        34.858128709647325,
                        116.92579616963053,
                        34.854782792591934,
                        116.92550716992545,
                        34.85143187547093,
                        116.92521817022046,
                        34.84858194543938,
                        116.92497217017313,
                        34.84496203506222,
                        116.92466017000355,
                        34.84508203179635,
                        116.92788816985731,
                        34.84556302037128,
                        116.94078916940178,
                        34.845807014394616,
                        116.9473621701835,
                        34.84665999359698,
                        116.96173016979095,
                        34.84126212682542,
                        116.96223516940594,
                        34.83914917892782,
                        116.96307317000527,
                        34.83621525126495,
                        116.96547716950339,
                        34.8344742945494,
                        116.96762216943375,
                        34.83156036658377,
                        116.9690761699762,
                        34.83091338269438,
                        116.96939817019141,
                        34.82304457670755,
                        116.97252516976278,
                        34.822296595388785,
                        116.97282216986369,
                        34.81728571905909,
                        116.97481216998337,
                        34.817024725253816,
                        116.97491616974042,
                        34.81692972796663,
                        116.97468616958665,
                        34.81392480200375,
                        116.96740616952346,
                        34.8132188192683,
                        116.95294316948146,
                        34.81272583157346,
                        116.94672016940235,
                        34.80726396657775,
                        116.94740516984078,
                        34.80266608041955,
                        116.94740516984072,
                        34.79662122946546,
                        116.94740516984065,
                        34.79387229695015,
                        116.94937917006679
                    ],
                    "name": "大屯镇"
                },
                {
                    "path": [
                        34.67731717262496,
                        116.9185121693672,
                        34.67609120278309,
                        116.91222116951609,
                        34.67691718281154,
                        116.907064169642,
                        34.67704017956652,
                        116.90623616998676,
                        34.682633041580104,
                        116.90297217014802,
                        34.683820012215094,
                        116.89542517012113,
                        34.686784939007936,
                        116.89512916984519,
                        34.68857189506493,
                        116.89183317021937,
                        34.68863589362028,
                        116.89085817025101,
                        34.69707868538219,
                        116.89012216975905,
                        34.70191156589481,
                        116.88969716961165,
                        34.70617846075708,
                        116.88755816952913,
                        34.707037439522225,
                        116.88712817025716,
                        34.70707143922839,
                        116.88625316984785,
                        34.70749942816522,
                        116.87507116936312,
                        34.71139833230004,
                        116.87016416973434,
                        34.71232630940552,
                        116.86687716943102,
                        34.71623021316693,
                        116.86757916958798,
                        34.72219806575906,
                        116.8686541700138,
                        34.72217506625549,
                        116.8687441695272,
                        34.72346403496689,
                        116.86889316949008,
                        34.7249169991197,
                        116.86762016959591,
                        34.72735493857817,
                        116.8624071696454,
                        34.72966488151368,
                        116.86193616946723,
                        34.73036986433531,
                        116.8625121701257,
                        34.73268580696584,
                        116.86440517016102,
                        34.733596784828094,
                        116.87143716962879,
                        34.73423876897662,
                        116.8716241701249,
                        34.73590872739556,
                        116.87208816973208,
                        34.741860580520594,
                        116.8621011702221,
                        34.743032551678745,
                        116.8581951696026,
                        34.74408652612379,
                        116.85847516998508,
                        34.74618847425469,
                        116.85903317020197,
                        34.746670462248865,
                        116.85916117024847,
                        34.74868141246606,
                        116.86076317003067,
                        34.74919139998923,
                        116.86502117010437,
                        34.751599340632886,
                        116.8657791694395,
                        34.75236032172609,
                        116.86402316967155,
                        34.75490325915734,
                        116.86227816977427,
                        34.75538624728104,
                        116.86292616950445,
                        34.75786018631222,
                        116.86371616952496,
                        34.7573071999272,
                        116.86542816981027,
                        34.75859016817671,
                        116.86711116978333,
                        34.759968133757845,
                        116.86676517017693,
                        34.760621118095614,
                        116.86954117011909,
                        34.75883916153328,
                        116.87035717007878,
                        34.759691140720335,
                        116.87364117000905,
                        34.75873716425173,
                        116.87380417021564,
                        34.75827617557066,
                        116.8720771698617,
                        34.75781418724431,
                        116.87222016997679,
                        34.75785218611055,
                        116.87236616956669,
                        34.75611222943451,
                        116.87293817002715,
                        34.75609822948344,
                        116.8735791700847,
                        34.758004182138734,
                        116.87296916998939,
                        34.758323174432185,
                        116.87409416974555,
                        34.75514825308206,
                        116.8753151697612,
                        34.75515725289412,
                        116.87612917007107,
                        34.754845260634504,
                        116.87614216959155,
                        34.754848260091734,
                        116.87670516983121,
                        34.753456295019944,
                        116.87692616976413,
                        34.75223732478271,
                        116.87681117013643,
                        34.75304430473414,
                        116.87902217018907,
                        34.753293298570334,
                        116.87996416964717,
                        34.752722313187284,
                        116.88021616954221,
                        34.749518391972096,
                        116.88156516960439,
                        34.74947839269978,
                        116.88047816948297,
                        34.74808642717008,
                        116.88084516990405,
                        34.74809142716654,
                        116.8817521701004,
                        34.74511850015457,
                        116.88263517000715,
                        34.745180498894904,
                        116.88410416971999,
                        34.74470051070235,
                        116.88424916948493,
                        34.744677511555764,
                        116.88458116974593,
                        34.74375853396096,
                        116.88459316944153,
                        34.74326454644951,
                        116.88440917021678,
                        34.742591563081874,
                        116.88398016987135,
                        34.739710633729864,
                        116.8849541700148,
                        34.73959963640706,
                        116.88432616947777,
                        34.73854266299289,
                        116.88460017001248,
                        34.73859066152992,
                        116.88492016967963,
                        34.73788967904687,
                        116.88506617016778,
                        34.73788067883224,
                        116.88520716973478,
                        34.7375866860342,
                        116.88520716973478,
                        34.7375396871885,
                        116.88504916955101,
                        34.73689970341062,
                        116.88523716987197,
                        34.735031749261424,
                        116.88597716966369,
                        34.73475575629603,
                        116.88453817008813,
                        34.73223381847331,
                        116.8855451698435,
                        34.732389814268565,
                        116.88681716991277,
                        34.73157783457792,
                        116.88660316965255,
                        34.72910489574792,
                        116.88638017006974,
                        34.72707694582329,
                        116.88643316977317,
                        34.724795001632664,
                        116.88638517009257,
                        34.72320204144132,
                        116.88591416991437,
                        34.72118809065079,
                        116.88538616983467,
                        34.719747126642936,
                        116.88489116936707,
                        34.71762117879736,
                        116.88506016942146,
                        34.716495206836086,
                        116.88544316973605,
                        34.71641920870385,
                        116.88704617024146,
                        34.714867246985165,
                        116.88619416939842,
                        34.714706250823575,
                        116.88791417007971,
                        34.71151632957335,
                        116.88789616963797,
                        34.71159732777049,
                        116.88751817024449,
                        34.71025636051544,
                        116.88755917025242,
                        34.71001336617371,
                        116.88736916938329,
                        34.709058389975546,
                        116.88713016990694,
                        34.707055439293995,
                        116.89128417022359,
                        34.709001391621335,
                        116.89199717025113,
                        34.70871539857625,
                        116.89341917010826,
                        34.70851740349015,
                        116.89310716993869,
                        34.70840640637361,
                        116.89305017003734,
                        34.707832420557985,
                        116.89528717002919,
                        34.70592046749984,
                        116.89477016982018,
                        34.705629474532635,
                        116.89586716998731,
                        34.70429750746965,
                        116.90079516953259,
                        34.70480849482177,
                        116.90119516956563,
                        34.70585446919549,
                        116.90182416992761,
                        34.70557947549561,
                        116.90344716962615,
                        34.704621499266146,
                        116.90332617015065,
                        34.704373505677154,
                        116.90461417011345,
                        34.70638745609619,
                        116.90496116954483,
                        34.70813941293372,
                        116.90572516962592,
                        34.70698144121669,
                        116.91370517019618,
                        34.70991236909906,
                        116.91406517004634,
                        34.70969337439033,
                        116.9154161697583,
                        34.709673374724495,
                        116.9172571699151,
                        34.7098173710688,
                        116.91881416949137,
                        34.7096383754779,
                        116.91881017019179,
                        34.70958837736783,
                        116.91936716968539,
                        34.70926938521913,
                        116.91934016992117,
                        34.709143387974635,
                        116.92113116984928,
                        34.71111533912086,
                        116.92146116956214,
                        34.71127233548583,
                        116.9240861698916,
                        34.71546623232686,
                        116.92166216940367,
                        34.72684595119449,
                        116.91563216966858,
                        34.72907589672111,
                        116.91460917001969,
                        34.72903789716613,
                        116.9139631699393,
                        34.72838791309908,
                        116.91379016968695,
                        34.728949899374754,
                        116.91311517019255,
                        34.72777392845253,
                        116.91263516979348,
                        34.72928289096882,
                        116.90727217005505,
                        34.73382477900732,
                        116.9084711694312,
                        34.73402177445837,
                        116.9091461698239,
                        34.733876777871735,
                        116.91031917015899,
                        34.73431276719714,
                        116.91247316941187,
                        34.741334593685416,
                        116.9093521696883,
                        34.74136959281173,
                        116.91113616994367,
                        34.74231656982751,
                        116.91226216952481,
                        34.74320954779428,
                        116.91405116980303,
                        34.74321054800902,
                        116.91742716979478,
                        34.74426952188407,
                        116.91743916949036,
                        34.744276521025455,
                        116.9201911700414,
                        34.744293520624005,
                        116.92654116944374,
                        34.74411752497866,
                        116.93262916980362,
                        34.74400052798468,
                        116.93665716972355,
                        34.74383753207341,
                        116.94238816970801,
                        34.743181548772164,
                        116.94845017012858,
                        34.743005552964725,
                        116.95172716948785,
                        34.74518049907819,
                        116.95178116991451,
                        34.745810483408256,
                        116.95159017011883,
                        34.74611447595813,
                        116.95137216966064,
                        34.74645846740174,
                        116.95093016979479,
                        34.74672046106506,
                        116.95043316967731,
                        34.74690145641123,
                        116.94928916965453,
                        34.749118402281475,
                        116.9496101700449,
                        34.7487504112434,
                        116.9603391698948,
                        34.75245531985618,
                        116.95981816948793,
                        34.75340629633976,
                        116.96548516989832,
                        34.75729120037602,
                        116.96475816962713,
                        34.75922315239485,
                        116.97390116958837,
                        34.759830138010855,
                        116.9752371701301,
                        34.7600631320238,
                        116.9743291701089,
                        34.760604118466475,
                        116.97355417015712,
                        34.760849112414405,
                        116.9732311701169,
                        34.76669196821099,
                        116.96879317011819,
                        34.76382503902813,
                        116.95674816981803,
                        34.76377504048089,
                        116.95605016985915,
                        34.76466701821479,
                        116.95544716943645,
                        34.764443023441906,
                        116.95445416992474,
                        34.768942912656954,
                        116.95151916997398,
                        34.7697068936939,
                        116.95102017020673,
                        34.770216881225714,
                        116.95147316994327,
                        34.77050987386078,
                        116.95206816996999,
                        34.771952838589954,
                        116.95337816967417,
                        34.77303981144342,
                        116.95469516994929,
                        34.77311481005644,
                        116.9549771699816,
                        34.77284981647938,
                        116.95659317000742,
                        34.77285181617408,
                        116.95721916999635,
                        34.77311481006689,
                        116.95885017009086,
                        34.77372479487409,
                        116.96017116966559,
                        34.77408678559913,
                        116.96199216973085,
                        34.77415978433944,
                        116.96310516979153,
                        34.77517575875633,
                        116.96258916940752,
                        34.77623873293222,
                        116.96222017023491,
                        34.77722170849489,
                        116.96204617015759,
                        34.77727170701323,
                        116.96288317003372,
                        34.777321706238034,
                        116.96328317006679,
                        34.77519175880235,
                        116.96362617019841,
                        34.773852791493354,
                        116.9648281699475,
                        34.77332580481087,
                        116.97254216948063,
                        34.77117585799108,
                        116.97314317025345,
                        34.76560599509449,
                        116.97425916978877,
                        34.76601098520808,
                        116.98033217008,
                        34.766804965892106,
                        116.98020317020854,
                        34.76715695683114,
                        116.98546016964181,
                        34.76028012692512,
                        116.99144716971922,
                        34.76081011355294,
                        117.00775517011594,
                        34.76130410168739,
                        117.01766916983102,
                        34.7583741737452,
                        117.02035216988675,
                        34.75633522428619,
                        117.02221916998275,
                        34.754528268729736,
                        117.02369816974125,
                        34.753522293380065,
                        117.02204216953243,
                        34.751830335206286,
                        117.01925616954449,
                        34.752552317223454,
                        117.01862617025594,
                        34.75022237467157,
                        117.0118691702495,
                        34.748815409268005,
                        117.00653516992506,
                        34.7442465221298,
                        117.01026116972115,
                        34.74378453356072,
                        117.00974716988522,
                        34.7437145351333,
                        117.00924516974491,
                        34.74353354018157,
                        117.00877316974173,
                        34.74184158186221,
                        117.0066211701387,
                        34.74083560627203,
                        117.00550516970502,
                        34.74062161196759,
                        117.00489116941166,
                        34.740584612791736,
                        117.00444216987307,
                        34.740433616685564,
                        117.00408217002297,
                        34.73664171032669,
                        117.00277916999156,
                        34.733961776355244,
                        117.00192416967373,
                        34.731312841609494,
                        116.99721016949039,
                        34.72965288260609,
                        116.99443516937309,
                        34.725871975624294,
                        116.98871416943433,
                        34.725216991862176,
                        116.98764716940451,
                        34.72451500921034,
                        116.98668216948184,
                        34.72173807773791,
                        116.98572216958206,
                        34.719181140326654,
                        116.98429116950406,
                        34.71767417754438,
                        116.97948216978453,
                        34.71525723723429,
                        116.97770017007727,
                        34.71088834518173,
                        116.97530216952855,
                        34.70806941477456,
                        116.97164416950442,
                        34.704945491437925,
                        116.96753816976661,
                        34.69800766309334,
                        116.9717171701976,
                        34.696879690707554,
                        116.9718071697109,
                        34.68996086109813,
                        116.97136417002001,
                        34.68842589863314,
                        116.96936116948154,
                        34.688235903316155,
                        116.96566917002059,
                        34.68230105015875,
                        116.96813117014325,
                        34.68084608603486,
                        116.96518516942346,
                        34.67809715325497,
                        116.96537316974445,
                        34.678301148754606,
                        116.96252417000734,
                        34.67888113401869,
                        116.95732117010249,
                        34.6792121257821,
                        116.95445817012171,
                        34.67709217805501,
                        116.95223916967315,
                        34.67173931053759,
                        116.95439816984715,
                        34.66671743432362,
                        116.95390216955454,
                        34.663781506325314,
                        116.95220117003811,
                        34.66319452088945,
                        116.95186116938123,
                        34.665799456659556,
                        116.94976216948163,
                        34.66794140395973,
                        116.94823917024047,
                        34.678000155786506,
                        116.94108916987373,
                        34.6785661419032,
                        116.93954216944483,
                        34.67890513393366,
                        116.93861417023055,
                        34.67863114027884,
                        116.92525517002832,
                        34.67733617246493,
                        116.91861017017484,
                        34.67731717262496,
                        116.9185121693672
                    ],
                    "name": "沛城镇"
                },
                {
                    "path": [
                        34.75245531985618,
                        116.95981816948793,
                        34.7487504112434,
                        116.9603391698948,
                        34.749118402281475,
                        116.9496101700449,
                        34.74690145641123,
                        116.94928916965453,
                        34.74672046106506,
                        116.95043316967731,
                        34.74645846740174,
                        116.95093016979479,
                        34.74611447595813,
                        116.95137216966064,
                        34.745810483408256,
                        116.95159017011883,
                        34.74518049907819,
                        116.95178116991451,
                        34.743005552964725,
                        116.95172716948785,
                        34.743181548772164,
                        116.94845017012858,
                        34.74383753207341,
                        116.94238816970801,
                        34.74400052798468,
                        116.93665716972355,
                        34.74411752497866,
                        116.93262916980362,
                        34.744293520624005,
                        116.92654116944374,
                        34.74779043434411,
                        116.92669016940671,
                        34.74787943213494,
                        116.92154216975342,
                        34.74911740207091,
                        116.92132716966833,
                        34.74921639976953,
                        116.91959517018981,
                        34.75165733940435,
                        116.91957316955022,
                        34.751623340323164,
                        116.92198016942137,
                        34.754869260091276,
                        116.92189016990805,
                        34.754894259488985,
                        116.92476316993462,
                        34.75656621821661,
                        116.92424317025097,
                        34.75750919505719,
                        116.92378816996631,
                        34.759644142037104,
                        116.92244716940175,
                        34.7614490978474,
                        116.92101516949893,
                        34.76244607280545,
                        116.92028416992801,
                        34.76412803163289,
                        116.91920517020264,
                        34.76453802133723,
                        116.91900916948573,
                        34.76746294940597,
                        116.9182031695718,
                        34.770037885730005,
                        116.91687816979912,
                        34.77164984572826,
                        116.91646517024557,
                        34.77104586102573,
                        116.91425417019293,
                        34.776200733543355,
                        116.91338717017966,
                        34.77781269343013,
                        116.91298116940052,
                        34.77823268306855,
                        116.913958169917,
                        34.77840267891743,
                        116.91459616960151,
                        34.77839667950669,
                        116.91558716946335,
                        34.778303681535405,
                        116.91645716984975,
                        34.777524700603465,
                        116.91892416999538,
                        34.77736670488063,
                        116.92034116982961,
                        34.779571650157116,
                        116.92041516944946,
                        34.781710597279115,
                        116.92013116976739,
                        34.78177559578999,
                        116.91938316957977,
                        34.784844520014005,
                        116.91924416966263,
                        34.78547850445267,
                        116.92167016980044,
                        34.794349285171265,
                        116.91816216956427,
                        34.794531281188654,
                        116.92454916967486,
                        34.79462027877286,
                        116.92703017006423,
                        34.79099736782377,
                        116.92736516979991,
                        34.7902823860501,
                        116.92743116992217,
                        34.78834843359402,
                        116.92469416943969,
                        34.786129488267136,
                        116.92439317003914,
                        34.78579549669309,
                        116.9243481698333,
                        34.78459952649524,
                        116.93062316979083,
                        34.7818535938378,
                        116.93694217012937,
                        34.7814746032155,
                        116.93781216961743,
                        34.78324955929054,
                        116.94344817006565,
                        34.78502251539724,
                        116.94667316954641,
                        34.78597849214071,
                        116.94821816942714,
                        34.787491454641625,
                        116.95019716967622,
                        34.78842143158968,
                        116.95157116985277,
                        34.788652425996354,
                        116.9517571696256,
                        34.7893914082465,
                        116.9519951701753,
                        34.793531305635575,
                        116.95276816957903,
                        34.79337930938586,
                        116.95427116962696,
                        34.79034838416807,
                        116.95899216948298,
                        34.78900941717499,
                        116.96027916962085,
                        34.787105464199385,
                        116.96165216997245,
                        34.78266457395687,
                        116.96242416955114,
                        34.777321706238034,
                        116.96328317006679,
                        34.77727170701323,
                        116.96288317003372,
                        34.77722170849489,
                        116.96204617015759,
                        34.77623873293222,
                        116.96222017023491,
                        34.77517575875633,
                        116.96258916940752,
                        34.77415978433944,
                        116.96310516979153,
                        34.77408678559913,
                        116.96199216973085,
                        34.77372479487409,
                        116.96017116966559,
                        34.77311481006689,
                        116.95885017009086,
                        34.77285181617408,
                        116.95721916999635,
                        34.77284981647938,
                        116.95659317000742,
                        34.77311481005644,
                        116.9549771699816,
                        34.77303981144342,
                        116.95469516994929,
                        34.771952838589954,
                        116.95337816967417,
                        34.77050987386078,
                        116.95206816996999,
                        34.770216881225714,
                        116.95147316994327,
                        34.7697068936939,
                        116.95102017020673,
                        34.768942912656954,
                        116.95151916997398,
                        34.764443023441906,
                        116.95445416992474,
                        34.76466701821479,
                        116.95544716943645,
                        34.76377504048089,
                        116.95605016985915,
                        34.76382503902813,
                        116.95674816981803,
                        34.76669196821099,
                        116.96879317011819,
                        34.760849112414405,
                        116.9732311701169,
                        34.760604118466475,
                        116.97355417015712,
                        34.7600631320238,
                        116.9743291701089,
                        34.759830138010855,
                        116.9752371701301,
                        34.75922315239485,
                        116.97390116958837,
                        34.75729120037602,
                        116.96475816962713,
                        34.75340629633976,
                        116.96548516989832,
                        34.75245531985618,
                        116.95981816948793
                    ],
                    "name": "沛县新城区"
                },
                {
                    "path": [
                        34.85939567789792,
                        116.88274916981138,
                        34.85591376398019,
                        116.88539517005712,
                        34.85133087796543,
                        116.88887917000393,
                        34.84985491415273,
                        116.89453416982039,
                        34.84622900337065,
                        116.89584017022483,
                        34.83782321150637,
                        116.89860816977091,
                        34.83669523927948,
                        116.89897517019209,
                        34.834912283573566,
                        116.89590217014894,
                        34.83503128035732,
                        116.89005016979065,
                        34.83531927360358,
                        116.88308617009501,
                        34.835835260525634,
                        116.87274616950921,
                        34.835170277183565,
                        116.87006116980365,
                        34.840219152199175,
                        116.86822616949472,
                        34.840603142882344,
                        116.868111169867,
                        34.84505703230202,
                        116.86870916936854,
                        34.85374381826531,
                        116.86597517015761,
                        34.85626875572974,
                        116.86807216950913,
                        34.85789971508521,
                        116.86942616959422,
                        34.85867269618673,
                        116.87006716965169,
                        34.87262535114584,
                        116.86488317001357,
                        34.87116338718057,
                        116.85881516974521,
                        34.87085939490133,
                        116.85755416954659,
                        34.87088139407511,
                        116.84519716997525,
                        34.87156037725467,
                        116.84134616960733,
                        34.872089364002434,
                        116.83835516958001,
                        34.87240935647937,
                        116.83653816971272,
                        34.87398831740751,
                        116.83653916953767,
                        34.875281285214534,
                        116.83733716995403,
                        34.87721223738755,
                        116.83617816986262,
                        34.883370085488764,
                        116.82994616956282,
                        34.88824596492,
                        116.82501116944667,
                        34.88881295080064,
                        116.82443717023463,
                        34.89317984244043,
                        116.83434316955385,
                        34.90148063747625,
                        116.83451016995849,
                        34.90197962547102,
                        116.83452017000425,
                        34.91394532892507,
                        116.83476117002887,
                        34.916070276350254,
                        116.8356361695398,
                        34.91538229337876,
                        116.83994317001732,
                        34.92373108675953,
                        116.84061216966406,
                        34.9236960877561,
                        116.85042216962208,
                        34.92342809478209,
                        116.85374417008548,
                        34.925854034571174,
                        116.8521861697859,
                        34.92982993586784,
                        116.85261517013143,
                        34.929509943879864,
                        116.85586716937631,
                        34.92866996475286,
                        116.85690716964197,
                        34.92524504977337,
                        116.85899616949581,
                        34.92168013820746,
                        116.86164816958937,
                        34.91991918137652,
                        116.86420116994877,
                        34.914615312855155,
                        116.87188816971766,
                        34.91414132473941,
                        116.87327516941467,
                        34.91383433203925,
                        116.87417316939015,
                        34.913197347602505,
                        116.87603717001141,
                        34.91239536778111,
                        116.87838216995833,
                        34.91011442432884,
                        116.8850561701241,
                        34.90677550661693,
                        116.89482017005129,
                        34.903717582300025,
                        116.90180817003647,
                        34.902697607927415,
                        116.9018571695419,
                        34.90371358263622,
                        116.90181717025727,
                        34.896597758799864,
                        116.91807516952684,
                        34.88990992363718,
                        116.91760316952363,
                        34.87927818679971,
                        116.91781716978373,
                        34.87910219104933,
                        116.91584316955759,
                        34.8751592883723,
                        116.91588617011357,
                        34.87554627910383,
                        116.9212931702329,
                        34.87503529172938,
                        116.92240916976827,
                        34.87366932550509,
                        116.92238217000411,
                        34.873063340143496,
                        116.92195916950645,
                        34.873047340675896,
                        116.92180316987086,
                        34.87281634630999,
                        116.91952817024415,
                        34.86982942036815,
                        116.91836417012985,
                        34.870356407654825,
                        116.91395516954508,
                        34.869993416550706,
                        116.91051716962899,
                        34.866722497558676,
                        116.90821617006293,
                        34.86435655567642,
                        116.90848717022463,
                        34.86298658950757,
                        116.90737616981369,
                        34.86186661691586,
                        116.90587117011597,
                        34.86023565733885,
                        116.90368017015481,
                        34.85967667107279,
                        116.90293117014221,
                        34.86148662690978,
                        116.90060616938851,
                        34.86562652448162,
                        116.89469117017943,
                        34.86896144169513,
                        116.88975916953785,
                        34.868952441776266,
                        116.88965716943069,
                        34.86818646114486,
                        116.88967317022251,
                        34.868194460977854,
                        116.88766616948604,
                        34.86890244359721,
                        116.88765516961541,
                        34.86892344243004,
                        116.88551616953283,
                        34.86888944377075,
                        116.88162716953005,
                        34.863177584719075,
                        116.87752116979223,
                        34.86235360523284,
                        116.87692917013851,
                        34.86121163330624,
                        116.88136816996217,
                        34.85939567789792,
                        116.88274916981138
                    ],
                    "name": "杨屯镇"
                },
                {
                    "path": [
                        34.571102788622106,
                        117.0537111699444,
                        34.56979182100363,
                        117.05376816984575,
                        34.56415895971852,
                        117.05440516970525,
                        34.55681314012484,
                        117.05337217001049,
                        34.55618915608492,
                        117.05292416939851,
                        34.551917260704386,
                        117.04985616937823,
                        34.550907286038374,
                        117.05050716948149,
                        34.55110928076302,
                        117.04836616974907,
                        34.55133327501374,
                        117.04597716942122,
                        34.55199025934873,
                        117.04342817015811,
                        34.552420248387705,
                        117.04175716988067,
                        34.55847909949452,
                        117.04082416974515,
                        34.559876065214105,
                        117.0383511697517,
                        34.56230300547244,
                        117.03612016960763,
                        34.56239600286728,
                        117.0357241697725,
                        34.56290699066361,
                        117.03233816973494,
                        34.5637109707895,
                        117.02554416991867,
                        34.56256599905231,
                        117.01989216957689,
                        34.560698044735965,
                        117.01452516964041,
                        34.561658021061994,
                        117.01284316949236,
                        34.56400096327293,
                        117.01445517021861,
                        34.566690897657075,
                        117.01727516964347,
                        34.56888084313384,
                        117.01652817017907,
                        34.57032680797013,
                        117.01628616943137,
                        34.57196976764184,
                        117.01735816948415,
                        34.57347872993868,
                        117.01834316949825,
                        34.575294685609585,
                        117.02088316943886,
                        34.57810761634649,
                        117.0232581695231,
                        34.58348448405713,
                        117.02188517006985,
                        34.584387461565264,
                        117.02061817002347,
                        34.585231441358,
                        117.0194321701679,
                        34.585590431942045,
                        117.01461616987737,
                        34.587228391582066,
                        117.012724169667,
                        34.59249826218176,
                        117.01177016961512,
                        34.59365923325296,
                        117.01155916972786,
                        34.59379623008393,
                        117.00947016987402,
                        34.59493820200667,
                        117.00772417015182,
                        34.595465188776515,
                        117.00691817023787,
                        34.59735514248973,
                        117.00711817025443,
                        34.59899210266898,
                        117.00875617002163,
                        34.59856911301902,
                        117.01296016966867,
                        34.60110105076541,
                        117.01345616996126,
                        34.601907030638166,
                        117.01859216991895,
                        34.604661963046524,
                        117.02015617006634,
                        34.605192949596514,
                        117.0204571694669,
                        34.60896185692113,
                        117.0182361693686,
                        34.613146754065774,
                        117.01637316947054,
                        34.61185278594108,
                        117.01314016959391,
                        34.61382073692186,
                        117.01020516964307,
                        34.6131297541236,
                        117.00395817017291,
                        34.61315375387513,
                        116.99235516973867,
                        34.61431172517793,
                        116.99197616962203,
                        34.61919660475601,
                        116.99037317001499,
                        34.62192053782522,
                        116.99558916944032,
                        34.625542448204754,
                        116.99759216997886,
                        34.62651342438416,
                        116.99812916938097,
                        34.63052132571129,
                        116.99652216957597,
                        34.63241127902615,
                        116.99698117005867,
                        34.6355852010761,
                        116.99775216981253,
                        34.636254184924326,
                        116.99848417010666,
                        34.63704716481818,
                        116.9993491695719,
                        34.637078164414625,
                        117.00094016948339,
                        34.63907511551596,
                        117.00149017020262,
                        34.64113006438324,
                        117.00679216984173,
                        34.64368300181523,
                        117.01000416980195,
                        34.64366400238989,
                        117.01080916989105,
                        34.64356600466257,
                        117.01504017020059,
                        34.64131606002663,
                        117.01792216954962,
                        34.639331108741885,
                        117.02128716967073,
                        34.640028091988604,
                        117.02451717007263,
                        34.6404420813207,
                        117.02643316967418,
                        34.64355800452104,
                        117.03575616956051,
                        34.6458149490121,
                        117.0362661700968,
                        34.649922847807545,
                        117.03719517003447,
                        34.65026983983899,
                        117.03727416967718,
                        34.65115581801859,
                        117.04105516972493,
                        34.65158180746808,
                        117.04496717019221,
                        34.65426074127598,
                        117.04668117012741,
                        34.65501972226372,
                        117.05309816947695,
                        34.65550471041598,
                        117.05481116958721,
                        34.657148669702806,
                        117.05432816971351,
                        34.658584634366704,
                        117.05325716948565,
                        34.65979760514923,
                        117.05809316986773,
                        34.65635268986005,
                        117.05950317002923,
                        34.65035283787725,
                        117.06160916960147,
                        34.6442309881339,
                        117.06621216945662,
                        34.643976994422076,
                        117.06640317015066,
                        34.64117006374618,
                        117.06876917001394,
                        34.63964010167368,
                        117.07126616939851,
                        34.639643101619754,
                        117.07395316965221,
                        34.64028508529032,
                        117.07727517011561,
                        34.64169305068322,
                        117.07995416997343,
                        34.643866997215355,
                        117.08264016950389,
                        34.64603994375876,
                        117.08603116956435,
                        34.64961985568057,
                        117.091645169373,
                        34.65044983522312,
                        117.09407817008177,
                        34.65102382135517,
                        117.09810017015396,
                        34.65108181958432,
                        117.09977416990615,
                        34.65041283637513,
                        117.10016217024366,
                        34.64072707469482,
                        117.10548716944884,
                        34.63626918478674,
                        117.10793316967805,
                        34.63377724619196,
                        117.10930017018181,
                        34.63205828827629,
                        117.11021917007369,
                        34.63028833217953,
                        117.11116616955461,
                        34.62913835992351,
                        117.11184116994725,
                        34.62895936436474,
                        117.10945417016758,
                        34.62861137320706,
                        117.10172016964462,
                        34.62764639718709,
                        117.09959416998082,
                        34.62451147414963,
                        117.09610917020906,
                        34.62203253525222,
                        117.0906491694879,
                        34.621964536951204,
                        117.08654816977305,
                        34.62216053234187,
                        117.08380617016601,
                        34.62165854467992,
                        117.08046916963399,
                        34.6209915610734,
                        117.07603917003114,
                        34.62024457947489,
                        117.07439416969297,
                        34.61721865400534,
                        117.0744591699902,
                        34.61591468608932,
                        117.07686316948838,
                        34.61448372101147,
                        117.07972516964422,
                        34.613060755842916,
                        117.08145816984597,
                        34.612625766899725,
                        117.08152616961803,
                        34.606549916148715,
                        117.08246717014943,
                        34.60543594404027,
                        117.08145216999809,
                        34.60483895861176,
                        117.08090916984986,
                        34.60415797538974,
                        117.07939516993127,
                        34.60012407496205,
                        117.0790431695787,
                        34.5984721151523,
                        117.0715821697655,
                        34.597921128482355,
                        117.06938616978151,
                        34.59621817097643,
                        117.06941916939343,
                        34.588273366354315,
                        117.06967516948637,
                        34.58789437528342,
                        117.06820016992584,
                        34.584772452604646,
                        117.05831717017278,
                        34.58250750807189,
                        117.05480317008875,
                        34.5773776342473,
                        117.05347417011801,
                        34.575910670570615,
                        117.0534981695091,
                        34.571102788622106,
                        117.0537111699444
                    ],
                    "name": "魏庙镇"
                },
                {
                    "path": [
                        34.68913588137947,
                        117.00618916941959,
                        34.69056384622204,
                        117.00530217021313,
                        34.69180981553036,
                        117.00438216959806,
                        34.69262079565533,
                        117.0037841700966,
                        34.69461174650774,
                        117.00268516938138,
                        34.69993061508445,
                        116.999518169627,
                        34.70102258879715,
                        116.99822016961848,
                        34.702584549891064,
                        116.99258917009146,
                        34.70349652775969,
                        116.99228716996765,
                        34.70451150226718,
                        116.99195116950875,
                        34.70589946799603,
                        116.9904561698567,
                        34.70691744302476,
                        116.99167117002453,
                        34.70763542573329,
                        116.99168716991811,
                        34.71010136446633,
                        116.99329616937301,
                        34.713870271831574,
                        116.99250516952769,
                        34.71665720254955,
                        116.99170016943872,
                        34.72166307972545,
                        116.98858217008811,
                        34.72451500921034,
                        116.98668216948184,
                        34.725216991862176,
                        116.98764716940451,
                        34.725871975624294,
                        116.98871416943433,
                        34.72965288260609,
                        116.99443516937309,
                        34.731312841609494,
                        116.99721016949039,
                        34.733961776355244,
                        117.00192416967373,
                        34.73664171032669,
                        117.00277916999156,
                        34.740433616685564,
                        117.00408217002297,
                        34.740584612791736,
                        117.00444216987307,
                        34.74062161196759,
                        117.00489116941166,
                        34.74083560627203,
                        117.00550516970502,
                        34.74184158186221,
                        117.0066211701387,
                        34.74353354018157,
                        117.00877316974173,
                        34.7437145351333,
                        117.00924516974491,
                        34.74378453356072,
                        117.00974716988522,
                        34.7442465221298,
                        117.01026116972115,
                        34.748815409268005,
                        117.00653516992506,
                        34.75022237467157,
                        117.0118691702495,
                        34.752552317223454,
                        117.01862617025594,
                        34.751830335206286,
                        117.01925616954449,
                        34.753522293380065,
                        117.02204216953243,
                        34.754528268729736,
                        117.02369816974125,
                        34.75203333040632,
                        117.0257381700896,
                        34.75037637099653,
                        117.0269401698387,
                        34.74431352106643,
                        117.03290517017483,
                        34.73874265798866,
                        117.0388691697877,
                        34.731795829753054,
                        117.04869616946405,
                        34.726222967284926,
                        117.056679169509,
                        34.72456700821471,
                        117.05852416986369,
                        34.722662054612435,
                        117.06032616966237,
                        34.71864015453575,
                        117.06380316993646,
                        34.715606229368206,
                        117.06629316964833,
                        34.715123241290875,
                        117.06615717010422,
                        34.714075267059506,
                        117.06184116940582,
                        34.71324328736186,
                        117.05842116993142,
                        34.7154292333321,
                        117.05648517023842,
                        34.71521723857508,
                        117.05587716979285,
                        34.714195263773405,
                        117.05409416936237,
                        34.70779942145909,
                        117.04348316951321,
                        34.703749521616714,
                        117.03980816977061,
                        34.700139610014574,
                        117.03772817013756,
                        34.695164733017414,
                        117.03486116995875,
                        34.69199581120841,
                        117.0252521698421,
                        34.69054384713973,
                        117.02085317020133,
                        34.689496872621,
                        117.01500216966797,
                        34.687160930409945,
                        117.01121916997037,
                        34.68725592787312,
                        117.01084317022679,
                        34.6880499082239,
                        117.00769917003859,
                        34.68913588137947,
                        117.00618916941959
                    ],
                    "name": "沛县湖西农场管理委员会"
                },
                {
                    "path": [
                        34.691552821189134,
                        116.75611716943207,
                        34.69160781957202,
                        116.75445017025089,
                        34.69156682098777,
                        116.7527231698969,
                        34.69139782525147,
                        116.74987816945948,
                        34.69127782794565,
                        116.74894716987207,
                        34.68981586419939,
                        116.74848716956451,
                        34.68988286212029,
                        116.74419316950576,
                        34.68988586245611,
                        116.74409416977157,
                        34.687773914330144,
                        116.74415417004599,
                        34.68785291259638,
                        116.74263316955633,
                        34.687602918699774,
                        116.74256317013447,
                        34.68760291869837,
                        116.74204216972757,
                        34.68596195921174,
                        116.74194217016841,
                        34.68596095905047,
                        116.74127116997367,
                        34.6859109606662,
                        116.74122116974493,
                        34.683479020298975,
                        116.74089117003207,
                        34.68358701777797,
                        116.73782817003475,
                        34.68444799650405,
                        116.73783817008045,
                        34.684487995474946,
                        116.73694716977765,
                        34.68417700329916,
                        116.73694716977765,
                        34.684197002481675,
                        116.73595616991577,
                        34.683516019159875,
                        116.73583616936689,
                        34.68360401726722,
                        116.73283216981909,
                        34.68322402624571,
                        116.73270217012279,
                        34.68345302125269,
                        116.73096916992101,
                        34.68299303242139,
                        116.73089016937998,
                        34.683341023558704,
                        116.72860616953247,
                        34.6829210338355,
                        116.72850616997333,
                        34.68268203979916,
                        116.73010916958039,
                        34.682111054186365,
                        116.73000817019634,
                        34.68239004690258,
                        116.72836617023121,
                        34.68208905481879,
                        116.72822616959081,
                        34.68214905313336,
                        116.72794516938342,
                        34.68335102325183,
                        116.72822616959081,
                        34.6834300213086,
                        116.72755516939608,
                        34.6832800251735,
                        116.72749517001994,
                        34.68328002517333,
                        116.72743516974549,
                        34.68387901010964,
                        116.72579216995543,
                        34.68103608066045,
                        116.72530116968575,
                        34.68110507874534,
                        116.72459017020634,
                        34.6794931185182,
                        116.72420916954147,
                        34.67952411775262,
                        116.72483016950751,
                        34.67600020493896,
                        116.72410916998233,
                        34.676139200858096,
                        116.72343716996265,
                        34.67653919143989,
                        116.72232616955189,
                        34.676808184718126,
                        116.72165517025547,
                        34.67692818157013,
                        116.72156417001891,
                        34.68024210025337,
                        116.72206617015927,
                        34.68076208742611,
                        116.71870517023609,
                        34.67814615174085,
                        116.71828916941112,
                        34.6781851505492,
                        116.7179591696982,
                        34.67863313946787,
                        116.71548417005494,
                        34.67866313877477,
                        116.71542416978049,
                        34.679133127484754,
                        116.71551417019221,
                        34.679262123867915,
                        116.71447216937837,
                        34.67854114171922,
                        116.71436216977352,
                        34.678690138061185,
                        116.71292917004575,
                        34.67824914899606,
                        116.71283916963401,
                        34.67850614258823,
                        116.71069416970367,
                        34.6770551786105,
                        116.71051316995371,
                        34.677124177057905,
                        116.71002316950894,
                        34.676784185590684,
                        116.70996216940956,
                        34.6769931797599,
                        116.70953116941432,
                        34.67583220870451,
                        116.70933116939779,
                        34.67612020144225,
                        116.70855116942309,
                        34.67635119596329,
                        116.70795816994445,
                        34.67505922811214,
                        116.70778817006514,
                        34.67512822600603,
                        116.70725716961248,
                        34.67653019115615,
                        116.70742716949181,
                        34.67673918670486,
                        116.70687616984603,
                        34.67781016029913,
                        116.70696616935938,
                        34.67806715377542,
                        116.7046111693667,
                        34.67821714974897,
                        116.70436117001974,
                        34.68252204392499,
                        116.70477216992353,
                        34.68337802243029,
                        116.70473716976345,
                        34.68520397736158,
                        116.70485216939119,
                        34.685388972876154,
                        116.7012851696037,
                        34.68706093200623,
                        116.70157517003203,
                        34.68755991920424,
                        116.69474916953027,
                        34.68840089907637,
                        116.69483916994194,
                        34.68842089798072,
                        116.69515016938827,
                        34.688600893804335,
                        116.69520016961694,
                        34.68898188464529,
                        116.69506016987485,
                        34.68905788286769,
                        116.69265416982857,
                        34.69020885428924,
                        116.69269417001159,
                        34.69025685281431,
                        116.69162117013391,
                        34.6918688132526,
                        116.69169216938073,
                        34.69202880946033,
                        116.69152216950143,
                        34.6927287921894,
                        116.69155216963867,
                        34.69261179484106,
                        116.6930051694579,
                        34.69303178488963,
                        116.69301516950365,
                        34.69300278569376,
                        116.69338617012275,
                        34.69384276486093,
                        116.69297517021899,
                        34.69601571115648,
                        116.69333616989407,
                        34.69592771294367,
                        116.69474017020782,
                        34.69698868697602,
                        116.69484016976693,
                        34.69787966489944,
                        116.69501116947119,
                        34.697493675036384,
                        116.69719616958453,
                        34.699956614019946,
                        116.69776817004512,
                        34.699946614116676,
                        116.69800817024463,
                        34.70123858209334,
                        116.69830916964521,
                        34.70089259082168,
                        116.70093516979954,
                        34.70119058329455,
                        116.70102416948801,
                        34.70174656997489,
                        116.70115016988471,
                        34.70192156578646,
                        116.70016317022079,
                        34.70351352607553,
                        116.70030416978773,
                        34.703495527024025,
                        116.70126617023571,
                        34.704606498969916,
                        116.70130916989338,
                        34.70543747846427,
                        116.70133716948251,
                        34.70505248834009,
                        116.70459416964029,
                        34.705013489635725,
                        116.70564616960985,
                        34.70614446166627,
                        116.70577717002944,
                        34.706056463884806,
                        116.70679916985345,
                        34.706256458780906,
                        116.70685917012793,
                        34.70629545763941,
                        116.70639816999545,
                        34.70738743080288,
                        116.70651916947097,
                        34.70753242731938,
                        116.70311116969214,
                        34.70729143290292,
                        116.7030511694177,
                        34.70741942981459,
                        116.70126717006063,
                        34.70979137161024,
                        116.70124716996916,
                        34.70981037064225,
                        116.70103716990691,
                        34.711252335592725,
                        116.70101716981543,
                        34.71122133642498,
                        116.70034516978745,
                        34.709819370957966,
                        116.70035516984152,
                        34.70987736936648,
                        116.69884216974779,
                        34.715682226517934,
                        116.6986821699143,
                        34.71572322496556,
                        116.69936317015481,
                        34.71380227276569,
                        116.69953317003409,
                        34.71387527089235,
                        116.70141816967346,
                        34.715787223206426,
                        116.70126816988565,
                        34.71577622393926,
                        116.70097716963251,
                        34.71902914372252,
                        116.70077716961599,
                        34.719019143908525,
                        116.70064716991966,
                        34.719543130887914,
                        116.70062816965311,
                        34.71985012333311,
                        116.70061716978248,
                        34.71983712362613,
                        116.69903316954357,
                        34.71991612156057,
                        116.69903017006891,
                        34.72146808377009,
                        116.69896317012173,
                        34.721376085638724,
                        116.69752016944993,
                        34.721096092441435,
                        116.69755016958712,
                        34.72089109781536,
                        116.69480316995731,
                        34.722993046034,
                        116.69474316968287,
                        34.724754002736056,
                        116.69482317004885,
                        34.72481300069799,
                        116.69356017020039,
                        34.72515299274522,
                        116.69358117011683,
                        34.725171991939106,
                        116.6931391702509,
                        34.72641196183043,
                        116.69257816966105,
                        34.72683295124938,
                        116.69257816966105,
                        34.726851950795655,
                        116.69217716980307,
                        34.72829291500727,
                        116.69221716998605,
                        34.728242916360244,
                        116.6918061700823,
                        34.72829891510211,
                        116.68982116998545,
                        34.72902989723415,
                        116.68997216959825,
                        34.72908389543906,
                        116.69197716978655,
                        34.73056485871946,
                        116.69189716942063,
                        34.73060485828718,
                        116.69199716987805,
                        34.73139583874334,
                        116.69194716964934,
                        34.73139583874364,
                        116.69204717010679,
                        34.73220681840644,
                        116.69205316995453,
                        34.73281780382567,
                        116.69205816997746,
                        34.73292980099285,
                        116.69337117005458,
                        34.733430788332285,
                        116.69336117000891,
                        34.73360578429731,
                        116.69637816997547,
                        34.73429676676697,
                        116.6964381702499,
                        34.734513761414405,
                        116.70066916966115,
                        34.735164745595064,
                        116.70068916975266,
                        34.73535774108259,
                        116.70257316956713,
                        34.735877728155316,
                        116.70251317019095,
                        34.73643571404349,
                        116.70694316979387,
                        34.736598710552535,
                        116.7090571697621,
                        34.73763968453667,
                        116.7089371701115,
                        34.73765168412328,
                        116.71020016995993,
                        34.73738069095761,
                        116.71024017014295,
                        34.73748268879091,
                        116.71185316979573,
                        34.73778368090442,
                        116.7117331701452,
                        34.73860366076702,
                        116.71163316968772,
                        34.73866565922745,
                        116.71250516972391,
                        34.739185646154,
                        116.71238417024843,
                        34.73915464712495,
                        116.71204416959141,
                        34.74027561930232,
                        116.71178417019881,
                        34.740437615376315,
                        116.7126651695575,
                        34.738635660266915,
                        116.7131561698272,
                        34.73866665949223,
                        116.71408817013781,
                        34.74313054943194,
                        116.71313616973579,
                        34.743231546603084,
                        116.71384816993837,
                        34.742110573931065,
                        116.71404816995489,
                        34.7424235665372,
                        116.71640316994758,
                        34.742744558902146,
                        116.71627216952803,
                        34.742673560119435,
                        116.7156721694784,
                        34.743403542606316,
                        116.71552116986562,
                        34.743403542605705,
                        116.71530116975761,
                        34.744154523458526,
                        116.71516117001552,
                        34.74426552130749,
                        116.71658316987265,
                        34.74574748433324,
                        116.71648316941527,
                        34.74575848404261,
                        116.71723516980086,
                        34.74760043900524,
                        116.71734617012899,
                        34.74758943880453,
                        116.71714516938918,
                        34.74968238744325,
                        116.7172351698009,
                        34.74972038635736,
                        116.7160731702348,
                        34.74791843073517,
                        116.71592216972371,
                        34.74821642351147,
                        116.7140991700086,
                        34.74882740865068,
                        116.71416916943052,
                        34.748629413673314,
                        116.71570216961571,
                        34.74975038572262,
                        116.71581217011885,
                        34.74981838394589,
                        116.71434017003301,
                        34.752131326627065,
                        116.71471917014978,
                        34.7535092929753,
                        116.7149101699455,
                        34.75338529615514,
                        116.71678516953914,
                        34.75629822394305,
                        116.71714617011253,
                        34.756396221844525,
                        116.71530316940763,
                        34.75888916043452,
                        116.71550316942417,
                        34.758881160314104,
                        116.71734716995401,
                        34.76054311953956,
                        116.71727316943586,
                        34.76043512214296,
                        116.71157516996165,
                        34.76126710135489,
                        116.71186617021483,
                        34.76125310153126,
                        116.70934116944451,
                        34.761803088119926,
                        116.70930117015988,
                        34.76171909046009,
                        116.70675516947317,
                        34.7643020262418,
                        116.70655516945662,
                        34.76424802817606,
                        116.70413017004208,
                        34.76618098039406,
                        116.70399117012497,
                        34.766339976062035,
                        116.70398017025435,
                        34.76629297733947,
                        116.70305116941837,
                        34.767535946778004,
                        116.70295216968418,
                        34.767263953587566,
                        116.70027516947627,
                        34.77130285351872,
                        116.69994916996139,
                        34.77178184220432,
                        116.70482416980317,
                        34.77181884142705,
                        116.70625616970602,
                        34.773470800055705,
                        116.70632617002623,
                        34.77354179818784,
                        116.70701817013739,
                        34.77703471225805,
                        116.70666716960976,
                        34.77714270931483,
                        116.7052441699278,
                        34.777878691285515,
                        116.7052111694175,
                        34.77923465796497,
                        116.70511417023151,
                        34.77930165648483,
                        116.70336017011331,
                        34.77937165425741,
                        116.70331016988462,
                        34.781101611645106,
                        116.70326116948083,
                        34.78109061221459,
                        116.70156616981225,
                        34.78125060841556,
                        116.70155616976649,
                        34.78134560550135,
                        116.69990616940545,
                        34.78526250928015,
                        116.70008316985586,
                        34.78531850772964,
                        116.69771816981739,
                        34.78602949026049,
                        116.69773717008403,
                        34.78603649027621,
                        116.69591316964564,
                        34.7868374700602,
                        116.69600416988227,
                        34.786973466592336,
                        116.69370816944084,
                        34.78604248986526,
                        116.69348716950788,
                        34.786082489111465,
                        116.68821417018113,
                        34.78672347284392,
                        116.68820417013539,
                        34.78678947150487,
                        116.68593816983115,
                        34.78698946653985,
                        116.68592816978546,
                        34.78697946683541,
                        116.68553716997322,
                        34.78711946330966,
                        116.68553716997322,
                        34.787086463741055,
                        116.68377316980929,
                        34.78776444723208,
                        116.68351517006647,
                        34.789637401232,
                        116.68288116968169,
                        34.79110836473838,
                        116.68305116956098,
                        34.79132935908266,
                        116.68314116997269,
                        34.7912893601543,
                        116.68340217008857,
                        34.79425328734529,
                        116.6843001700641,
                        34.79459227872521,
                        116.6823341702339,
                        34.793970293781776,
                        116.6822391697993,
                        34.794207288610956,
                        116.68090616963065,
                        34.79552825564489,
                        116.68117017011961,
                        34.79550025656885,
                        116.68141716999185,
                        34.79652123079592,
                        116.6816181698333,
                        34.796383234653376,
                        116.68263217015975,
                        34.79862817893126,
                        116.68308317024646,
                        34.79869517719255,
                        116.68252116983169,
                        34.799705152531594,
                        116.6820501696535,
                        34.80279907602807,
                        116.68270816942949,
                        34.801857099123986,
                        116.68700317021143,
                        34.80278307618851,
                        116.68716916989275,
                        34.80272407786253,
                        116.68758317016955,
                        34.80257508152696,
                        116.68863517013081,
                        34.80556300804737,
                        116.6893131699983,
                        34.80523001572272,
                        116.69251716956265,
                        34.80564100568711,
                        116.69255716974557,
                        34.80581800164964,
                        116.69075316939875,
                        34.806277990088,
                        116.69082316971897,
                        34.80616999282403,
                        116.69177517012106,
                        34.80669997969234,
                        116.69184516954294,
                        34.80667098054811,
                        116.69200617009979,
                        34.80629099020402,
                        116.69225717016991,
                        34.80621199153467,
                        116.6927781696785,
                        34.80654198379928,
                        116.69281816986155,
                        34.80630598920469,
                        116.69540516965777,
                        34.80776795335251,
                        116.69551517016102,
                        34.807757953956724,
                        116.69570517013179,
                        34.81426679313585,
                        116.69622116961759,
                        34.81433279114403,
                        116.69622516981553,
                        34.81425079331193,
                        116.70140816962893,
                        34.81329381680409,
                        116.70140916945381,
                        34.81317581967184,
                        116.70320316975491,
                        34.8126558326876,
                        116.70316316957194,
                        34.812390839295006,
                        116.70673117008265,
                        34.812891826816795,
                        116.70680217022777,
                        34.81249383674864,
                        116.70889617010454,
                        34.815768755830625,
                        116.70952717011632,
                        34.816030749244675,
                        116.70742716949349,
                        34.81839269101043,
                        116.70774717005898,
                        34.8185126881083,
                        116.7063501694179,
                        34.820837630908215,
                        116.70364916981886,
                        34.822526588561175,
                        116.70393616987407,
                        34.82274558352243,
                        116.70272417007925,
                        34.82430754483088,
                        116.70288416991278,
                        34.82504352690466,
                        116.70020816952977,
                        34.82658548875948,
                        116.70041916941695,
                        34.82571951028749,
                        116.70330616968721,
                        34.82709147588187,
                        116.70386716937882,
                        34.82662448760473,
                        116.70597117019963,
                        34.828166449356765,
                        116.70635216996614,
                        34.82808745175017,
                        116.70670316959543,
                        34.82751046606533,
                        116.70926816965037,
                        34.828361444750435,
                        116.70958917004079,
                        34.827694460955065,
                        116.7125951701367,
                        34.82883643275738,
                        116.71282617011539,
                        34.828622438061224,
                        116.72029117012652,
                        34.83013240135694,
                        116.72489817017967,
                        34.83161736451913,
                        116.7294311697147,
                        34.83198635529628,
                        116.73055916984397,
                        34.8303573953673,
                        116.73958717017751,
                        34.82993240632846,
                        116.74194016962198,
                        34.81938466661054,
                        116.74084216962989,
                        34.81547176300317,
                        116.74183116984187,
                        34.81242983830484,
                        116.74259917012098,
                        34.81149186128732,
                        116.7428361699474,
                        34.81122986821491,
                        116.75344416942353,
                        34.81041588843716,
                        116.75689416993342,
                        34.808419937818094,
                        116.76533916993571,
                        34.80326706482174,
                        116.76547016945693,
                        34.80251508305812,
                        116.7742281694537,
                        34.804287039325,
                        116.77847516965683,
                        34.80916591875658,
                        116.78121316996419,
                        34.81115686991217,
                        116.78233117004771,
                        34.81243983798138,
                        116.78305116974789,
                        34.811624858239135,
                        116.78591717010178,
                        34.81510177279553,
                        116.79318217009639,
                        34.824744534593584,
                        116.796749169884,
                        34.82493652938323,
                        116.80009616956349,
                        34.822262595439845,
                        116.79961517023783,
                        34.820616636286154,
                        116.80057616996243,
                        34.8272504723979,
                        116.80692016951707,
                        34.82704947703988,
                        116.80904216988125,
                        34.825885506096164,
                        116.80890717016203,
                        34.824023552277275,
                        116.80869117025193,
                        34.812301841993204,
                        116.80540916997136,
                        34.810347890112794,
                        116.80486216962514,
                        34.805411012164996,
                        116.80685216974473,
                        34.80416604277337,
                        116.80831217013503,
                        34.79778619993834,
                        116.81579516968935,
                        34.79762420426616,
                        116.81686316954415,
                        34.788498429917965,
                        116.81463516977298,
                        34.78795144315753,
                        116.81450116987871,
                        34.787367457566965,
                        116.8064341701681,
                        34.789849396442456,
                        116.80410616993964,
                        34.78817643717668,
                        116.79600816936858,
                        34.78755945234293,
                        116.79302516973723,
                        34.7820355889853,
                        116.79239916974822,
                        34.78195759115607,
                        116.79199217004245,
                        34.779743645343814,
                        116.78049116971546,
                        34.775016762644135,
                        116.77995017011531,
                        34.773766793377845,
                        116.77668016953045,
                        34.76736095131055,
                        116.77426216978851,
                        34.76714095687243,
                        116.774430170018,
                        34.76220307873391,
                        116.7781861699513,
                        34.763619043714165,
                        116.78574717022192,
                        34.76303705779248,
                        116.78616016977546,
                        34.759372148319045,
                        116.78875917016549,
                        34.75632622396861,
                        116.78733817013335,
                        34.75328929872883,
                        116.78918517013781,
                        34.75179433536613,
                        116.79009416998393,
                        34.74892240635781,
                        116.78856016997379,
                        34.74727044731513,
                        116.78767816989183,
                        34.74237756788549,
                        116.78261817010208,
                        34.74007262493905,
                        116.78094116997677,
                        34.73544973864957,
                        116.78929616956738,
                        34.73447576313605,
                        116.7934451698611,
                        34.73347678725252,
                        116.79532016945477,
                        34.735523737173196,
                        116.79728117016049,
                        34.73617072110492,
                        116.80141717003546,
                        34.73642671466856,
                        116.80304916995487,
                        34.734840754151286,
                        116.80536916978741,
                        34.733999774592256,
                        116.80659917002387,
                        34.73479175535672,
                        116.80997917021367,
                        34.72287904884396,
                        116.8100551694832,
                        34.72163507947138,
                        116.8100631698791,
                        34.72093409713799,
                        116.80338816988841,
                        34.71939413452309,
                        116.80338717006349,
                        34.7139002704092,
                        116.80338717006343,
                        34.71353827947078,
                        116.79833016974841,
                        34.7057214721893,
                        116.79818917018133,
                        34.70402651398491,
                        116.79815817021917,
                        34.70165057245812,
                        116.80179516942856,
                        34.70027360619153,
                        116.79940416945081,
                        34.70013661013874,
                        116.79771616945497,
                        34.69683369117005,
                        116.79649316978941,
                        34.696407701733406,
                        116.79011516989964,
                        34.69524973049081,
                        116.78587216989449,
                        34.69564572015121,
                        116.77822117011061,
                        34.694051759772115,
                        116.77430216997054,
                        34.688716890998975,
                        116.77217916978147,
                        34.688542895457296,
                        116.77163516980825,
                        34.68643994767474,
                        116.76506617012282,
                        34.68568596577789,
                        116.76370816983977,
                        34.68732992525458,
                        116.76386017017579,
                        34.68798390901207,
                        116.76050116990241,
                        34.68821490366666,
                        116.75553016980113,
                        34.691552821189134,
                        116.75611716943207
                    ],
                    "name": "鹿楼镇"
                },
                {
                    "path": [
                        34.54869433930861,
                        116.86463117011466,
                        34.54939432228839,
                        116.86489016968247,
                        34.54943432128577,
                        116.86485117022265,
                        34.550659291531694,
                        116.86193416981523,
                        34.55029929998219,
                        116.86193416981523,
                        34.5504922955828,
                        116.86004716962775,
                        34.55020230258776,
                        116.8600261697113,
                        34.55036529858877,
                        116.85819916979827,
                        34.55001530747979,
                        116.85817916970674,
                        34.55014730362817,
                        116.85696117006415,
                        34.55230825081743,
                        116.85699117020143,
                        34.55268824163871,
                        116.85726116963986,
                        34.55305823233776,
                        116.85728116973134,
                        34.55326522693643,
                        116.85358616989731,
                        34.55279423869225,
                        116.85354616971435,
                        34.55283523781818,
                        116.85272716938158,
                        34.5525352449217,
                        116.8527471694731,
                        34.55219425374029,
                        116.85310616949832,
                        34.55165626677002,
                        116.85167816979337,
                        34.55033629905075,
                        116.85163916943532,
                        34.55033729936409,
                        116.85092016956003,
                        34.549856311313036,
                        116.85089016942277,
                        34.5499693082992,
                        116.84931216993007,
                        34.55236124921782,
                        116.84945216967213,
                        34.55251624533266,
                        116.84635716988778,
                        34.55206625681641,
                        116.84631716970478,
                        34.55268924115181,
                        116.84468016976253,
                        34.55380021375237,
                        116.84472016994548,
                        34.553763214712404,
                        116.84320316965385,
                        34.55465319273714,
                        116.84324316983684,
                        34.55468519227917,
                        116.84228416976201,
                        34.55669714300268,
                        116.84234417003651,
                        34.55673014199507,
                        116.84066716991126,
                        34.55641014942132,
                        116.84065716986552,
                        34.556585145759826,
                        116.83804216958185,
                        34.55452419637574,
                        116.83795217006843,
                        34.55450319672836,
                        116.83815116936177,
                        34.5543032018943,
                        116.83816116940747,
                        34.55430220162753,
                        116.83847017010231,
                        34.55362221810301,
                        116.83845116983565,
                        34.55308523176855,
                        116.83658416973965,
                        34.554066207674005,
                        116.83652416946519,
                        34.55451719599519,
                        116.83600516960645,
                        34.554537196114325,
                        116.83588516995583,
                        34.553747215484364,
                        116.83589517000159,
                        34.55379921419103,
                        116.83456716985579,
                        34.552778239246244,
                        116.83453716971853,
                        34.55225225215931,
                        116.83235116978031,
                        34.55201325816816,
                        116.83172216941833,
                        34.55088628561949,
                        116.82972516962599,
                        34.55043729673961,
                        116.82920616976719,
                        34.55047829554781,
                        116.8286171695882,
                        34.5506882908483,
                        116.82829816974595,
                        34.54761736576624,
                        116.82785816952989,
                        34.54763836567116,
                        116.82744917017425,
                        34.54790835923424,
                        116.82749916950465,
                        34.547959357549054,
                        116.82712016938797,
                        34.54764936505507,
                        116.8270801701033,
                        34.5477133635984,
                        116.8264811698786,
                        34.54781136127254,
                        116.82558316990311,
                        34.548162352373836,
                        116.82558316990311,
                        34.548242350793345,
                        116.82531316956639,
                        34.54824335039276,
                        116.82489417016507,
                        34.550514294981674,
                        116.82503416990718,
                        34.55052629429775,
                        116.82440516954519,
                        34.548154352597926,
                        116.82422516962012,
                        34.54823735056406,
                        116.82287716938286,
                        34.55058829296155,
                        116.82307817012267,
                        34.55107728069973,
                        116.81828617012155,
                        34.55065729153043,
                        116.81824616993859,
                        34.55079128801853,
                        116.81648916944742,
                        34.5526022434347,
                        116.81657916985914,
                        34.552855237499834,
                        116.81497117022916,
                        34.55327322684155,
                        116.81088916988254,
                        34.55457319521433,
                        116.81109817011993,
                        34.55450219639156,
                        116.81171716953781,
                        34.556653143497904,
                        116.81203717010331,
                        34.55657514550405,
                        116.81112816935885,
                        34.55634715106643,
                        116.80984016939607,
                        34.55561416943957,
                        116.80786517024328,
                        34.55466219278726,
                        116.80613617023951,
                        34.55454319540178,
                        116.8057671701686,
                        34.55453519550207,
                        116.80537717018123,
                        34.55475519058254,
                        116.80433916956537,
                        34.5540942070165,
                        116.80427917018922,
                        34.55428920174672,
                        116.80157316966893,
                        34.55356022011474,
                        116.80086416983934,
                        34.55266024158099,
                        116.80014516996401,
                        34.55272224013425,
                        116.7987371694523,
                        34.5535132211556,
                        116.79884716995547,
                        34.55366021736383,
                        116.79672016956845,
                        34.55367621658822,
                        116.79651016950613,
                        34.55512718146281,
                        116.79673016961421,
                        34.55516818017913,
                        116.79598116960167,
                        34.555739166022875,
                        116.79614116943524,
                        34.55544417377702,
                        116.79906717006355,
                        34.555894162519884,
                        116.79914716953117,
                        34.55618015540188,
                        116.79534217009231,
                        34.55827110365731,
                        116.79551216997172,
                        34.55839410101764,
                        116.7938641701587,
                        34.5613860275121,
                        116.79425316942284,
                        34.56152502390546,
                        116.7944731695309,
                        34.562385002560916,
                        116.79511316976345,
                        34.56290498969355,
                        116.79538317010027,
                        34.565566924014455,
                        116.79590216995909,
                        34.56571792090056,
                        116.79493316983852,
                        34.566888892203245,
                        116.79508316962634,
                        34.5671328861847,
                        116.7937931700137,
                        34.56742387871162,
                        116.79380317005946,
                        34.56749687707981,
                        116.79323016977402,
                        34.56809286221361,
                        116.79328616985053,
                        34.56818286022981,
                        116.79303616960527,
                        34.56902283924272,
                        116.79308616983398,
                        34.5695208273825,
                        116.78813216945116,
                        34.56956082631913,
                        116.78804216993781,
                        34.57107178882274,
                        116.7882021697714,
                        34.571173786607574,
                        116.78647416959251,
                        34.569342831357176,
                        116.78625416948441,
                        34.56936283086903,
                        116.78559417005873,
                        34.56902283922228,
                        116.78554416982999,
                        34.56911483714748,
                        116.7841161701251,
                        34.568073862471394,
                        116.78398616953041,
                        34.5683678556906,
                        116.78062516960726,
                        34.56842885427545,
                        116.77946916988894,
                        34.56801886422692,
                        116.77945016962236,
                        34.56801986432905,
                        116.77925016960577,
                        34.56707888740463,
                        116.77919017022961,
                        34.56709888672181,
                        116.77873016992207,
                        34.57085179396605,
                        116.77890016980143,
                        34.57089279306957,
                        116.77855116982201,
                        34.571012790061694,
                        116.77857116991349,
                        34.57104278983642,
                        116.77820117001761,
                        34.5729337428344,
                        116.77832116966827,
                        34.573894719236755,
                        116.77849116954758,
                        34.574176712245944,
                        116.77617216953989,
                        34.57462770099979,
                        116.77623316963931,
                        34.574748698537476,
                        116.7751331699975,
                        34.5768296474608,
                        116.77534317005974,
                        34.57694064479865,
                        116.7740941695567,
                        34.57472969885836,
                        116.77381417007255,
                        34.57476969750631,
                        116.77303417009784,
                        34.57411971354506,
                        116.77292416959467,
                        34.5741507129672,
                        116.77250517019336,
                        34.57526068589387,
                        116.77264417011047,
                        34.57536168296541,
                        116.77167516998996,
                        34.576191662637434,
                        116.77174216993711,
                        34.58368947861315,
                        116.77223116965871,
                        34.58502844535832,
                        116.77227616986457,
                        34.58510844308163,
                        116.77220616954439,
                        34.58659340717916,
                        116.77232316972031,
                        34.58789137489165,
                        116.77242616965245,
                        34.58911134524277,
                        116.77284616977701,
                        34.59283425334822,
                        116.77357616952305,
                        34.5928942519277,
                        116.77352617019261,
                        34.59294525075829,
                        116.77277717018013,
                        34.59937909203841,
                        116.7732171694979,
                        34.60018107273666,
                        116.77277817000511,
                        34.600241071185835,
                        116.77268816959341,
                        34.60014107374582,
                        116.77261716944835,
                        34.600309069523355,
                        116.77245516996493,
                        34.60155303886759,
                        116.77327816959732,
                        34.602390018021396,
                        116.77440116970372,
                        34.602675011011335,
                        116.77539816941335,
                        34.602564014040695,
                        116.77930016983493,
                        34.60167003540946,
                        116.78157916965958,
                        34.60159603778173,
                        116.78391216991099,
                        34.60171803495087,
                        116.78608416960554,
                        34.601485040106155,
                        116.78697516990829,
                        34.60153703928379,
                        116.78859517013213,
                        34.60260701242836,
                        116.78880816966918,
                        34.60326799630929,
                        116.78836316943026,
                        34.604498966369526,
                        116.78791817008963,
                        34.605783934698486,
                        116.78775917008103,
                        34.606781909660874,
                        116.78797216961802,
                        34.607119901372464,
                        116.7886491696606,
                        34.60688290762536,
                        116.79286917009944,
                        34.60598692961582,
                        116.79577016971511,
                        34.6048259578299,
                        116.79692717015662,
                        34.60425297185457,
                        116.79776317020779,
                        34.60419797390429,
                        116.79899116989614,
                        34.604588964187286,
                        116.80004217003248,
                        34.60455796502842,
                        116.80056616991415,
                        34.60447896647438,
                        116.80143016955442,
                        34.60448796641406,
                        116.80393916953281,
                        34.6044929662211,
                        116.80726316964613,
                        34.60450196615769,
                        116.80919116984151,
                        34.604404968419026,
                        116.81379816989471,
                        34.60445296711552,
                        116.81696516964915,
                        34.60434397036484,
                        116.81762417014825,
                        34.604004978039235,
                        116.818068169664,
                        34.60277400878894,
                        116.81806816966395,
                        34.60198802826834,
                        116.81824616993919,
                        34.601275045246105,
                        116.81824616993919,
                        34.60038106752499,
                        116.81913616951873,
                        34.59930509397528,
                        116.82240916957834,
                        34.599981077729524,
                        116.82345916988973,
                        34.59998007727314,
                        116.82390417012869,
                        34.60152903956993,
                        116.82550517008593,
                        34.60159603789991,
                        116.82755116938387,
                        34.60120104728877,
                        116.82883216967396,
                        34.601412042127144,
                        116.83089616941348,
                        34.602480016028835,
                        116.83173317018789,
                        34.60280000801551,
                        116.8326221699425,
                        34.6027980079102,
                        116.8335651701238,
                        34.60308100087837,
                        116.83472216966707,
                        34.604362969974524,
                        116.83612816963067,
                        34.60502095348134,
                        116.83739116947913,
                        34.605011953608,
                        116.83806816952168,
                        34.605066952510285,
                        116.84139517000797,
                        34.60529394678464,
                        116.84411716952341,
                        34.604894956646525,
                        116.84751616997974,
                        34.60504695274557,
                        116.8525701699217,
                        34.60495995517256,
                        116.85314716950678,
                        34.60483095850153,
                        116.85401117004537,
                        34.605221948761326,
                        116.85490116962491,
                        34.606095927328994,
                        116.85474116979137,
                        34.6080588784089,
                        116.85451016981271,
                        34.61091280835128,
                        116.85445717010931,
                        34.611073804469186,
                        116.85435016997918,
                        34.615444696834615,
                        116.85379916943513,
                        34.616473671642794,
                        116.85381617005187,
                        34.61872661583695,
                        116.8538531698618,
                        34.620348575875084,
                        116.85469016973794,
                        34.620721566943985,
                        116.85591716960134,
                        34.621048558824455,
                        116.86396316939553,
                        34.621277553418096,
                        116.86547717021246,
                        34.621544546769556,
                        116.86636716979197,
                        34.621744541723864,
                        116.86657916950409,
                        34.62243552449963,
                        116.8673101699733,
                        34.62198653542377,
                        116.86909116985564,
                        34.62203953451861,
                        116.86987417020337,
                        34.62182453958174,
                        116.87076516960781,
                        34.61974659092731,
                        116.87758617008663,
                        34.619745590712576,
                        116.87931416936719,
                        34.61908360693277,
                        116.88127316952473,
                        34.619058607897976,
                        116.88151816974712,
                        34.61890361164394,
                        116.88300116970362,
                        34.619080606997876,
                        116.88426617010025,
                        34.619077607067055,
                        116.88879216996254,
                        34.61829262660848,
                        116.89012816960593,
                        34.615277700999556,
                        116.89062716937318,
                        34.613278750208394,
                        116.89346017011502,
                        34.61176178726074,
                        116.89495817014007,
                        34.60887185910377,
                        116.89428016937431,
                        34.60413997494493,
                        116.89238116949113,
                        34.60362798804464,
                        116.89217616945169,
                        34.602075026205405,
                        116.89461816948302,
                        34.602395018288156,
                        116.90085817017885,
                        34.60197002882472,
                        116.90158616937666,
                        34.6008960553057,
                        116.90342616970851,
                        34.59932709408964,
                        116.90512016955218,
                        34.59804312543269,
                        116.90886616943975,
                        34.597938128112474,
                        116.90895216965349,
                        34.595867178899816,
                        116.91064916987017,
                        34.59315624549163,
                        116.91102416978893,
                        34.59289025235726,
                        116.9148781696316,
                        34.589978324026156,
                        116.9160941696243,
                        34.58937033864413,
                        116.91693916989634,
                        34.58909634569636,
                        116.92335617014415,
                        34.58988332602707,
                        116.92524917017951,
                        34.590615308222915,
                        116.9260881697054,
                        34.590440312504356,
                        116.92855216947797,
                        34.589602332906374,
                        116.92966016951571,
                        34.58939133840225,
                        116.93183916978134,
                        34.589055346724436,
                        116.93401817004691,
                        34.58879435303855,
                        116.93864517019159,
                        34.588963348690676,
                        116.93923816967013,
                        34.58924334192092,
                        116.94021716983647,
                        34.58689439958294,
                        116.94063216993818,
                        34.58549843429571,
                        116.94087816998547,
                        34.58294849720668,
                        116.94155716967778,
                        34.5806105546404,
                        116.94066316990022,
                        34.57516968857043,
                        116.93723316948173,
                        34.57451670470449,
                        116.93718716945095,
                        34.57446770570653,
                        116.93695717019548,
                        34.57363772583584,
                        116.93702516996757,
                        34.573166737553095,
                        116.93594416969398,
                        34.5716917738003,
                        116.93175316956739,
                        34.57123078549016,
                        116.93044316986327,
                        34.569265833902456,
                        116.92837116972781,
                        34.565877916815346,
                        116.92899616989172,
                        34.56102403649566,
                        116.92715616955982,
                        34.55511918197136,
                        116.92636916991238,
                        34.555104181797915,
                        116.92477916982578,
                        34.55505918348047,
                        116.91988916991535,
                        34.55610915753663,
                        116.91631916975486,
                        34.55721413041644,
                        116.91387517007375,
                        34.55760512055983,
                        116.90884316987305,
                        34.55275323969368,
                        116.90884316987302,
                        34.54797235780075,
                        116.90900316970657,
                        34.54790135926046,
                        116.908077170142,
                        34.547739363208514,
                        116.90598216954203,
                        34.54741937082029,
                        116.90183317014655,
                        34.54831134929313,
                        116.89632317009504,
                        34.55400220899591,
                        116.89554016974738,
                        34.55425420295723,
                        116.88735517003602,
                        34.55147827108646,
                        116.88721216992087,
                        34.55333422558894,
                        116.87975117010771,
                        34.55338722408538,
                        116.87578216973907,
                        34.553340225029366,
                        116.87406916962874,
                        34.54900633229593,
                        116.87351616943475,
                        34.54715137778231,
                        116.87390816997018,
                        34.547296374169036,
                        116.87249316978578,
                        34.547493369253296,
                        116.87056016956751,
                        34.54869433930861,
                        116.86463117011466
                    ],
                    "name": "河口镇"
                },
                {
                    "path": [
                        34.86564552351426,
                        116.80144316997631,
                        34.86391456644739,
                        116.79168317024697,
                        34.86626250807513,
                        116.78590516950855,
                        34.868989440575675,
                        116.78389416947249,
                        34.8746033017392,
                        116.7830851700839,
                        34.88110614135374,
                        116.78584517013259,
                        34.88234011045042,
                        116.78636917001421,
                        34.883154090269464,
                        116.78499016981485,
                        34.88315509024757,
                        116.78353617017069,
                        34.88316009014411,
                        116.77860017022952,
                        34.88361907907711,
                        116.76775816950341,
                        34.883719076647004,
                        116.76539716966298,
                        34.886329012353414,
                        116.76314116940445,
                        34.88626501372876,
                        116.75882717015263,
                        34.8864630090524,
                        116.75273616941969,
                        34.887724977430175,
                        116.74450916987561,
                        34.887777976459326,
                        116.74416616974393,
                        34.88983892509017,
                        116.74361816957287,
                        34.89302684652321,
                        116.74422517019352,
                        34.89648376053139,
                        116.74484716998451,
                        34.896772753625974,
                        116.74339917018814,
                        34.8977447299347,
                        116.74364816971018,
                        34.89996767482806,
                        116.74382816963525,
                        34.90040766411919,
                        116.74377917012977,
                        34.901477637207435,
                        116.74031516937617,
                        34.90184862801024,
                        116.74042616970424,
                        34.90203862313968,
                        116.73973516941803,
                        34.902134621380185,
                        116.73365816982714,
                        34.903676583256846,
                        116.73436016998403,
                        34.90380658002285,
                        116.73299816950309,
                        34.90444656355728,
                        116.73335917007645,
                        34.904497562669135,
                        116.73323816970263,
                        34.9045465615696,
                        116.73326916966474,
                        34.905648534036395,
                        116.73394917008035,
                        34.90638851592525,
                        116.73275817020189,
                        34.90734049224563,
                        116.73347916972705,
                        34.90743048986911,
                        116.73346916968131,
                        34.90852046290903,
                        116.73153616946311,
                        34.910070424393695,
                        116.7301751697053,
                        34.910791407054816,
                        116.72934416967703,
                        34.91211137435746,
                        116.72773216984915,
                        34.91278135768202,
                        116.7265701693847,
                        34.913020351563254,
                        116.72632917025858,
                        34.91338134269493,
                        116.72632017003781,
                        34.917647237142454,
                        116.72805317023955,
                        34.92066116296726,
                        116.7291851696685,
                        34.921783134768454,
                        116.7297761694973,
                        34.923946081437094,
                        116.73022616975909,
                        34.926706012791364,
                        116.73069416956429,
                        34.926682013423886,
                        116.73090416962657,
                        34.9265850164293,
                        116.73126416947667,
                        34.92635002230783,
                        116.73185916950345,
                        34.92425307390328,
                        116.73748917010383,
                        34.92305910368471,
                        116.74107517015794,
                        34.92242011890416,
                        116.74138716942919,
                        34.9214021446253,
                        116.74159116964366,
                        34.91878520907167,
                        116.74146716979507,
                        34.91782023269963,
                        116.7417531700253,
                        34.91615527436787,
                        116.74783416981411,
                        34.91623427211531,
                        116.74870816950009,
                        34.916791258387015,
                        116.7494241699007,
                        34.91891420597205,
                        116.75170516937526,
                        34.9195731896779,
                        116.75236516969933,
                        34.91907320226001,
                        116.75553917002475,
                        34.91905520234985,
                        116.75570317005631,
                        34.91863921306637,
                        116.75949016994045,
                        34.918572214458806,
                        116.76009316947618,
                        34.91854421524446,
                        116.76035117011733,
                        34.91837321962897,
                        116.76352816991752,
                        34.918345220347355,
                        116.7640411699285,
                        34.918541215135896,
                        116.7671381693627,
                        34.92023717315304,
                        116.76832116974357,
                        34.92184713380484,
                        116.76973616992797,
                        34.9226381136884,
                        116.77043217023707,
                        34.92468706297306,
                        116.77083916994286,
                        34.925394045498805,
                        116.77097916968502,
                        34.92746399454867,
                        116.77209816959342,
                        34.930219926304325,
                        116.77264516993965,
                        34.93022092644985,
                        116.77264516993965,
                        34.932285875376024,
                        116.7731921693875,
                        34.93347484558551,
                        116.77355116941276,
                        34.934121829754595,
                        116.77374717012962,
                        34.93825672765225,
                        116.77485017014459,
                        34.94032267608907,
                        116.77568316982273,
                        34.94088666244254,
                        116.77618316941492,
                        34.943258603671474,
                        116.7782861695126,
                        34.94266161838918,
                        116.78198816991758,
                        34.94082766376548,
                        116.79337117024374,
                        34.94622053018455,
                        116.79267816940946,
                        34.94936545228911,
                        116.78122317001157,
                        34.951198406798525,
                        116.78074416943747,
                        34.9639790907827,
                        116.77740616997897,
                        34.96325910851207,
                        116.77997117003397,
                        34.961884142503024,
                        116.7848701701652,
                        34.97598479364242,
                        116.78486416941925,
                        34.97716076429605,
                        116.78486416941925,
                        34.972426881300244,
                        116.79944416963697,
                        34.97151090456173,
                        116.79944816983499,
                        34.9303839220896,
                        116.79961617006397,
                        34.93006093035877,
                        116.80720316937554,
                        34.930021931230144,
                        116.80811616941959,
                        34.96958095174581,
                        116.80463116964835,
                        34.970879919803004,
                        116.80451716984557,
                        34.96966495010741,
                        116.807687169973,
                        34.968750972758755,
                        116.80935716952722,
                        34.9681439878346,
                        116.81036016998297,
                        34.96737000651992,
                        116.81164016954988,
                        34.94731350336002,
                        116.81513416954215,
                        34.93137989773353,
                        116.81791016948411,
                        34.93139289723102,
                        116.81798917002514,
                        34.92631102311479,
                        116.81639317009069,
                        34.924833059465605,
                        116.82587816946038,
                        34.92237012034541,
                        116.82540616945724,
                        34.920047178320694,
                        116.83229916990614,
                        34.9195201914965,
                        116.83386016968043,
                        34.92412907722509,
                        116.84051217010492,
                        34.92592703281077,
                        116.84063416940535,
                        34.92603003029085,
                        116.8406411699764,
                        34.92602802989802,
                        116.84076417000001,
                        34.92592603263146,
                        116.84746417010507,
                        34.925854034571174,
                        116.8521861697859,
                        34.92342809478209,
                        116.85374417008548,
                        34.9236960877561,
                        116.85042216962208,
                        34.92373108675953,
                        116.84061216966406,
                        34.91538229337876,
                        116.83994317001732,
                        34.916070276350254,
                        116.8356361695398,
                        34.91394532892507,
                        116.83476117002887,
                        34.90197962547102,
                        116.83452017000425,
                        34.90148063747625,
                        116.83451016995849,
                        34.89317984244043,
                        116.83434316955385,
                        34.88881295080064,
                        116.82443717023463,
                        34.88824596492,
                        116.82501116944667,
                        34.883370085488764,
                        116.82994616956282,
                        34.87721223738755,
                        116.83617816986262,
                        34.875281285214534,
                        116.83733716995403,
                        34.87398831740751,
                        116.83653916953767,
                        34.87554527879967,
                        116.83653916953767,
                        34.875839271452314,
                        116.83203416959174,
                        34.8773572340626,
                        116.82908316974739,
                        34.876332259281234,
                        116.82634916963804,
                        34.87230035879363,
                        116.81287917000601,
                        34.86688849268357,
                        116.81049516970094,
                        34.866258508116175,
                        116.80590716991438,
                        34.86564552351426,
                        116.80144316997631
                    ],
                    "name": "龙固镇"
                },
                {
                    "path": [
                        34.616473671642794,
                        116.85381617005187,
                        34.615444696834615,
                        116.85379916943513,
                        34.611073804469186,
                        116.85435016997918,
                        34.61091280835128,
                        116.85445717010931,
                        34.6080588784089,
                        116.85451016981271,
                        34.606095927328994,
                        116.85474116979137,
                        34.605221948761326,
                        116.85490116962491,
                        34.60483095850153,
                        116.85401117004537,
                        34.60495995517256,
                        116.85314716950678,
                        34.60504695274557,
                        116.8525701699217,
                        34.604894956646525,
                        116.84751616997974,
                        34.60529394678464,
                        116.84411716952341,
                        34.605066952510285,
                        116.84139517000797,
                        34.605011953608,
                        116.83806816952168,
                        34.60502095348134,
                        116.83739116947913,
                        34.604362969974524,
                        116.83612816963067,
                        34.60308100087837,
                        116.83472216966707,
                        34.6027980079102,
                        116.8335651701238,
                        34.60280000801551,
                        116.8326221699425,
                        34.602480016028835,
                        116.83173317018789,
                        34.601412042127144,
                        116.83089616941348,
                        34.60120104728877,
                        116.82883216967396,
                        34.60159603789991,
                        116.82755116938387,
                        34.60152903956993,
                        116.82550517008593,
                        34.59998007727314,
                        116.82390417012869,
                        34.599981077729524,
                        116.82345916988973,
                        34.59930509397528,
                        116.82240916957834,
                        34.60038106752499,
                        116.81913616951873,
                        34.601275045246105,
                        116.81824616993919,
                        34.60198802826834,
                        116.81824616993919,
                        34.60277400878894,
                        116.81806816966395,
                        34.604004978039235,
                        116.818068169664,
                        34.60434397036484,
                        116.81762417014825,
                        34.60445296711552,
                        116.81696516964915,
                        34.604404968419026,
                        116.81379816989471,
                        34.60450196615769,
                        116.80919116984151,
                        34.6044929662211,
                        116.80726316964613,
                        34.60448796641406,
                        116.80393916953281,
                        34.60447896647438,
                        116.80143016955442,
                        34.60455796502842,
                        116.80056616991415,
                        34.604588964187286,
                        116.80004217003248,
                        34.60419797390429,
                        116.79899116989614,
                        34.60425297185457,
                        116.79776317020779,
                        34.6048259578299,
                        116.79692717015662,
                        34.60598692961582,
                        116.79577016971511,
                        34.60688290762536,
                        116.79286917009944,
                        34.607119901372464,
                        116.7886491696606,
                        34.606781909660874,
                        116.78797216961802,
                        34.605783934698486,
                        116.78775917008103,
                        34.604498966369526,
                        116.78791817008963,
                        34.60326799630929,
                        116.78836316943026,
                        34.60260701242836,
                        116.78880816966918,
                        34.60153703928379,
                        116.78859517013213,
                        34.601485040106155,
                        116.78697516990829,
                        34.60171803495087,
                        116.78608416960554,
                        34.60159603778173,
                        116.78391216991099,
                        34.60167003540946,
                        116.78157916965958,
                        34.602564014040695,
                        116.77930016983493,
                        34.602675011011335,
                        116.77539816941335,
                        34.602390018021396,
                        116.77440116970372,
                        34.60155303886759,
                        116.77327816959732,
                        34.600309069523355,
                        116.77245516996493,
                        34.60084205595922,
                        116.77180817005959,
                        34.6019730282958,
                        116.77203817021339,
                        34.602063025858484,
                        116.77131816961487,
                        34.601463040744605,
                        116.77117916969767,
                        34.60146304074448,
                        116.77112816964406,
                        34.60470796084057,
                        116.76776017004823,
                        34.605597939229895,
                        116.76848016974847,
                        34.610291823758445,
                        116.76870016985654,
                        34.610450819682384,
                        116.7700801698809,
                        34.61296275733461,
                        116.77020016953149,
                        34.61300275680523,
                        116.77100016959766,
                        34.61446372043095,
                        116.77109017000937,
                        34.614573718228776,
                        116.77146917012605,
                        34.61772664032392,
                        116.77168017001331,
                        34.619106606688824,
                        116.77188017002987,
                        34.61949459706331,
                        116.77171716982326,
                        34.61944759768422,
                        116.77192316968758,
                        34.62205853346048,
                        116.77225016992577,
                        34.622230529263994,
                        116.7710711697429,
                        34.62251552213597,
                        116.76269316968775,
                        34.624927462712485,
                        116.7627731700537,
                        34.62529845358289,
                        116.75970316948535,
                        34.62873136944158,
                        116.76016416961781,
                        34.628751368703604,
                        116.7596741700714,
                        34.632715271514904,
                        116.76039416977164,
                        34.63245427755273,
                        116.76164417009957,
                        34.632874267354964,
                        116.76172416956726,
                        34.63280426895669,
                        116.7620141699955,
                        34.6335842501032,
                        116.76219416991259,
                        34.633444252969284,
                        116.7634141701113,
                        34.6343502307042,
                        116.7635531700285,
                        34.63446822834866,
                        116.76357116957185,
                        34.6392291104223,
                        116.7643451696988,
                        34.64127006045676,
                        116.76474516973192,
                        34.641330058771565,
                        116.76481417022717,
                        34.64126006085844,
                        116.76542517014745,
                        34.64391199535149,
                        116.76598517001415,
                        34.64413299024739,
                        116.76422517004823,
                        34.64542495847598,
                        116.76126616980801,
                        34.64611694123703,
                        116.75895617002116,
                        34.64636693471511,
                        116.75987616973796,
                        34.64649693175771,
                        116.75771516991405,
                        34.64878887519156,
                        116.75806616954335,
                        34.64911986673037,
                        116.75602516937005,
                        34.65187179914711,
                        116.7564961695483,
                        34.6519217981253,
                        116.75593616968162,
                        34.65391374890659,
                        116.75631616962328,
                        34.653983747221865,
                        116.75575616975658,
                        34.65470872947954,
                        116.75595016992536,
                        34.65663668167893,
                        116.75646616941111,
                        34.6562856905873,
                        116.75845616953083,
                        34.65749666074658,
                        116.75870716960095,
                        34.65736666395434,
                        116.75976716995817,
                        34.65782665249409,
                        116.7598141698138,
                        34.65863663243729,
                        116.75989716965451,
                        34.658667632084345,
                        116.75922717018302,
                        34.65962860806005,
                        116.75929716960489,
                        34.65971860590161,
                        116.75707717022975,
                        34.66214054642507,
                        116.75710716946865,
                        34.662161545461416,
                        116.75488717009354,
                        34.66306252349943,
                        116.75498716965265,
                        34.66318252031818,
                        116.75620716984344,
                        34.664162496303064,
                        116.75617716970613,
                        34.66410349794031,
                        116.75562716988529,
                        34.66631544300394,
                        116.75563716993105,
                        34.666553437351205,
                        116.76196816996512,
                        34.67383025807631,
                        116.76191916956142,
                        34.673556264678005,
                        116.76858816970432,
                        34.67598720511508,
                        116.76846717022882,
                        34.67903113022315,
                        116.7684081697793,
                        34.679303123506884,
                        116.76498917012985,
                        34.68176606229283,
                        116.76521916938533,
                        34.68180606182052,
                        116.76427916957701,
                        34.68336702344896,
                        116.76440917017173,
                        34.683577018185325,
                        116.76479016993825,
                        34.683698015015565,
                        116.76349016938158,
                        34.68568596577789,
                        116.76370816983977,
                        34.68643994767474,
                        116.76506617012282,
                        34.688542895457296,
                        116.77163516980825,
                        34.688716890998975,
                        116.77217916978147,
                        34.694051759772115,
                        116.77430216997054,
                        34.69564572015121,
                        116.77822117011061,
                        34.69524973049081,
                        116.78587216989449,
                        34.696407701733406,
                        116.79011516989964,
                        34.69683369117005,
                        116.79649316978941,
                        34.70013661013874,
                        116.79771616945497,
                        34.70027360619153,
                        116.79940416945081,
                        34.70165057245812,
                        116.80179516942856,
                        34.70191356632984,
                        116.80225116953815,
                        34.702108561089965,
                        116.80598217025545,
                        34.702144560553336,
                        116.81226516971061,
                        34.70023160752742,
                        116.81455416958111,
                        34.700178608938344,
                        116.81483216941541,
                        34.699057636626165,
                        116.82068217012389,
                        34.69887864065365,
                        116.82199517020106,
                        34.697719669290066,
                        116.83050717015051,
                        34.69754367344241,
                        116.83407216938988,
                        34.6974136767223,
                        116.83671116996297,
                        34.69594971345337,
                        116.83980616974735,
                        34.69502873616556,
                        116.84277716968315,
                        34.69463574518112,
                        116.8455931698083,
                        34.69413475766442,
                        116.84819317002335,
                        34.69375876724076,
                        116.85178917012317,
                        34.69345577499776,
                        116.8546771702183,
                        34.691699817849454,
                        116.85695216984499,
                        34.688597894596356,
                        116.85622516957373,
                        34.68715293030954,
                        116.85694517017225,
                        34.686081956408415,
                        116.85747816937645,
                        34.68596695959527,
                        116.86202917025142,
                        34.68700393369814,
                        116.86382517020233,
                        34.688645893344,
                        116.86515716964777,
                        34.68904788359549,
                        116.86670516990159,
                        34.68950787203575,
                        116.87057616946275,
                        34.68950387231719,
                        116.87398316941668,
                        34.68891088672056,
                        116.87726717024523,
                        34.688408899133236,
                        116.87758816973731,
                        34.68759791910736,
                        116.87810716959608,
                        34.687265927474236,
                        116.87832017003139,
                        34.68292403408363,
                        116.87562416955677,
                        34.68292703392692,
                        116.8733011702495,
                        34.68069608939494,
                        116.87048216975127,
                        34.678788136066345,
                        116.8701321699469,
                        34.67765616446766,
                        116.86992517025767,
                        34.67445624290062,
                        116.8730211698669,
                        34.67423024829236,
                        116.87294116950098,
                        34.670889331024455,
                        116.87175116944745,
                        34.668748383467154,
                        116.87156516967454,
                        34.66827539529119,
                        116.87095316992938,
                        34.66747841479334,
                        116.86992416953431,
                        34.66788640514691,
                        116.86682717010011,
                        34.66836539331527,
                        116.85732116991569,
                        34.6662884443825,
                        116.85626916995437,
                        34.66414749688176,
                        116.85617517024305,
                        34.65657468334075,
                        116.85753617000069,
                        34.65524671606223,
                        116.8538531698622,
                        34.65472472946514,
                        116.8538731699537,
                        34.648202890121226,
                        116.8541301698716,
                        34.64655793014339,
                        116.8543161696444,
                        34.645485956903855,
                        116.85510516983993,
                        34.64483897253623,
                        116.85575017009539,
                        34.64295301910083,
                        116.85762817006206,
                        34.641025066469155,
                        116.86022816937877,
                        34.63469522304533,
                        116.86100116968068,
                        34.633772245268865,
                        116.8613531700332,
                        34.63112431062814,
                        116.86236416998653,
                        34.627833391474745,
                        116.8640041694035,
                        34.62472946789392,
                        116.86505616936464,
                        34.621744541723864,
                        116.86657916950409,
                        34.621544546769556,
                        116.86636716979197,
                        34.621277553418096,
                        116.86547717021246,
                        34.621048558824455,
                        116.86396316939553,
                        34.620721566943985,
                        116.85591716960134,
                        34.620348575875084,
                        116.85469016973794,
                        34.61872661583695,
                        116.8538531698618,
                        34.616473671642794,
                        116.85381617005187
                    ],
                    "name": "栖山镇"
                },
                {
                    "path": [
                        34.663781506325314,
                        116.95220117003811,
                        34.66671743432362,
                        116.95390216955454,
                        34.67173931053759,
                        116.95439816984715,
                        34.67709217805501,
                        116.95223916967315,
                        34.6792121257821,
                        116.95445817012171,
                        34.67888113401869,
                        116.95732117010249,
                        34.678301148754606,
                        116.96252417000734,
                        34.67809715325497,
                        116.96537316974445,
                        34.677908158142024,
                        116.96531616984302,
                        34.67572821180641,
                        116.96991117020059,
                        34.67366926241719,
                        116.97046017019663,
                        34.673545265522016,
                        116.97268516959461,
                        34.673625263655296,
                        116.97857516958773,
                        34.673212274136446,
                        116.97996016963485,
                        34.673023278960564,
                        116.98085916943528,
                        34.67273628537944,
                        116.98222517011422,
                        34.67002635278455,
                        116.98517316958544,
                        34.669701360427425,
                        116.9865971699907,
                        34.668143398733214,
                        116.9934211699443,
                        34.667385417915284,
                        116.99639017023026,
                        34.66514347284387,
                        116.99704016961027,
                        34.66458148681452,
                        116.99720316981691,
                        34.662191545479864,
                        116.9974011701836,
                        34.660674582790485,
                        116.99568516970031,
                        34.65964260873178,
                        116.9952011700016,
                        34.655916700331865,
                        116.99568516970021,
                        34.65234978836928,
                        116.99768616969051,
                        34.65180280175158,
                        116.99830216963366,
                        34.649352862280956,
                        117.00008316951593,
                        34.645313961660044,
                        116.99843317005318,
                        34.64495497058664,
                        116.99555116980578,
                        34.64343600739526,
                        116.99363716985401,
                        34.64323701293054,
                        116.99293317004738,
                        34.64294102019041,
                        116.99289816988727,
                        34.64104406685998,
                        116.99266916955838,
                        34.64030008537827,
                        116.99335116962375,
                        34.63995309375348,
                        116.99445117016387,
                        34.63960210223181,
                        116.99445117016387,
                        34.64015908852736,
                        116.997332169688,
                        34.639700099490504,
                        116.99781717010995,
                        34.63825613515084,
                        116.99878416968234,
                        34.637026165323455,
                        116.99830016998366,
                        34.63704716481818,
                        116.9993491695719,
                        34.636254184924326,
                        116.99848417010666,
                        34.6355852010761,
                        116.99775216981253,
                        34.63241127902615,
                        116.99698117005867,
                        34.63052132571129,
                        116.99652216957597,
                        34.62651342438416,
                        116.99812916938097,
                        34.625542448204754,
                        116.99759216997886,
                        34.62192053782522,
                        116.99558916944032,
                        34.61919660475601,
                        116.99037317001499,
                        34.61431172517793,
                        116.99197616962203,
                        34.61315375387513,
                        116.99235516973867,
                        34.6131297541236,
                        117.00395817017291,
                        34.61382073692186,
                        117.01020516964307,
                        34.61185278594108,
                        117.01314016959391,
                        34.613146754065774,
                        117.01637316947054,
                        34.60896185692113,
                        117.0182361693686,
                        34.605192949596514,
                        117.0204571694669,
                        34.604661963046524,
                        117.02015617006634,
                        34.601907030638166,
                        117.01859216991895,
                        34.60110105076541,
                        117.01345616996126,
                        34.59856911301902,
                        117.01296016966867,
                        34.59899210266898,
                        117.00875617002163,
                        34.59735514248973,
                        117.00711817025443,
                        34.596573161484834,
                        117.00633616973161,
                        34.59833011826763,
                        116.99919616941054,
                        34.59846911497491,
                        116.98701016954342,
                        34.598487114659235,
                        116.9854521701422,
                        34.60068706027177,
                        116.9815261694312,
                        34.600640061332015,
                        116.98014316993216,
                        34.60119504799868,
                        116.98007716980989,
                        34.60153303950339,
                        116.97179716966407,
                        34.60188803110847,
                        116.96404116939975,
                        34.60220902284551,
                        116.96359517023421,
                        34.60348399139517,
                        116.96182117002466,
                        34.60363598781335,
                        116.95017116973477,
                        34.60178403313228,
                        116.95050717019369,
                        34.597096149077174,
                        116.95135816941514,
                        34.59473420677972,
                        116.94658516968059,
                        34.59226026811829,
                        116.94472316960733,
                        34.591896276926526,
                        116.93985117013865,
                        34.588963348690676,
                        116.93923816967013,
                        34.58879435303855,
                        116.93864517019159,
                        34.589055346724436,
                        116.93401817004691,
                        34.58939133840225,
                        116.93183916978134,
                        34.589602332906374,
                        116.92966016951571,
                        34.590440312504356,
                        116.92855216947797,
                        34.590615308222915,
                        116.9260881697054,
                        34.58988332602707,
                        116.92524917017951,
                        34.58909634569636,
                        116.92335617014415,
                        34.58937033864413,
                        116.91693916989634,
                        34.589978324026156,
                        116.9160941696243,
                        34.59289025235726,
                        116.9148781696316,
                        34.59315624549163,
                        116.91102416978893,
                        34.595867178899816,
                        116.91064916987017,
                        34.597938128112474,
                        116.90895216965349,
                        34.59804312543269,
                        116.90886616943975,
                        34.59932709408964,
                        116.90512016955218,
                        34.6008960553057,
                        116.90342616970851,
                        34.60197002882472,
                        116.90158616937666,
                        34.602395018288156,
                        116.90085817017885,
                        34.602075026205405,
                        116.89461816948302,
                        34.60362798804464,
                        116.89217616945169,
                        34.60413997494493,
                        116.89238116949113,
                        34.60887185910377,
                        116.89428016937431,
                        34.61176178726074,
                        116.89495817014007,
                        34.613278750208394,
                        116.89346017011502,
                        34.615277700999556,
                        116.89062716937318,
                        34.61829262660848,
                        116.89012816960593,
                        34.619077607067055,
                        116.88879216996254,
                        34.619080606997876,
                        116.88426617010025,
                        34.61890361164394,
                        116.88300116970362,
                        34.619058607897976,
                        116.88151816974712,
                        34.61908360693277,
                        116.88127316952473,
                        34.619745590712576,
                        116.87931416936719,
                        34.61974659092731,
                        116.87758617008663,
                        34.62182453958174,
                        116.87076516960781,
                        34.62203953451861,
                        116.86987417020337,
                        34.62198653542377,
                        116.86909116985564,
                        34.62243552449963,
                        116.8673101699733,
                        34.621744541723864,
                        116.86657916950409,
                        34.62472946789392,
                        116.86505616936464,
                        34.627833391474745,
                        116.8640041694035,
                        34.63112431062814,
                        116.86236416998653,
                        34.633772245268865,
                        116.8613531700332,
                        34.63469522304533,
                        116.86100116968068,
                        34.641025066469155,
                        116.86022816937877,
                        34.64295301910083,
                        116.85762817006206,
                        34.64483897253623,
                        116.85575017009539,
                        34.645485956903855,
                        116.85510516983993,
                        34.64655793014339,
                        116.8543161696444,
                        34.648202890121226,
                        116.8541301698716,
                        34.65472472946514,
                        116.8538731699537,
                        34.65524671606223,
                        116.8538531698622,
                        34.65657468334075,
                        116.85753617000069,
                        34.66414749688176,
                        116.85617517024305,
                        34.6662884443825,
                        116.85626916995437,
                        34.66836539331527,
                        116.85732116991569,
                        34.66788640514691,
                        116.86682717010011,
                        34.66747841479334,
                        116.86992416953431,
                        34.66827539529119,
                        116.87095316992938,
                        34.668748383467154,
                        116.87156516967454,
                        34.670889331024455,
                        116.87175116944745,
                        34.67423024829236,
                        116.87294116950098,
                        34.67445624290062,
                        116.8730211698669,
                        34.67765616446766,
                        116.86992517025767,
                        34.678788136066345,
                        116.8701321699469,
                        34.68069608939494,
                        116.87048216975127,
                        34.68292703392692,
                        116.8733011702495,
                        34.68292403408363,
                        116.87562416955677,
                        34.687265927474236,
                        116.87832017003139,
                        34.68759791910736,
                        116.87810716959608,
                        34.68854089624508,
                        116.88448816985886,
                        34.68863589362028,
                        116.89085817025101,
                        34.68857189506493,
                        116.89183317021937,
                        34.686784939007936,
                        116.89512916984519,
                        34.683820012215094,
                        116.89542517012113,
                        34.682633041580104,
                        116.90297217014802,
                        34.67704017956652,
                        116.90623616998676,
                        34.67691718281154,
                        116.907064169642,
                        34.67609120278309,
                        116.91222116951609,
                        34.67731717262496,
                        116.9185121693672,
                        34.67733617246493,
                        116.91861017017484,
                        34.67863114027884,
                        116.92525517002832,
                        34.67890513393366,
                        116.93861417023055,
                        34.6785661419032,
                        116.93954216944483,
                        34.678000155786506,
                        116.94108916987373,
                        34.66794140395973,
                        116.94823917024047,
                        34.665799456659556,
                        116.94976216948163,
                        34.66319452088945,
                        116.95186116938123,
                        34.663781506325314,
                        116.95220117003811
                    ],
                    "name": "张寨镇"
                },
                {
                    "path": [
                        34.48981478740624,
                        116.95733216997091,
                        34.489625792330976,
                        116.95720616957419,
                        34.48647386992048,
                        116.95933816998406,
                        34.48674386336247,
                        116.97087916959569,
                        34.48435792144975,
                        116.97204316970993,
                        34.48229197221159,
                        116.97199116983136,
                        34.48174898560123,
                        116.97197716958766,
                        34.4811839998519,
                        116.96531517001576,
                        34.47495815300741,
                        116.96484217018765,
                        34.4739631774536,
                        116.96578717001877,
                        34.47350718810667,
                        116.96564516972853,
                        34.47355618728659,
                        116.96525416991629,
                        34.47290520343694,
                        116.9650931693595,
                        34.473200195522786,
                        116.96276517002931,
                        34.47293920206777,
                        116.96274516993783,
                        34.47305619951198,
                        116.96139017002787,
                        34.46995327591507,
                        116.9610781698583,
                        34.46980727915074,
                        116.96253417005062,
                        34.467945324904136,
                        116.96238216971463,
                        34.467996324034594,
                        116.96261416951818,
                        34.465153393277504,
                        116.96225217001823,
                        34.46495439854985,
                        116.96280416948898,
                        34.46448540988083,
                        116.96276316948108,
                        34.46369342939337,
                        116.96269317005918,
                        34.46365343070375,
                        116.96288416985493,
                        34.46303544572805,
                        116.96278916942032,
                        34.46036051104245,
                        116.96234216953155,
                        34.46041850975536,
                        116.96135817024071,
                        34.46008751768077,
                        116.96129816996621,
                        34.460238513989225,
                        116.95992616943951,
                        34.46036251160219,
                        116.9587991700335,
                        34.46119349108266,
                        116.95892016950901,
                        34.461300488185884,
                        116.95780616962351,
                        34.46422341669673,
                        116.95812816983877,
                        34.46437741252728,
                        116.95567016991399,
                        34.46481840199771,
                        116.95573017018845,
                        34.46485540054539,
                        116.95470716964121,
                        34.46354443313494,
                        116.95456617007417,
                        34.46372142880959,
                        116.95316216976043,
                        34.46408241961067,
                        116.95316216976043,
                        34.46411141879047,
                        116.95272216954437,
                        34.46512239397762,
                        116.95277116994819,
                        34.46521939192751,
                        116.95141617003823,
                        34.46481840198566,
                        116.95128616944353,
                        34.46489739985013,
                        116.9507241699271,
                        34.46410641943753,
                        116.95062416946962,
                        34.464155418211085,
                        116.95010217013613,
                        34.46307444479756,
                        116.94992217021107,
                        34.4634734344724,
                        116.94922916937665,
                        34.463783426895226,
                        116.94926017023715,
                        34.463822426389676,
                        116.94883916938933,
                        34.46360243184507,
                        116.94881917018839,
                        34.46367242976719,
                        116.94847816971433,
                        34.46406241997838,
                        116.94854817003453,
                        34.46408241959715,
                        116.94815717022229,
                        34.46313044334161,
                        116.94800616971119,
                        34.46318044182799,
                        116.94751416961661,
                        34.46276945212568,
                        116.94742417010329,
                        34.462789451314066,
                        116.94723417013248,
                        34.46308944449811,
                        116.94729416950861,
                        34.463148442679305,
                        116.94696316997083,
                        34.46247845901352,
                        116.94681216945975,
                        34.4630674448739,
                        116.94630116999689,
                        34.463696428970266,
                        116.94557916974857,
                        34.46178447613843,
                        116.94512816966183,
                        34.46226146429529,
                        116.94309216951135,
                        34.459467533072214,
                        116.94223016952085,
                        34.45973652654596,
                        116.94109616954385,
                        34.457373584513256,
                        116.94026416969061,
                        34.45755157988706,
                        116.93939616985233,
                        34.459033543709225,
                        116.93247616963933,
                        34.45982652462365,
                        116.93271216964095,
                        34.46323744088925,
                        116.93369917020318,
                        34.46331643876852,
                        116.9331381696133,
                        34.46515839322523,
                        116.93364016975367,
                        34.465218392023104,
                        116.93358916969999,
                        34.465217392166224,
                        116.93334617002576,
                        34.465007396921045,
                        116.93269816939721,
                        34.465066395968655,
                        116.93234716976798,
                        34.46668835576527,
                        116.93266716943513,
                        34.46687635112132,
                        116.93143516954878,
                        34.46822831808902,
                        116.93172616980199,
                        34.468332315607434,
                        116.93098617001027,
                        34.468386313954525,
                        116.93060316969559,
                        34.47044826322451,
                        116.93099416950785,
                        34.47054726123754,
                        116.93041316972486,
                        34.4719192272133,
                        116.93064416970356,
                        34.47196822584471,
                        116.93035316945038,
                        34.472609210440595,
                        116.93044416968702,
                        34.47276720615923,
                        116.92933116962637,
                        34.47284820417805,
                        116.92935116971789,
                        34.473245195005134,
                        116.92645616995007,
                        34.47262420990492,
                        116.92632617025367,
                        34.47319119608883,
                        116.92311017009551,
                        34.47406217488636,
                        116.92329017002055,
                        34.47441116622008,
                        116.9213581696272,
                        34.473670184485336,
                        116.92116716983145,
                        34.47379918090967,
                        116.92031616971165,
                        34.4752311457503,
                        116.92061617018562,
                        34.47546014056928,
                        116.91966516960845,
                        34.47365918421327,
                        116.91934417011637,
                        34.4741671722732,
                        116.91636016976173,
                        34.473086198917386,
                        116.91611016951646,
                        34.47318619578353,
                        116.91547916950465,
                        34.47326619437512,
                        116.91497817008761,
                        34.47165423355531,
                        116.91477817007102,
                        34.47210422252924,
                        116.91244516981966,
                        34.47177323087226,
                        116.91235516940795,
                        34.47191322702541,
                        116.91175416953345,
                        34.47043226351103,
                        116.91133416940882,
                        34.470622258905465,
                        116.91042316991289,
                        34.469241293333106,
                        116.91001316983407,
                        34.469840278355704,
                        116.90608016945043,
                        34.46825931687993,
                        116.90568916963807,
                        34.4683493146779,
                        116.90498917002935,
                        34.469910276230266,
                        116.9053791700167,
                        34.47053126151929,
                        116.9019871701314,
                        34.470631258486044,
                        116.90191716981121,
                        34.470991249976024,
                        116.89988616968367,
                        34.47018126970423,
                        116.89968616966708,
                        34.470231268411084,
                        116.89923616940531,
                        34.4701712702536,
                        116.89907616957171,
                        34.4700212739313,
                        116.89895616992114,
                        34.470071272734344,
                        116.8986161701625,
                        34.472672209023386,
                        116.89920617016641,
                        34.47275320639233,
                        116.89865616944716,
                        34.47430316833802,
                        116.8990361693888,
                        34.474774156860555,
                        116.89654516985203,
                        34.47500515167369,
                        116.89657616981417,
                        34.4750851492609,
                        116.89565516937415,
                        34.47538014178817,
                        116.89388617008571,
                        34.475807131711754,
                        116.89194617019473,
                        34.47722809636293,
                        116.89233516945883,
                        34.477488090019584,
                        116.89068616982105,
                        34.479610038341164,
                        116.89122616959622,
                        34.479801033254326,
                        116.88983616952618,
                        34.47894005499813,
                        116.8896261694639,
                        34.4792720467898,
                        116.88747616951066,
                        34.47908105140209,
                        116.88734616981431,
                        34.47948604116161,
                        116.88501916941073,
                        34.48006802698596,
                        116.87981916987893,
                        34.47980803321854,
                        116.87977916969592,
                        34.47986903153148,
                        116.87929016997441,
                        34.48231997182816,
                        116.87954017021971,
                        34.48252196630044,
                        116.87763116939253,
                        34.47995102973598,
                        116.87729116963389,
                        34.48043501767946,
                        116.87303416938511,
                        34.478254071775595,
                        116.87275416990089,
                        34.47827507065536,
                        116.87226517017932,
                        34.476614111485375,
                        116.87200516988831,
                        34.47665511108703,
                        116.87125517005086,
                        34.47834606929943,
                        116.87149517025037,
                        34.478417067142644,
                        116.8707361701921,
                        34.476706109335744,
                        116.87049616999253,
                        34.47689910440331,
                        116.86860816998013,
                        34.474527163197,
                        116.86829816946043,
                        34.474355166952805,
                        116.86965716956831,
                        34.47387517902726,
                        116.86959717019218,
                        34.474169171638025,
                        116.86723916982643,
                        34.476639111126,
                        116.86765916995107,
                        34.47792307931533,
                        116.86583217003799,
                        34.47814307388096,
                        116.86588116954351,
                        34.47955603977758,
                        116.86441316965565,
                        34.48079900922215,
                        116.8629251696763,
                        34.48088900682733,
                        116.86271516961405,
                        34.48096100513596,
                        116.86189617017959,
                        34.48202097850773,
                        116.8620861701504,
                        34.482391969595966,
                        116.86160716957632,
                        34.48561389027728,
                        116.86203716974663,
                        34.48553189245236,
                        116.86282616994217,
                        34.489863786381406,
                        116.86356516990901,
                        34.49166474166862,
                        116.86376516992557,
                        34.491869736560766,
                        116.86398417020871,
                        34.49358569487194,
                        116.86425516947207,
                        34.493900687006764,
                        116.86063016995821,
                        34.49784159019597,
                        116.86107416947401,
                        34.49911355846206,
                        116.86121917013728,
                        34.499062559846365,
                        116.8620381695717,
                        34.50086351560955,
                        116.86225816967979,
                        34.500882515125156,
                        116.86293716937212,
                        34.50312346052101,
                        116.86334716945098,
                        34.50291146563728,
                        116.86488516965903,
                        34.502669471710256,
                        116.8658241696424,
                        34.50482041885148,
                        116.8661341701621,
                        34.50468942203387,
                        116.86716316965881,
                        34.50560539904234,
                        116.86728917005553,
                        34.506710372361724,
                        116.86744317004135,
                        34.50654837612632,
                        116.86883116956325,
                        34.50864932450539,
                        116.86922116955061,
                        34.50891231814433,
                        116.86717416952949,
                        34.510563277584744,
                        116.86743316999562,
                        34.51099326667697,
                        116.86756316969199,
                        34.510881269395114,
                        116.86909216967923,
                        34.51157125233102,
                        116.86917217004519,
                        34.51200524153844,
                        116.86633417017875,
                        34.51248622990995,
                        116.86599517024501,
                        34.51320621204277,
                        116.86607516971267,
                        34.51336820866015,
                        116.86458716973335,
                        34.51553015497033,
                        116.86476716965842,
                        34.51575414947287,
                        116.8627541699725,
                        34.51584514782956,
                        116.86146116998678,
                        34.51706611726317,
                        116.86148117007832,
                        34.51695412000128,
                        116.86283916946302,
                        34.51979605068439,
                        116.86299917019493,
                        34.51968405339081,
                        116.86405816982887,
                        34.520904022886974,
                        116.86434816935878,
                        34.520250039477304,
                        116.86749417009511,
                        34.52209099363292,
                        116.86776416952587,
                        34.52200899615746,
                        116.86879316992861,
                        34.523396962160284,
                        116.86896117015809,
                        34.524410937128785,
                        116.86908316945849,
                        34.52444193583038,
                        116.86826417002409,
                        34.52617289360834,
                        116.86832416940025,
                        34.52617489333536,
                        116.86678617009053,
                        34.52441393678252,
                        116.86668616963308,
                        34.524394937449976,
                        116.86573716960399,
                        34.524505934445344,
                        116.86476816948341,
                        34.527878851841855,
                        116.8648981700781,
                        34.52792685031797,
                        116.86627616955431,
                        34.53057878509492,
                        116.86639716992813,
                        34.530621784423424,
                        116.86378016999464,
                        34.53177575580275,
                        116.86379116986532,
                        34.53353471254457,
                        116.8638101701319,
                        34.53354571231086,
                        116.86293116951691,
                        34.535146673032116,
                        116.86305117007366,
                        34.535141672753404,
                        116.85963616972379,
                        34.536512639630295,
                        116.85963616972383,
                        34.536487640179736,
                        116.86313116954126,
                        34.53981955809792,
                        116.86331217018957,
                        34.5396865614071,
                        116.86524916970755,
                        34.546071403966,
                        116.86528817006565,
                        34.54609240352043,
                        116.86463117011463,
                        34.54869433930861,
                        116.86463117011466,
                        34.547493369253296,
                        116.87056016956751,
                        34.547296374169036,
                        116.87249316978578,
                        34.54715137778231,
                        116.87390816997018,
                        34.54900633229593,
                        116.87351616943475,
                        34.553340225029366,
                        116.87406916962874,
                        34.55338722408538,
                        116.87578216973907,
                        34.55333422558894,
                        116.87975117010771,
                        34.55147827108646,
                        116.88721216992087,
                        34.55425420295723,
                        116.88735517003602,
                        34.55400220899591,
                        116.89554016974738,
                        34.54831134929313,
                        116.89632317009504,
                        34.54741937082029,
                        116.90183317014655,
                        34.547739363208514,
                        116.90598216954203,
                        34.54790135926046,
                        116.908077170142,
                        34.54797235780075,
                        116.90900316970657,
                        34.55275323969368,
                        116.90884316987302,
                        34.55760512055983,
                        116.90884316987305,
                        34.55721413041644,
                        116.91387517007375,
                        34.55610915753663,
                        116.91631916975486,
                        34.55505918348047,
                        116.91988916991535,
                        34.555104181797915,
                        116.92477916982578,
                        34.553098231241684,
                        116.92668716992966,
                        34.55132327535777,
                        116.9272351701007,
                        34.550649291565705,
                        116.93182217006238,
                        34.548759338309424,
                        116.93309216958355,
                        34.54415745153239,
                        116.93618616954296,
                        34.54340046987589,
                        116.93669517025431,
                        34.54221949900951,
                        116.93834116951906,
                        34.5420245041137,
                        116.94099517016083,
                        34.54189750678628,
                        116.9427341702103,
                        34.53771061009511,
                        116.94301816989241,
                        34.53751861492545,
                        116.94582216942364,
                        34.537373618531085,
                        116.94959216960075,
                        34.53773660967233,
                        116.9495601698137,
                        34.53692262907268,
                        116.95455216983133,
                        34.536084650287634,
                        116.95504116955289,
                        34.52780385404779,
                        116.95517617017029,
                        34.51915006655965,
                        116.95541817001953,
                        34.51871507686233,
                        116.95804417017385,
                        34.51761010432398,
                        116.95873016953892,
                        34.5092143109643,
                        116.96340617008727,
                        34.50556840031501,
                        116.96315316946895,
                        34.5030414624126,
                        116.96280017018978,
                        34.50310646058806,
                        116.96149916980818,
                        34.50004553621016,
                        116.96079016997855,
                        34.49695861228813,
                        116.96215216956118,
                        34.48981478740624,
                        116.95733216997091
                    ],
                    "name": "敬安镇"
                },
                {
                    "path": [
                        34.494818664979846,
                        117.00712016990303,
                        34.49037277420149,
                        117.00633716955521,
                        34.48845182103182,
                        117.00594016989518,
                        34.48812082907572,
                        117.00913316958888,
                        34.48692985887834,
                        117.00886216942723,
                        34.48679986168179,
                        117.00876117004313,
                        34.48606787980335,
                        117.00856017020169,
                        34.48479691134287,
                        117.00828917004003,
                        34.48416692670654,
                        117.01182317021558,
                        34.48141299401049,
                        117.01119116948054,
                        34.48142099426747,
                        117.01051816963596,
                        34.47903805246029,
                        117.00996516944197,
                        34.47907705149209,
                        117.00976416960052,
                        34.47680410724969,
                        117.00915117003039,
                        34.4767651086365,
                        117.00934216982611,
                        34.474752157661236,
                        117.0090611696187,
                        34.47509614964101,
                        117.00679117001482,
                        34.47470515866072,
                        117.00652016985318,
                        34.475057150221744,
                        117.00408016947165,
                        34.47389617863333,
                        117.00382916940153,
                        34.47383818039679,
                        117.00444216986989,
                        34.472947202510944,
                        117.0042611701199,
                        34.47297620157406,
                        117.00413016970039,
                        34.47139424047286,
                        117.00380816948505,
                        34.471473238779296,
                        117.00333616948194,
                        34.469480287341874,
                        117.00283417023994,
                        34.469568284955855,
                        117.00215116945131,
                        34.46818631915808,
                        117.0018501700507,
                        34.46820531870916,
                        117.0015181697897,
                        34.46624336661473,
                        117.00109617001526,
                        34.466530359828084,
                        117.0002121693852,
                        34.465729379354066,
                        117.00005216955158,
                        34.46585137652526,
                        117.00056416973771,
                        34.46474940353662,
                        117.00025216956814,
                        34.46479840267382,
                        116.99989116989309,
                        34.46379742673859,
                        116.99957916972359,
                        34.46386642536572,
                        116.99930816956191,
                        34.46354543313199,
                        116.9991881699113,
                        34.46370342897448,
                        116.99840516956361,
                        34.46383342586556,
                        116.99837416960148,
                        34.463919423765105,
                        116.99801916977422,
                        34.46446641031228,
                        116.99580416952361,
                        34.46350443448429,
                        116.99550216939977,
                        34.46388342466442,
                        116.99523117013646,
                        34.46161048062936,
                        116.99451817010889,
                        34.46156048194251,
                        116.99470916990461,
                        34.46126148909375,
                        116.99483916960097,
                        34.46156648207917,
                        116.99335317016978,
                        34.46196747208725,
                        116.9934341694623,
                        34.462824451107274,
                        116.98903516982162,
                        34.46393642378149,
                        116.98946716964173,
                        34.46428241489919,
                        116.98811216973179,
                        34.46385242563937,
                        116.98791017006543,
                        34.464268415268975,
                        116.98645516969803,
                        34.465039396242524,
                        116.98667616963095,
                        34.46527339090037,
                        116.98546016963817,
                        34.46559038300241,
                        116.9834821701124,
                        34.46583037669367,
                        116.98353317016601,
                        34.4658993751211,
                        116.98302116997989,
                        34.46823231825031,
                        116.98354317021177,
                        34.468183318907066,
                        116.98394516989472,
                        34.46946428744541,
                        116.98413616969044,
                        34.46991427637398,
                        116.98048117003941,
                        34.4703352666184,
                        116.98054217013879,
                        34.47038426543901,
                        116.98019016978621,
                        34.47054426125477,
                        116.9802201699235,
                        34.47056326101006,
                        116.98003016995267,
                        34.47108424810789,
                        116.98008017018141,
                        34.47136224069552,
                        116.97577316970391,
                        34.47245321408185,
                        116.975844169849,
                        34.47249121345854,
                        116.97510116968421,
                        34.470879253221916,
                        116.97493016997998,
                        34.4709682506294,
                        116.97426717018121,
                        34.47188922812481,
                        116.97438716983179,
                        34.472134221822145,
                        116.97272116957723,
                        34.472354216838546,
                        116.97275116971444,
                        34.47264021000619,
                        116.97090416970991,
                        34.471669233354035,
                        116.97075416992203,
                        34.472203220212634,
                        116.96856616943563,
                        34.4741151736038,
                        116.96883716959736,
                        34.47416417242696,
                        116.96853617019678,
                        34.47477515753813,
                        116.96866616989314,
                        34.47490315399551,
                        116.96786316945389,
                        34.474463164972825,
                        116.96776316989478,
                        34.474728158550306,
                        116.96602616949505,
                        34.4739631774536,
                        116.96578717001877,
                        34.47495815300741,
                        116.96484217018765,
                        34.4811839998519,
                        116.96531517001576,
                        34.48174898560123,
                        116.97197716958766,
                        34.48229197221159,
                        116.97199116983136,
                        34.48435792144975,
                        116.97204316970993,
                        34.48674386336247,
                        116.97087916959569,
                        34.48647386992048,
                        116.95933816998406,
                        34.489625792330976,
                        116.95720616957419,
                        34.48981478740624,
                        116.95733216997091,
                        34.49695861228813,
                        116.96215216956118,
                        34.50004553621016,
                        116.96079016997855,
                        34.50310646058806,
                        116.96149916980818,
                        34.5030414624126,
                        116.96280017018978,
                        34.50556840031501,
                        116.96315316946895,
                        34.5092143109643,
                        116.96340617008727,
                        34.51761010432398,
                        116.95873016953892,
                        34.51871507686233,
                        116.95804417017385,
                        34.51915006655965,
                        116.95541817001953,
                        34.52780385404779,
                        116.95517617017029,
                        34.536084650287634,
                        116.95504116955289,
                        34.53692262907268,
                        116.95455216983133,
                        34.53773660967233,
                        116.9495601698137,
                        34.537373618531085,
                        116.94959216960075,
                        34.53751861492545,
                        116.94582216942364,
                        34.53771061009511,
                        116.94301816989241,
                        34.54189750678628,
                        116.9427341702103,
                        34.5420245041137,
                        116.94099517016083,
                        34.54221949900951,
                        116.93834116951906,
                        34.54340046987589,
                        116.93669517025431,
                        34.54415745153239,
                        116.93618616954296,
                        34.548759338309424,
                        116.93309216958355,
                        34.550649291565705,
                        116.93182217006238,
                        34.55132327535777,
                        116.9272351701007,
                        34.553098231241684,
                        116.92668716992966,
                        34.555104181797915,
                        116.92477916982578,
                        34.55511918197136,
                        116.92636916991238,
                        34.56102403649566,
                        116.92715616955982,
                        34.565877916815346,
                        116.92899616989172,
                        34.569265833902456,
                        116.92837116972781,
                        34.57123078549016,
                        116.93044316986327,
                        34.5716917738003,
                        116.93175316956739,
                        34.573166737553095,
                        116.93594416969398,
                        34.57363772583584,
                        116.93702516996757,
                        34.57446770570653,
                        116.93695717019548,
                        34.57451670470449,
                        116.93718716945095,
                        34.57516968857043,
                        116.93723316948173,
                        34.5806105546404,
                        116.94066316990022,
                        34.58294849720668,
                        116.94155716967778,
                        34.58549843429571,
                        116.94087816998547,
                        34.58689439958294,
                        116.94063216993818,
                        34.58924334192092,
                        116.94021716983647,
                        34.588963348690676,
                        116.93923816967013,
                        34.591896276926526,
                        116.93985117013865,
                        34.59226026811829,
                        116.94472316960733,
                        34.59473420677972,
                        116.94658516968059,
                        34.597096149077174,
                        116.95135816941514,
                        34.60178403313228,
                        116.95050717019369,
                        34.60363598781335,
                        116.95017116973477,
                        34.60348399139517,
                        116.96182117002466,
                        34.60220902284551,
                        116.96359517023421,
                        34.60188803110847,
                        116.96404116939975,
                        34.60153303950339,
                        116.97179716966407,
                        34.60119504799868,
                        116.98007716980989,
                        34.600640061332015,
                        116.98014316993216,
                        34.60068706027177,
                        116.9815261694312,
                        34.598487114659235,
                        116.9854521701422,
                        34.59846911497491,
                        116.98701016954342,
                        34.59833011826763,
                        116.99919616941054,
                        34.596573161484834,
                        117.00633616973161,
                        34.59735514248973,
                        117.00711817025443,
                        34.595465188776515,
                        117.00691817023787,
                        34.59493820200667,
                        117.00772417015182,
                        34.59379623008393,
                        117.00947016987402,
                        34.59365923325296,
                        117.01155916972786,
                        34.59249826218176,
                        117.01177016961512,
                        34.587228391582066,
                        117.012724169667,
                        34.585590431942045,
                        117.01461616987737,
                        34.585231441358,
                        117.0194321701679,
                        34.584387461565264,
                        117.02061817002347,
                        34.58348448405713,
                        117.02188517006985,
                        34.57810761634649,
                        117.0232581695231,
                        34.575294685609585,
                        117.02088316943886,
                        34.57347872993868,
                        117.01834316949825,
                        34.57196976764184,
                        117.01735816948415,
                        34.57032680797013,
                        117.01628616943137,
                        34.56888084313384,
                        117.01652817017907,
                        34.566690897657075,
                        117.01727516964347,
                        34.56400096327293,
                        117.01445517021861,
                        34.561658021061994,
                        117.01284316949236,
                        34.560698044735965,
                        117.01452516964041,
                        34.56256599905231,
                        117.01989216957689,
                        34.5637109707895,
                        117.02554416991867,
                        34.56290699066361,
                        117.03233816973494,
                        34.56239600286728,
                        117.0357241697725,
                        34.56230300547244,
                        117.03612016960763,
                        34.559876065214105,
                        117.0383511697517,
                        34.55847909949452,
                        117.04082416974515,
                        34.552420248387705,
                        117.04175716988067,
                        34.55199025934873,
                        117.04342817015811,
                        34.55133327501374,
                        117.04597716942122,
                        34.55110928076302,
                        117.04836616974907,
                        34.550907286038374,
                        117.05050716948149,
                        34.55060429339437,
                        117.05095416937021,
                        34.54796235846121,
                        117.05624816951162,
                        34.54480843581111,
                        117.05741216962586,
                        34.54330347291153,
                        117.05733717018107,
                        34.541716512125355,
                        117.05725816964004,
                        34.539946555434085,
                        117.06035516997255,
                        34.5388535821614,
                        117.06173816947158,
                        34.53701362753985,
                        117.06274816959997,
                        34.535502664312396,
                        117.0640001695778,
                        34.53460468687409,
                        117.06413116999735,
                        34.531448764666834,
                        117.0643291694657,
                        34.53070278303566,
                        117.06454816974883,
                        34.529958801023,
                        117.06494316975902,
                        34.52921481902354,
                        117.06516816988992,
                        34.52853083617075,
                        117.06274816959991,
                        34.528380839720484,
                        117.06282816996587,
                        34.52767885721191,
                        117.06292917024817,
                        34.52193799820808,
                        117.06376916959894,
                        34.5219179983963,
                        117.06363217022995,
                        34.52035703686772,
                        117.06385917001063,
                        34.51925206387977,
                        117.05594816993566,
                        34.518282088033,
                        117.05592816984417,
                        34.5185400818309,
                        117.05377816989093,
                        34.519837049531006,
                        117.04339217017275,
                        34.52056103225007,
                        117.03660517002902,
                        34.52038303658237,
                        117.03348416940706,
                        34.518757076647425,
                        117.03199816997582,
                        34.51579514953829,
                        117.03203817015877,
                        34.51572315095324,
                        117.03128516994825,
                        34.51205024135629,
                        117.03113416943718,
                        34.511933243820735,
                        117.02846217015043,
                        34.51175124881739,
                        117.02766116936101,
                        34.51120126198899,
                        117.02799216979709,
                        34.510936268794815,
                        117.0228011695878,
                        34.510754273094584,
                        117.02201916996326,
                        34.510655275413356,
                        117.01871816941627,
                        34.5106612757213,
                        117.01763117019323,
                        34.5099112934697,
                        117.01762016942425,
                        34.5099202932749,
                        117.01721916956627,
                        34.505606399560264,
                        117.01700716985415,
                        34.505567400348816,
                        117.01732917006935,
                        34.50518740987833,
                        117.01729817010718,
                        34.505244408408714,
                        117.0163551699259,
                        34.50418343469028,
                        117.01624416959781,
                        34.50422043354912,
                        117.01530016959161,
                        34.50404043825355,
                        117.01527016945438,
                        34.50407843730699,
                        117.01445716986771,
                        34.50277346889832,
                        117.0142931698362,
                        34.50207648607317,
                        117.01420616979753,
                        34.5021734840019,
                        117.01326216979133,
                        34.49921955677118,
                        117.01285916938521,
                        34.499403552113044,
                        117.01072117002573,
                        34.499592547235814,
                        117.01014816974032,
                        34.49970954431782,
                        117.00929516997076,
                        34.497807591002925,
                        117.00905416994624,
                        34.49787558943463,
                        117.00840117019317,
                        34.495713642687825,
                        117.00810917011509,
                        34.4958106406162,
                        117.00723617025403,
                        34.494818664979846,
                        117.00712016990303
                    ],
                    "name": "张庄镇"
                }
            ]
            new self.$Map.visualization.Area({
                styles:{
                    default:  {
                            fillColor: `rgba(56,124,234,0.1)`, //设置区域填充颜色
                            strokeColor: 'rgba(255,255,255,0.4)', //设置区域边线颜色
                            strokeWidth: 3, //设置区域边线颜色
                        }
                }
            }).addTo(self.map).setData(areaData);
            let labelData = [];
            areaData.forEach(e=>{
                let latitude = e.path.filter((u,i)=>i%2 === 0)
                let longitude = e.path.filter((u,i)=>i%2 !== 0)
                labelData.push({
                    id: e.name,
                    position: new self.$Map.LatLng(
                        (Math.max(...latitude)+Math.min(...latitude))/2,
                        (Math.max(...longitude)+Math.min(...longitude))/2
                    ),
                    content: e.name,
                })
            })
            new self.$Map.MultiLabel({
                id: 'townName',
                map:self.map, //设置折线图层显示到哪个地图实例中
                styles: {
                    default: new self.$Map.LabelStyle({
                        color: 'rgba(255,255,255,.8)', //颜色属性
                        padding:'4px 10px',
                        backgroundColor:'rgba(0,0,0,.2)',
                        borderRadius:6,
                        size: 14, //文字大小属性
                        offset: { x: 0, y: 0 }, //文字偏移属性单位为像素
                        angle: 0, //文字旋转属性
                        alignment: 'center', //文字水平对齐属性
                        verticalAlignment: 'middle' //文字垂直对齐属性
                    })
                },
                geometries: labelData
            });
            // const wall =[[117.1491462,34.55584785],[117.103715,34.55624139],[117.1053422,34.54989346],[117.1028096,34.54756163],[117.1035863,34.54078949],[117.097915,34.538664],[117.0984363,34.53689583],[117.0934391,34.53485644],[117.0867226,34.53699282],[117.0793219,34.53537357],[117.0787713,34.53008],[117.0759987,34.5296854],[117.0769123,34.52654019],[117.0702107,34.52722259],[117.0664102,34.52605272],[117.0677357,34.51808102],[117.057293,34.51629885],[117.0386738,34.5182992],[117.0355027,34.51628241],[117.0346247,34.50987942],[117.0210889,34.50815204],[117.0208253,34.50261033],[117.0179162,34.50176715],[117.0162308,34.49718191],[117.0127322,34.49761376],[117.0108288,34.49357521],[117.0096692,34.48637373],[117.0124679,34.4859939],[117.0117897,34.48265356],[117.0147842,34.48204913],[117.0135802,34.47232095],[117.0071965,34.47313226],[117.0081362,34.47152003],[117.0039598,34.46294472],[116.9987133,34.45868912],[116.987391,34.46292543],[116.9874557,34.46700731],[116.9723102,34.4700837],[116.9715879,34.47278164],[116.9686179,34.47052465],[116.9647293,34.47023201],[116.965563,34.4585613],[116.9613047,34.4588796],[116.9588351,34.46241643],[116.9570453,34.46126083],[116.9549701,34.46287555],[116.9465891,34.45981374],[116.9434716,34.45506647],[116.9360738,34.45673683],[116.9368339,34.46233247],[116.9341698,34.46608257],[116.933577,34.47045677],[116.9269912,34.47068106],[116.9263783,34.47229862],[116.9246566,34.47145063],[116.9231736,34.47288045],[116.9224985,34.47130792],[116.9197729,34.47177351],[116.9118234,34.46719737],[116.9023483,34.46812392],[116.9023217,34.47203452],[116.896354,34.47334534],[116.8938016,34.47764353],[116.8926927,34.47671553],[116.8763929,34.47814415],[116.8736571,34.47441896],[116.8707432,34.474771],[116.8659285,34.48003635],[116.8673688,34.49122396],[116.8641699,34.49202424],[116.8667884,34.50043325],[116.8692245,34.50082905],[116.8726753,34.50606917],[116.8707576,34.50841136],[116.8727365,34.5090282],[116.867991,34.51104108],[116.8676177,34.51329424],[116.8648542,34.51351446],[116.8676751,34.5181527],[116.8706996,34.51823958],[116.8723921,34.52126554],[116.868039,34.52210607],[116.8699444,34.52787269],[116.8671807,34.52809375],[116.8661944,34.53279967],[116.8631483,34.53293135],[116.8632982,34.53403396],[116.8664102,34.5341814],[116.8667951,34.53806778],[116.868536,34.53846358],[116.8681084,34.54737498],[116.8623629,34.54803804],[116.860334,34.5508224],[116.8563967,34.55011731],[116.856031,34.5477321],[116.852833,34.54760044],[116.8530249,34.54989187],[116.8487618,34.54958516],[116.8448149,34.55440205],[116.8412481,34.55418246],[116.8412967,34.55117904],[116.8377509,34.55135679],[116.8321885,34.54822185],[116.8306929,34.54570574],[116.8265383,34.54584062],[116.8261632,34.54835723],[116.819963,34.5486999],[116.81948,34.55051117],[116.8139533,34.55139466],[116.8135772,34.55400133],[116.805073,34.55267838],[116.8022068,34.55002775],[116.799853,34.55148437],[116.7969233,34.5571109],[116.7991501,34.56328461],[116.7957247,34.56668509],[116.7902586,34.5673426],[116.7835554,34.56592382],[116.7748605,34.56715418],[116.7760221,34.59765615],[116.7715163,34.60351002],[116.7718985,34.60713083],[116.7750699,34.61131933],[116.7752694,34.61818503],[116.7745239,34.61990803],[116.7669557,34.62060381],[116.763372,34.62333541],[116.7639886,34.62897312],[116.7669249,34.63193767],[116.7691924,34.64018487],[116.7610648,34.64457056],[116.7598309,34.64870547],[116.761249,34.65665937],[116.7595733,34.66277119],[116.7649582,34.66463459],[116.7651359,34.6712576],[116.7721829,34.67139438],[116.7715356,34.67695189],[116.7685893,34.67732678],[116.7674696,34.67975155],[116.7670402,34.68496658],[116.7588524,34.68589962],[116.7593448,34.68912859],[116.7520076,34.68909346],[116.7510739,34.68732966],[116.7467047,34.68753568],[116.7449448,34.68432302],[116.7396862,34.6822744],[116.7283915,34.68066384],[116.7264609,34.67611863],[116.7129932,34.67563929],[116.7075463,34.67595838],[116.7081123,34.68294074],[116.7053771,34.68320867],[116.7054584,34.68491039],[116.6971856,34.68573319],[116.6979031,34.69296522],[116.704084,34.70256281],[116.7043971,34.70692447],[116.7019518,34.71152284],[116.7057931,34.71421375],[116.6949639,34.7251339],[116.6947019,34.73073792],[116.7094703,34.73300381],[116.712368,34.73675682],[116.7174004,34.73711719],[116.7173677,34.74057456],[116.7201843,34.74218478],[116.7203431,34.74725801],[116.717695,34.74734573],[116.7188893,34.75658152],[116.7209021,34.75667914],[116.7209193,34.75818767],[116.708933,34.76172462],[116.7081529,34.77813109],[116.702982,34.77874439],[116.7034686,34.78360519],[116.6876069,34.78399945],[116.6862116,34.78787584],[116.6892669,34.79130207],[116.6864587,34.79213069],[116.6856202,34.7994317],[116.6902002,34.79953334],[116.692312,34.80323407],[116.6984053,34.80280848],[116.6994957,34.81026519],[116.7115897,34.81020554],[116.7122756,34.81474031],[116.708233,34.81800264],[116.7077412,34.82079584],[116.7158895,34.82784826],[116.7185028,34.83890049],[116.724583,34.84857117],[116.7334378,34.84664173],[116.7336914,34.8496672],[116.7314112,34.85040302],[116.7296479,34.85370693],[116.7298776,34.85732807],[116.7333138,34.85831818],[116.7332846,34.86737797],[116.7265025,34.87105154],[116.7265628,34.87275446],[116.7235156,34.87327064],[116.7201294,34.88296616],[116.7224909,34.88469292],[116.7314845,34.88213545],[116.73233,34.88480913],[116.729587,34.88606599],[116.730606,34.88960483],[116.7360846,34.88914287],[116.7464772,34.89307488],[116.7467842,34.90013173],[116.7362249,34.90023213],[116.7374829,34.90429449],[116.729901,34.91103272],[116.7343602,34.92467984],[116.7453327,34.92094465],[116.745991,34.91574601],[116.752072,34.91408101],[116.756603,34.91749899],[116.771376,34.91646699],[116.77467,34.92056399],[116.779088,34.93618299],[116.782524,34.94118501],[116.797609,34.938754],[116.796916,34.944147],[116.785461,34.94729201],[116.781643,34.96190601],[116.789108,34.959811],[116.789102,34.97508801],[116.815878,34.96529699],[116.822148,34.929306],[116.860105,34.92743601],[116.865886,34.91960601],[116.876126,34.912541],[116.899059,34.90470101],[116.9213362,34.894931],[116.9218745,34.87431493],[116.9233434,34.87267015],[116.9427624,34.87283777],[116.9429405,34.86949443],[116.9498055,34.86881947],[116.9510357,34.86576046],[116.9498301,34.8639122],[116.9329505,34.86101759],[116.9295375,34.85436773],[116.9291958,34.84318237],[116.9659709,34.84469928],[116.967311,34.83707299],[116.97186,34.83239799],[116.9846888,34.80604397],[116.9722326,34.80549815],[116.9810303,34.80693828],[116.9808107,34.80936319],[116.9495345,34.80609109],[116.9493007,34.79421528],[116.9517132,34.79175026],[116.9564694,34.79109014],[116.9553316,34.78765324],[116.9594862,34.78399229],[116.9610163,34.78485758],[116.9623265,34.78341909],[116.9643908,34.77685115],[116.9750483,34.77766172],[116.9751796,34.77574411],[116.9780536,34.77607517],[116.97847,34.77451569],[116.9760577,34.77385453],[116.9762797,34.76490802],[116.9878826,34.76622878],[116.9913485,34.76313977],[117.0088565,34.76737958],[117.0123675,34.76938418],[117.0297661,34.74543876],[117.0409908,34.73411095],[117.057988,34.72051179],[117.0675109,34.70941605],[117.0774044,34.69599604],[117.0706307,34.69269854],[117.0672501,34.68769637],[117.0651173,34.68011833],[117.0773927,34.68082681],[117.0785758,34.67871736],[117.0825824,34.68031321],[117.0839865,34.67748931],[117.0796602,34.67695431],[117.0870508,34.66733646],[117.0621749,34.66467775],[117.0620498,34.66118804],[117.0550258,34.65984015],[117.0557559,34.65632794],[117.0787198,34.65757416],[117.0877446,34.65675442],[117.067676,34.64447986],[117.0698449,34.64054676],[117.0711931,34.64342734],[117.0742178,34.6387662],[117.0829767,34.63927224],[117.083831,34.64425534],[117.086544,34.64441797],[117.0863541,34.64602509],[117.1033553,34.64777618],[117.1137149,34.62856384],[117.1281258,34.5926274],[117.1340271,34.58333211],[117.1481412,34.56698596]];
            // let path = [];
            // wall.forEach(e=>{
            //     path.push(new self.$Map.LatLng(e[1],e[0]))
            // })
            // let wallData = [
            //     {
            //         path: path,
            //         height: 4500,
            //         styleId: "style1"
            //     }
            // ]
            // new self.$Map.visualization.Wall({
            //     styles: {
            //         'style1': {
            //             color: new self.$Map.GradientColor({
            //                 stops: {
            //                     0: "rgba(1,124,247,1)",
            //                     1: "rgba(29,250,242,0.1)",
            //                 },//设置渐变色的颜色，此处为rgba()格式
            //                 angle: 90, //设置渐变色的渐变方向，此处为90度
            //             }),
            //         },
            //     },
            //     processAnimation: {
            //         animationType: "breath", //设置动画类型，此处为呼吸
            //         breathAmplitude: 0.5, //设置呼吸幅度
            //         yoyo: true, //设置回弹效果
            //         duration: 2000, //设置动画时长
            //     },
            // }).addTo(self.map).setData(wallData);
        },
        StartAnimation(){
            let keyframe = [
                { percentage: 0, rotation: 0 },
                { percentage: 0.5, rotation: 180 },
                { percentage: 1, rotation: 360 }
            ];
            this.map.startAnimation(keyframe, { duration: 1000*120, loop: Infinity });
            this.animationPaly = true;
        },
        PauseAnimation(){
            this.map.pauseAnimation()
            this.animationPaly = false;
        },
        InfoWindow(point){
            let self = this;
            new self.$Map.InfoWindow({
                map: self.map,
                position: new self.$Map.LatLng(point.latitude,point.longitude),
                // enableCustom: true,
                content: 
                `<div style="color:#000;text-align: left;">
                    <div>${point.name}</div>
                    <div>${point.address}</div>
                    <div>道路距离 ${(point.roadDistance*1/1000).toFixed(2)} km 直线距离 ${(point.straightDistance*1/1000).toFixed(2)} km</div>
                </div>`
            });
            // setTimeout(()=>{currentInfoWindow.destroy()},7*1000)
        },
        ResetMap(){
            this.map.panTo(this.center);
            this.map.setZoom(this.zoom);
            this.map.setPitch(this.pitch);
            // this.StartAnimation();
            this.CleanMap()
        },
        CleanMap(isNavigation){
            if(this.polylineLayer!=null){
                this.polylineLayer.remove("roadLine");
            }
            if(!isNavigation){
                this.simulation = {
                    visible:false,
                    form:{
                        start:{
                            value:'',
                            loading:false,
                            type:'search'
                        },
                        end:{
                            value:'',
                            loading:false,
                            type:'search'
                        }
                    },
                    searchResult:{
                        start:[],
                        end:[]
                    },
                    skillOptions:[],
                    table:[],
                }
                this.skillResult = {
                    visible:false,
                    activeName:'',
                    data:[]
                }
            }
            this.zoomMap = true
        },
        PersonJob(){
            let self = this;
            if(self.simulation.table.length>0){
                let queryArr = []
                self.simulation.table.forEach(e=>{
                    if(e.id!==null && e.number!==null && e.number!=0){
                        queryArr.push(self.$axios.get(`/api/person-job/list/skill?id=${e.id}&number=${e.number}&include=false`))
                    }
                })
                self.$axios.all(queryArr).then(self.$axios.spread(function () {
                    let res = [];
                    for (let index = 0; index < arguments.length; index++) {
                        res.push({
                            result : arguments[index],
                            query : self.simulation.table[index]
                        })
                    }
                    self.skillResult.data = res;
                    self.skillResult.activeName = 'skill_'+self.simulation.table[0].id;
                    self.skillResult.visible = true;
                    self.showDetailCard = 'personJob'
                }));
            }
        },
        SimulationRoad(){
            let self  = this;
            const start = self.simulation.form.start;
            const end = self.simulation.form.end;
            let startLocation = '';
            let endLocation = '';
            if(start.type=='search'){
                startLocation = start.value;
            }else{
                const location = self.pointerData.find(e=>e.guid==start.value[0]).records.find(e=>e.guid==start.value[1])
                startLocation = `${location.latitude},${location.longitude}`
            }
            if(end.type=='search'){
                endLocation = end.value;
            }else{
                const location = self.pointerData.find(e=>e.guid==end.value[0]).records.find(e=>e.guid==end.value[1])
                endLocation = `${location.latitude},${location.longitude}`
            }

            if(startLocation == endLocation){
                self.$message({
                    showClose: true,
                    message: '出发地 目的地不可相同',
                    type: 'error'
                });
            }else{
                const item = {
                    start: startLocation,
                    end: endLocation,
                }
                self.Driving(item,true)
            }
        },
        Driving(item,isNavigation){
            const url=`https://apis.map.qq.com/ws/direction/v1/driving/?from=${item.start}&to=${item.end}&output=jsonp&callback=cb&key=${this.key}`
            jsonp(url, null, (err, data) => {
                let coors = data.result.routes[0].polyline, pl = [];
                let kr = 1000000;
                for (let i = 2; i < coors.length; i++) {
                    coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr;
                }
                for (let i = 0; i < coors.length; i += 2) {
                    pl.push(new this.$Map.LatLng(coors[i], coors[i+1]));
                }
                this.CleanMap(isNavigation);
                this.DisplayPolyline(pl);
                let center = new this.$Map.LatLng((item.start.split(",")[0]*1+item.end.split(",")[0]*1)/2,(item.start.split(",")[1]*1+item.end.split(",")[1]*1)/2)
                this.map.panTo(center);
                if(isNavigation){
                    this.DisplayNavigation(data.result.routes[0]);
                }
            })
        },
        DisplayPolyline(pl){
            //创建 MultiPolyline显示折线
            if(this.polylineLayer==null){
                this.polylineLayer = new this.$Map.MultiPolyline({
                    id: 'polyline-layer', //图层唯一标识
                    map: this.map,//绘制到目标地图
                    //折线样式定义
                    styles: {
                        'roadLine': new this.$Map.PolylineStyle({
                            color: 'rgba(86,255,255,1)', //线填充色
                            width: 6, //折线宽度
                            borderWidth: 5, //边线宽度
                            borderColor: 'rgba(86,255,255,.1)', //边线颜色
                            lineCap: 'round', //线端头方式
                            enableBloom:true
                        })
                    },
                    //折线数据定义
                    geometries: [
                        {
                            id: 'roadLine',//折线唯一标识，删除时使用
                            styleId: 'roadLine',//绑定样式名
                            paths: pl
                        }
                    ]
                })
            }else{
                this.polylineLayer.add(
                    {
                        'id': 'roadLine',//折线唯一标识，删除时使用
                        'styleId': 'roadLine',//绑定样式名
                        'paths': pl
                    }
                )
            }
        },
        DisplayNavigation(routes){
            this.$set(this.simulation,'result',routes);
            let zoom = 10;
            let km = routes.distance/1000;
            if(km>0&&km<=10){zoom=16}
            else if(km>10&&km<=20){zoom=12}
            else if(km>20&&km<=30){zoom=10}
            else if(km>30&&km<=40){zoom=8}
            else if(km>40){zoom=4}

            this.showDetailCard = 'driving'
            this.map.setZoom(zoom);
        },
        ChangeSimulationType(field){
            let target = this.simulation.form[field];
            target.value = (target.type=='search' ? '' : [])
        },
        SearchPointStart(val) {
            this.SearchPoint('start',val)
        },
        SearchPointEnd(val) {
            this.SearchPoint('end',val)
        },
        SearchPoint(field,val) {
            let target = this.simulation.form[field];
            if(val!==''){
                target.loading = true;
                this.$jsonp(`https://apis.map.qq.com/ws/place/v1/search`, {
                    boundary:'nearby(34.736104,116.930169,1000,1)',
                    keyword:val,
                    page_size:20,
                    page_index:1,
                    key: this.key,
                    output: 'jsonp'
                }).then(res => {
                    this.simulation.searchResult[field] = res.data.map(e=>{
                        return {
                            ...e,
                            location:`${e.location.lat},${e.location.lng}`
                        }
                    })
                    target.loading = false;
                })
            }else{
                this.simulation.searchResult[field] = [];
            }
        },
        AddPerson(){
            this.simulation.table.push({
                id:null,
                number:null,
            })
        },
        DeletePerson(index){
            this.simulation.table.splice(index,1)
        },
        ZoomMap(){
            this.zoomMap = !this.zoomMap
        },
        SetBaseMap(val){
            let baseMap = null;
            let mapStyleId = null;
            let pitch = null;
            let zoom = this.map.getZoom();
            switch (val) {
                case 'satellite':
                    baseMap = [{ type: "satellite" }];
                    mapStyleId = 'style1';
                    pitch = 0;
                    break;
                case 'vector':
                    baseMap = [ { type: "vector"}];
                    mapStyleId = 'style2';
                    pitch = 50;
                    zoom = 17
                    break;
                case 'traffic':
                    baseMap = [{ type: "satellite" },{type: "traffic",features: ["base", "flow"],opacity: 1 }];
                    mapStyleId = 'style1';
                    pitch = 0;
                    break;
            }
            this.map.setBaseMap(baseMap);
            this.map.setMapStyleId(mapStyleId);
            this.map.setPitch(pitch);
            this.map.setZoom(zoom);
        },
        BackgroundColor(type,div){
            let background = '';
            let color = '';
            if(type=='高速'){background = '#389881';color='#000'}
            if(type=='国道'){background = '#d82126';color='#000'}
            if(type=='省道'){background = '#fbd706';color='#000'}
            if(type=='县道'){background = '#fefefe';color='#000'}
            div=='card'?background+='c9':null;
            return `background:${background};color:${color}`
        },
        TabClick(tab){
            if(tab.label!='快速响应'&&tab.label!='紧急动员'){
                this.showDetailCard=null
            }
        },
        Pointer(){
            let self = this;
            self.$axios.get(`/api/point-option/list?pageSize=999`).then(res => {
               const pointerData =  res.records.filter(e=>e.isShow);
               self.pointerData = pointerData; 
               self.pointerDataHeight = 1110-(70*(pointerData.length+1))+'px';
               pointerData.forEach(e=>{
                    self.$axios.get(`/api/point/list?guid=${e.guid}&pageSize=999`).then(res => {
                        let target = self.pointerData.find(r=>r.guid==e.guid);
                        target.records = res.records
                    })
               })
            })
        },
        GoPointer(point){
            let self = this;
            if(point.latitude&&point.longitude){
                const position = new self.$Map.LatLng(point.latitude,point.longitude);
                setTimeout(()=>{
                    self.map.zoomTo(10);
                },500*0)
                setTimeout(()=>{
                    self.map.panTo(position);
                },500*1)
                setTimeout(()=>{
                    self.map.zoomTo(16);
                    self.InfoWindow(point)
                },500*2)
                setTimeout(()=>{
                    self.map.setCenter(position);
                },500*3)
            }else{
                self.$message.error(`${point.name} 位置信息未录入`);
            }
        },
        ChangePointerDataShow(val){
            let self = this;
            const allGuids = self.pointerData.map(e=>e.guid);
            const hideGuids = allGuids.filter(e=>!val.includes(e));
            hideGuids.forEach(e=>{
                const target = self.pointerDataMap[`pointer_${e}`];
                if(target){
                    target.setVisible(false);
                }
            })
            const showGuids = allGuids.filter(e=>val.includes(e));
            showGuids.forEach(e=>{
                const target = self.pointerDataMap[`pointer_${e}`];
                if(target){
                    target.setVisible(true);
                }else{
                    const aim = self.pointerData.find(r=>r.guid==e);
                    const geometries = aim.records.map(r=>{
                        return {
                            id: `pointer_${aim.guid}_${r.guid}`,
                            position: new self.$Map.LatLng(r.latitude*1,r.longitude*1),
                        }
                    })
                    self.pointerDataMap[`pointer_${aim.guid}`] =  new self.$Map.MultiMarker({
                        id:`pointer_${aim.guid}`,
                        map: self.map,
                        styles: {
                            default: new self.$Map.MarkerStyle({ 
                                width: 64/2,  // 点标记样式宽度（像素）
                                height: 64/2, // 点标记样式高度（像素）
                                // src: 'https://img2.baidu.com/it/u=4075982508,2641645164&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500',
                                src: aim.picture,  //图片路径
                                anchor: { x: 16, y: 32 }  
                            }) 
                        },
                        geometries: geometries
                    }).on("click", self.ClickPointer);
                }
            })
        },
        ClickPointer(e){
            const arr = e.geometry.id.split('_');
            const typeGuid = arr[arr.length-2];
            const pointerGuid = arr[arr.length-1];
            const target = this.pointerData.find(e=>e.guid==typeGuid).records.find(e=>e.guid==pointerGuid);
            this.InfoWindow(target)
        },
        PointDetail(_point){
            let point = JSON.parse(JSON.stringify(_point))
            const detail = JSON.parse(point.detail);
            let detailArr = [];
            if(detail){
                detail.forEach(e=>{
                    if(e.category== "固定值"){
                        detailArr.push({
                            name:e.name,
                            value:e.value,
                        })
                    }else if(e.category=="外部接口"){
                        detailArr.push({
                            name:e.name,
                            value:null,
                        })
                        this.SendRequest(e)
                    }
                })
            }
            point.detailArr = detailArr;
            this.pointDetailInfo = point;
            this.pointDetailInfoShow = true;
        },
        PointDetailInfoHide(){
            this.pointDetailInfoShow = false;
            this.pointDetailInfo = null;
        },
        SendRequest(e){
            this.$axios.get(e.address).then(res => {
                const structure = e.structure.split('.');
                let current = res;
                for (let index = 0; index < structure.length; index++) {
                    const element = structure[index];
                    current = current[element];
                }
                if(current===undefined){
                    current = '数据结构异常'
                }
                this.pointDetailInfo.detailArr.find(r=>r.name==e.name).value=current;
            })
        },
        PointerLabel(type){
            let self = this;
            const aim = self.simulation.form[type];
            let name = "";
            if(aim.type=='select'){
                name = self.pointerData.find(e=>e.guid==aim.value[0]).records.find(e=>e.guid==aim.value[1]).name;
            }else{
                name = self.simulation.searchResult[type].find(e=>e.location==self.simulation.form[type].value).title
            }
            return name;
        }
    },
    mounted(){
        this.GetData();
        // this.imageType?null:this.GetData();
        setTimeout(()=>{
            this.mapShow = true
        },5000)
        setTimeout(()=>{
            this.dataShow = true
        },7000)
    }
}
</script>